import { APP_CONFIG, buildCopyrightText } from "@/config/app-config";

export default {
  common: {
    appName: APP_CONFIG.brand.name,
    appSubtitle: APP_CONFIG.brand.subtitle,
    cancel: "キャンセル",
    confirm: "確認",
    save: "保存",
    delete: "削除",
    edit: "編集",
    view: "表示",
    viewAll: "すべて表示",
    create: "新規作成",
    search: "検索",
    filter: "絞り込み",
    refresh: "更新",
    retry: "再試行",
    back: "戻る",
    submit: "送信",
    close: "閉じる",
    details: "詳細",
    done: "完了",
    copy: "コピー",
    success: "処理が完了しました",
    failed: "処理に失敗しました",
    required: "必須",
    optional: "任意",
    enabled: "有効",
    disabled: "無効",
    switchLanguage: "言語を切り替え",
    dialog: "ダイアログ",
    globalLoading: "読み込み中...",
    loading: "読み込み中...",
    saving: "保存中…",
    resourceLoadingDescription:
      "アプリケーションのリソースを読み込んでいます...",
    import: "インポート",
    export: "エクスポート",
    actions: "操作",
    noData: "データはありません",
    yes: "はい",
    no: "いいえ",
  },
  toast: {
    viewportLabel: "通知",
  },
  auth: {
    brandAria: "ログインページへ戻る",
    terms: "利用規約",
    privacy: "プライバシーポリシー",
    copyright: buildCopyrightText(),
    loginFailed: "ログインに失敗しました",
    mfaFailed: "MFA 認証に失敗しました",
    verificationFailed:
      "認証コードが正しくありません。もう一度お試しください。",
    passkeyVerifying: "確認中...",
    passkeyLogin: "Passkey でログイン",
    or: "または",
    mfaPrompt:
      "{email} は MFA が有効です。6 桁の認証コードを入力してください。",
    mfaCode: "ワンタイム認証コード",
    verifyAndSignIn: "認証してログイン",
    previousStep: "前に戻る",
    tenantIdentifier: "テナント識別子",
    tenantIdPlaceholder: "テナント ID",
    email: "メールアドレス",
    password: "パスワード",
    signingIn: "ログイン中...",
    signIn: "ログイン",
    forgotPassword: "パスワードをお忘れですか",
    trialQuestion: "プラットフォームを試しますか？",
    applyTrial: "トライアルを申請",
    enterEmailFirst: "先にメールアドレスを入力してください。",
    passkeyUnsupportedOrigin:
      "現在のアクセス元はサポートされていません。http://localhost:6277 からログインしてください。",
    passkeyRpMismatch:
      "Passkey のドメインが一致しません。http://localhost:6277 からログインしてください。",
    passkeyNotBound:
      "このメールアドレスには Passkey が登録されていません。設定で登録するか、パスワードでログインしてください。",
    passkeyFailed:
      "Passkey ログインに失敗しました。再試行するか、パスワードでログインしてください。",
    mfaInvalid:
      "認証コードが正しくありません。確認してもう一度お試しください。",
    mfaInvalidDetailed:
      "認証コードが正しくありません。認証アプリの 6 桁の数字を確認してください。",
    sessionExpired:
      "セッションの有効期限が切れました。再度ログインしてください。",
    sessionRevoked:
      "別のデバイスでログインされたため、このセッションは無効になりました。再度ログインしてください。",
    ssoContinueWith: "{provider} でログイン",
    tenantRequired: "先にテナント識別子を入力してください",
    ssoErrors: {
      SSO_LOGIN_FAILED:
        "エンタープライズ SSO ログインに失敗しました。再試行するか管理者に連絡してください。",
      SSO_USER_NOT_PROVISIONED:
        "このアカウントはまだプラットフォームに登録されていません。",
      SSO_MFA_SESSION_EXPIRED:
        "SSO 検証セッションの有効期限が切れました。再度ログインしてください。",
      LOGIN_IP_NOT_ALLOWED:
        "この IP アドレスからのログインは許可されていません。",
      PASSWORD_LOGIN_DISABLED: "このテナントではパスワードログインが無効です。",
      ENTERPRISE_MFA_REQUIRED:
        "テナントポリシーで MFA が必須です。設定で有効化してください。",
      OIDC_STATE_EXPIRED:
        "SSO 状態の有効期限が切れました。再度ログインしてください。",
    },
    forgot: {
      title: "パスワード再設定",
      description:
        "アカウントのメールアドレスを入力してください。30 分間有効なパスワード再設定リンクを送信します。",
      sent: "該当するアカウントが存在する場合、再設定メールを送信しました。受信トレイと迷惑メールフォルダを確認してください。",
      tenantLabel: "テナント ID",
      optional: "任意",
      tenantPlaceholder: "同じメールが複数テナントに属する場合のみ入力",
      sendResetEmail: "再設定メールを送信",
      submitting: "送信中...",
      backToSignIn: "ログインへ戻る",
      submitFailed: "送信に失敗しました",
    },
    reset: {
      title: "新しいパスワードを設定",
      description:
        "新しいログインパスワードを設定してください。このリンクとトークンは 30 分後に失効します。",
      done: "パスワードを更新しました。以前のログインセッションはすべて取り消されています。新しいパスワードで再度ログインしてください。",
      goToSignIn: "ログインへ進む",
      token: "再設定トークン",
      newPassword: "新しいパスワード",
      confirmPassword: "パスワード確認",
      updating: "更新中...",
      updatePassword: "パスワードを更新",
      mismatch: "2 回入力したパスワードが一致しません。",
      failed: "パスワード再設定に失敗しました",
    },
    invitation: {
      title: "アカウント招待を承諾",
      done: "アカウントを作成しました。メールアドレスと新しいパスワードでログインできます。",
      token: "招待トークン",
      name: "名前",
      setPassword: "パスワードを設定",
      joinTenant: "テナントに参加",
      acceptFailed: "招待の承諾に失敗しました",
      validation: {
        tokenRequired: "招待トークンを入力してください。",
        passwordMin: "パスワードは 8 文字以上で入力してください。",
      },
    },
  },
  personalAuth: {
    registerTitle: "個人アカウント登録",
    registerDescription:
      "メールアドレスで個人用テナントとワークスペースを作成します。",
    displayName: "表示名",
    displayNamePlaceholder: "例：山田 太郎",
    registerSubmit: "登録する",
    registerSubmitting: "登録中…",
    registerFailed: "登録に失敗しました",
    emailAlreadyRegistered:
      "このメールアドレスは既に登録されています。ログインしてください。",
    haveAccount: "すでにアカウントをお持ちですか？",
    googleRegister: "Google で登録 / ログイン",
    googleLogin: "Google でログイン",
    googleUnavailableTitle: "Google ではログインできません",
    googleUnavailableDescription: "この Google アカウントはまだ登録されていません。アカウントは運営が開設するか、トライアル申請が承認された後にご利用ください。",
    googleUnavailableGeneric: "Google ログインを完了できませんでした。時間をおいて再度お試しください。",
    backHome: "ホームへ戻る",
    verifyPendingTitle: "メール認証を完了してください",
    verifyPendingDescription:
      "登録メールに記載されたリンクをクリックして認証を完了してください。",
    verifySentTo: "認証メールの送信先：{email}",
    verifySuccessTitle: "メール認証が完了しました",
    verifySuccessDescription: "ログインしてサービスをご利用ください。",
    verifySuccessNotice:
      "メールアドレスの認証が完了しました。ログイン後すぐに利用を開始できます。",
    verifyAlreadyTitle: "すでに認証済みです",
    verifyAlreadyDescription: "このメールアドレスは既に認証されています。",
    verifyAlreadyNotice: "追加の操作は不要です。ログインしてご利用ください。",
    verifyExpiredTitle: "認証リンクが無効です",
    verifyExpiredDescription:
      "リンクの有効期限が切れたか無効です。認証メールを再送してください。",
    verifyExpiredNotice:
      "新しい認証メールを再送して、メール内のリンクから再度お試しください。",
    resendVerification: "認証メールを再送",
    resendAccepted: "認証メールを送信しました。受信トレイをご確認ください。",
    resendFailed: "認証メールの送信に失敗しました",
    emailNotVerified: "未認証",
    homeTitle: "個人ホーム",
    homeLoadFailed: "個人ホームの読み込みに失敗しました",
    workspaceType: "ワークスペース種別",
    entityType: "事業形態",
    currency: "通貨",
    fiscalYear: "会計年度開始日",
    googleLinkRequired:
      "同じメールの既存アカウントがあります。ログイン後に Google を連携してください。",
    welcomeTitle: "ようこそ、{name} さん",
    welcomeDescription:
      "個人用ワークスペースの準備が完了しました。ダッシュボードから会計業務を始められます。",
    verifyPendingInline: "一部の機能はメール認証完了後にご利用いただけます。",
    setupCompleteTitle: "アカウントの準備状況",
    setupCompleteDescription: "個人事業向けの初期設定が完了しています。",
    accountEmail: "メールアドレス",
    workspaceName: "ワークスペース",
    entityTypeSoleProprietor: "個人事業主",
    fiscalYearValue: "{month}月{day}日開始 · {currency}",
    nextStepsTitle: "次のステップ",
    nextStepsDescription:
      "まずはダッシュボードで全体像を確認するか、プロフィール設定を行ってください。",
    goToDashboard: "ダッシュボードへ",
    openSettings: "設定を開く",
    viewWorkspace: "ワークスペースを確認",
    uploadDocuments: "書類アップロード",
  },
  personalLineIntegration: {
    title: "LINE連携",
    description: "LINE公式アカウントと個人アカウントを連携します。",
    notLinked:
      "LINEアカウントはまだ連携されていません。\n\nLINE公式アカウントを友だち追加し、トーク画面で「連携」と送信してください。",
    loadFailed: "LINE連携状態の読み込みに失敗しました",
    actionFailed: "LINE連携の更新に失敗しました",
    platformTitle: "公式アカウント",
    platformAvailable: "利用可能",
    platformUnavailable: "利用できません",
    addFriend: "友だち追加",
    bindingsTitle: "連携済みワークスペース",
    defaultBadge: "既定の受信先",
    imageIntakeOn: "画像受信オン",
    imageIntakeOff: "画像受信オフ",
    linkedAt: "連携日時 {value}",
    noDefaultWarning:
      "受信先が選択されていません。LINEから書類を送信する前に、既定のワークスペースを選択してください。",
    setDefaultButton: "既定の受信先に設定",
    unlinkWorkspaceButton: "このワークスペースとの連携を解除",
    unlinkAllButton: "すべてのLINE連携を解除",
    unlinkAllConfirmTitle: "すべてのLINE連携を解除",
    unlinkAllConfirmDescription:
      "現在のアカウントに紐づくすべてのLINEワークスペース連携を解除します。",
    selectWorkspaceTitle: "LINEを連携するワークスペースを選択してください",
    selectWorkspaceDescription:
      "このLINEアカウントを連携するワークスペースを選択します。",
    noBindableWorkspace: "LINE連携できるワークスペースがありません。",
    alreadyLinked: "連携済み",
    resultSuccessTitle: "LINE連携が完了しました",
    resultSuccessDescription: "LINEアプリに戻ってください。",
    resultFailedTitle: "LINE連携を完了できませんでした",
    resultFailedDescription:
      "もう一度LINEのトーク画面から連携を開始してください。",
    resultPendingTitle: "連携を確認しています",
    resultPendingDescription: "しばらくしてから再度お試しください。",
  },
  workspaceLineIntegration: {
    title: "Workspace LINE連携",
    description: "このワークスペースでLINEからの書類受信を有効にします。",
    platformTitle: "公式アカウント",
    platformAvailable: "利用可能",
    platformUnavailable: "利用できません",
    addFriend: "友だち追加",
    integrationTitle: "ワークスペース連携",
    statusActive: "有効",
    statusDisabled: "無効",
    statusNotEnabled: "未設定",
    imageIntakeOn: "画像受信オン",
    imageIntakeOff: "画像受信オフ",
    enableButton: "LINE連携を有効にする",
    disableButton: "LINE連携を無効にする",
    enableImageButton: "画像受信を有効にする",
    disableImageButton: "画像受信を無効にする",
    myBindingTitle: "自分のLINE連携",
    bound: "このワークスペースにLINEを連携済みです。",
    notBound: "このワークスペースにはまだLINEを連携していません。",
    boundAccountFallback: "LINEアカウント {value}",
    boundAccountUnknown: "連携済みのLINEアカウント",
    lineAccountId: "アカウント識別子：{value}",
    linkedAt: "連携日時：{value}",
    defaultBadge: "既定の受信先",
    setDefaultButton: "既定の受信先に設定",
    unlinkButton: "このワークスペースとの連携を解除",
    linkStepsTitle: "連携手順",
    linkStepAddFriend: "下記から LINE 公式アカウントを友だち追加してください。",
    linkStepSendCommand: "LINE の 1:1 トークで「連携」と送信してください。",
    linkStepOpenLink:
      "Bot から届く「連携する」ボタンを押し、本システムにログインしてこのワークスペースを選択してください。",
    linkStepConfirm:
      "LINE で Account Link を完了したら、この画面に戻って連携状態を確認してください。",
    manageBindingsButton: "LINE 連携をすべて管理",
    accountBindingsTitle: "アカウントの LINE 連携一覧",
    accountBindingsDescription:
      "LINE アカウントと各ワークスペースの連携状態です。既定の受信先の変更や解除もここで行えます。",
    currentWorkspaceBadge: "このワークスペース",
    inviteTitle: "提出者を招待して連携",
    inviteDescription:
      "Web アカウントのない LINE ユーザーが、このワークスペースに連携して書類を送信できる 6 桁の招待コードを発行します。",
    generateInviteButton: "招待コードを発行",
    inviteCodeLabel: "招待コード",
    inviteExpiresAt: "有効期限: {value}",
    inviteInstructions:
      "提出者に、Bot との 1:1 トークで上記 6 桁の数字（または「BIND 数字」）を送信するよう案内してください。",
    copyInviteCode: "コードをコピー",
    copiedInviteCode: "コピーしました",
    revokeInviteCode: "コードを無効化",
    submittersTitle: "連携済み提出者",
    submittersEmpty: "招待コードで連携した LINE 提出者はまだいません。",
    unlinkSubmitter: "連携解除",
    loadFailed: "ワークスペースのLINE連携状態の読み込みに失敗しました",
    actionFailed: "ワークスペースのLINE連携更新に失敗しました",
  },
  personalDocuments: {
    uploadTitle: "書類アップロード",
    uploadDescription: "領収書や請求書を PDF / 画像でアップロードします。",
    listTitle: "書類一覧",
    listDescription: "アップロード済みの書類と処理状況を確認できます。",
    selectFileTitle: "ファイルを選択",
    allowedFormats: "PDF・JPEG・PNG（最大 {maxMb} MB）",
    dropzone: "クリックしてファイルを選択、またはドラッグ＆ドロップ",
    uploadButton: "アップロード",
    uploading: "アップロード中…",
    uploadSuccess: "アップロードが完了しました。",
    uploadFailed: "アップロードに失敗しました",
    fileTooLarge: "ファイルサイズが {maxMb} MB を超えています",
    viewList: "書類一覧を見る",
    nextPhaseNotice: "文字認識と仕訳候補の作成は次の開発段階で対応します。",
    empty: "アップロード済みの書類はありません。",
    download: "ダウンロード",
    delete: "削除",
    loadFailed: "書類一覧の読み込みに失敗しました",
    downloadFailed: "ダウンロードに失敗しました",
    deleteFailed: "削除に失敗しました",
    workspaceRequired: "アップロード前にワークスペースを選択してください。",
    viewDetail: "詳細",
    detailTitle: "書類詳細",
    detailDescription: "文字認識と仕訳候補の確認",
    processingStatus: "処理状況",
    failureCode: "エラーコード",
    ocrResult: "OCR結果",
    pageCount: "ページ数",
    detectedLanguages: "検出言語",
    candidateTitle: "仕訳候補",
    candidateDisclaimer:
      "AIによる候補です。会計データにはまだ反映されていません。",
    warnings: "警告",
    retryProcessing: "処理を再試行",
    retryFailed: "再試行に失敗しました",
    openReview: "内容確認を開く",
    review: {
      title: "内容確認",
      description: "原本を確認し、仕訳候補を修正してください。",
      aiDisclaimer: "AIによる候補です。原本を確認して修正してください。",
      previewTitle: "確証プレビュー",
      showOriginal: "確証を表示",
      formTitle: "入力内容",
      documentNumber: "確証番号",
      memo: "摘要",
      linesTitle: "借方・貸方",
      debit: "借方",
      credit: "貸方",
      selectAccount: "勘定科目を選択",
      addLine: "行を追加",
      clearAll: "候補をすべてクリア",
      totals: "合計",
      unbalanced: "借方と貸方が一致していません",
      save: "保存",
      confirm: "内容を確定",
      confirmTitle: "内容確認の確定",
      confirmDescription: "入力内容を確定し、仕訳下書きを作成します。",
      openDraft: "仕訳下書きを開く",
      loadFailed: "内容確認の読み込みに失敗しました",
      saveFailed: "保存に失敗しました",
      confirmFailed: "確定に失敗しました",
      saveState: {
        idle: "未保存",
        saving: "保存中",
        saved: "保存済み",
        failed: "保存に失敗しました",
        conflict:
          "他の画面で内容が更新されました。最新の内容を読み込んでから、もう一度保存してください。",
      },
      steps: {
        document: "書類",
        ocr: "認識結果",
        review: "内容確認",
        draft: "仕訳下書き",
        approval: "承認",
        posting: "転記",
      },
    },
    field: {
      documentType: "書類種別",
      documentDate: "日付",
      counterparty: "取引先",
      totalAmount: "合計金額",
      taxAmount: "税額",
      confidence: "信頼度",
    },
    processingStage: {
      OCR_QUEUED: "文字認識待ち",
      OCR_PROCESSING: "文字認識中",
      OCR_COMPLETED: "文字認識完了",
      AI_EXTRACTION_QUEUED: "仕訳候補作成待ち",
      AI_EXTRACTING: "仕訳候補を作成中",
      REVIEW_REQUIRED: "確認待ち",
      PROCESSING_FAILED: "処理失敗",
    },
    status: {
      UPLOADED: "アップロード中",
      SECURITY_SCANNING: "アップロード中",
      STORED: "保存済み",
      SECURITY_REJECTED: "失敗",
      QUEUED_FOR_PARSING: "処理待ち",
      PARSING: "処理待ち",
      PARSED: "処理待ち",
      NEEDS_REVIEW: "確認待ち",
      OCR_QUEUED: "文字認識待ち",
      OCR_PROCESSING: "文字認識中",
      OCR_COMPLETED: "文字認識完了",
      AI_EXTRACTION_QUEUED: "仕訳候補作成待ち",
      AI_EXTRACTING: "仕訳候補を作成中",
      PROCESSING_FAILED: "処理失敗",
      PROCESSING_CANCELLED: "取消済み",
      ARCHIVED: "削除済み",
    },
  },
  legalPage: {
    effectiveDate: "発効日：{date}",
  },
  trial: {
    title: "トライアルを申請",
    description:
      "企業情報を送信し、メール認証を完了してください。承認後、管理者アカウントの招待メールが届きます。",
    submittedTitle: "申請を送信しました",
    submittedDescription:
      "運用担当者の審査後、メールで結果をお知らせします。受信トレイをご確認ください。",
    organizationName: "企業・組織名",
    organizationPlaceholder: "企業・組織名を入力",
    contactName: "担当者名",
    contactPlaceholder: "担当者名を入力",
    workEmail: "勤務先メールアドレス",
    emailVerified: "認証済み",
    resendAfter: "{seconds}s 後に再送",
    sendingCode: "送信中",
    sendCode: "認証コードを送信",
    verificationCode: "メール認証コード",
    codePlaceholder: "6 桁の認証コードを入力",
    verifying: "認証中",
    confirmEmail: "メールを認証",
    phone: "電話番号",
    phonePlaceholder: "電話番号を入力",
    countryRegion: "国または地域",
    countryPlaceholder: "例：日本",
    expectedMonthlyUnits: "月間想定利用量",
    useCase: "利用シーン",
    useCasePlaceholder: "例：毎月の仕入先請求書から金額、日付、会社情報を抽出",
    notes: "補足事項",
    notesPlaceholder: "文書種類、言語、導入希望時期などを入力できます",
    agreementPrefix: "",
    agreementConnector: "および",
    agreementSuffix: "に同意します。",
    submitting: "送信中...",
    submit: "トライアル申請を送信",
    invalidEmail: "有効なメールアドレスを入力してください。",
    codeSent: "認証コードを送信しました。メールをご確認ください。",
    codeSendFailed: "認証コードの送信に失敗しました",
    invalidCode: "6 桁の認証コードを入力してください。",
    emailVerifiedToast: "メール認証が完了しました",
    codeVerifyFailed: "認証コードの確認に失敗しました",
    submitFailed: "送信に失敗しました。しばらくしてから再度お試しください。",
    validation: {
      organizationName: "企業・組織名を入力してください。",
      organizationNameTooLong:
        "企業・組織名は {max} 文字以内で入力してください。",
      contactName: "担当者名を入力してください。",
      contactNameTooLong: "担当者名は {max} 文字以内で入力してください。",
      phone: "有効な電話番号を入力してください。",
      phoneTooLong: "電話番号は {max} 文字以内で入力してください。",
      countryRegion: "国または地域を入力してください。",
      countryRegionTooLong: "国または地域は {max} 文字以内で入力してください。",
      useCase: "利用シーンを 10 文字以上で入力してください。",
      useCaseTooLong: "利用シーンは {max} 文字以内で入力してください。",
      expectedMonthlyUnits: "月間想定利用量は 0 より大きい値にしてください。",
      expectedMonthlyUnitsInteger: "月間想定利用量は整数で入力してください。",
      expectedMonthlyUnitsTooLarge:
        "月間想定利用量は {max} 以下にしてください。",
      notesTooLong: "補足事項は {max} 文字以内で入力してください。",
      termsAccepted:
        "サービス利用規約とプライバシーポリシーに同意してください。",
      verificationToken: "送信前にメール認証を完了してください。",
    },
  },
  navigation: {
    operatorConsole: "運用コンソール",
    tenantConsole: "テナント画面へ戻る",
    operationManagement: "運用管理",
  },
  impersonation: {
    bannerTitle: "代運営中",
    bannerDescription: "テナント管理者権限で「{tenant}」を管理中です",
    exitToOperator: "運用コンソールに戻る",
    exitSuccess: "代運営を終了しました",
    exitFailed: "代運営の終了に失敗しました",
  },
  userMenu: {
    accountSettings: "個人設定",
    feedback: "自分のフィードバック",
    signOut: "ログアウト",
  },
  sidebar: {
    sendFeedback: "フィードバックを送信",
  },
  tenantShell: {
    menuSearchPlaceholder: "メニューを検索",
    menuNoResults: "一致するメニューはありません",
    collapseSidebar: "サイドバーを折りたたむ",
    expandSidebar: "サイドバーを展開",
    breadcrumb: "現在位置",
    back: "戻る",
    refresh: "現在のページを更新",
    home: "ホームへ戻る",
    fullscreen: "全画面表示",
    exitFullscreen: "全画面を終了",
    openedPages: "開いているページ",
    closeTab: "{label} を閉じる",
    closeCurrentTab: "現在を閉じる",
    closeOtherTabs: "他を閉じる",
    closeAllTabs: "すべて閉じる",
  },
  placeholders: {
    clickToCopy: "置換タグをクリックしてコピー",
    custom: "カスタム",
    example: "例: {example}",
    copiedToken: "{token} をコピーしました",
    copyFailedManual: "コピーに失敗しました。手動でコピーしてください。",
  },
  dataTableCell: {
    copiedToClipboard: "クリップボードにコピーしました",
    copyFailed: "コピーに失敗しました",
  },
  menu: {
    systemSettings: { label: "システム設定" },
    personalSettings: {
      label: "個人設定",
      subtitle: "個人アカウントとセキュリティ",
    },
    sections: {
      documents: "確証",
      banking: "銀行",
      arAp: "債権債務",
      accounting: "会計",
      reports: "報告・出力",
    },
    dashboard: {
      label: "ダッシュボード",
      subtitle: "ワークスペースのKPIと要対応",
    },
    workspace: {
      label: "ワークスペース",
      subtitle: "会計データ空間とメンバー境界",
    },
    documentIntake: {
      label: "伝票受信",
      subtitle: "領収書・請求書の受付と AI 解析確認",
    },
    documentSummary: {
      label: "伝票集計",
      subtitle: "処理完了伝票の財務集計・絞り込み・出力",
    },
    reviewInbox: {
      label: "レビュー受信箱",
      subtitle: "対応待ちの仕訳ドラフトレビュー",
    },
    accountingBooks: {
      label: "帳簿設定",
      subtitle: "ワークスペースの会計帳簿・会計期間を管理",
    },
    chartOfAccounts: {
      label: "勘定科目",
      subtitle: "有効な会計帳簿の勘定科目を管理",
    },
    ledger: {
      label: "元帳",
      subtitle: "有効な会計帳簿の転記済み仕訳元帳",
    },
    financialReports: {
      label: "財務レポート",
      subtitle: "試算表・貸借対照表・損益の投影",
    },
    accountingExports: {
      label: "会計データ出力",
      subtitle: "仕訳データの汎用CSVエクスポート",
    },
    bankAccounts: {
      label: "口座設定",
      subtitle: "銀行口座の登録と GL 科目マッピング",
    },
    bankImport: {
      label: "銀行明細インポート",
      subtitle: "銀行明細のアップロードとバッチ確認",
    },
    bankMatching: {
      label: "銀行明細照合",
      subtitle: "銀行明細行の候補照合と確定",
    },
    bankEvidence: {
      label: "銀行明細×伝票照合",
      subtitle: "出金明細と確認済み伝票セグメントの照合",
    },
    bankReconciliation: {
      label: "期間照合",
      subtitle: "銀行明細と業務取引を期間単位で確認",
    },
    bankGlMappings: {
      label: "銀行口座 会計設定",
      subtitle: "銀行口座と GL 勘定科目のマッピングを設定します",
    },
    arApReceivables: {
      label: "売掛金",
      subtitle: "売掛義務（運用オープンアイテム）",
    },
    arApPayables: {
      label: "買掛金",
      subtitle: "買掛義務（運用オープンアイテム）",
    },
    arApPayments: {
      label: "入出金",
      subtitle: "入金・出金",
    },
    openingArAp: {
      label: "期首売掛買掛",
      subtitle: "期首の未消込残高を取り込む",
    },
    japaneseFinancialStatements: {
      label: "日本式財務諸表",
      subtitle: "レポートスナップショットからの日本式列示",
    },
    webhooks: {
      label: "Webhook",
      subtitle: "イベント通知と外部連携",
    },
    team: {
      label: "権限管理",
      subtitle: "メニュー権限とメンバー",
    },
    organizationHealth: {
      label: "企業管理",
      subtitle: "企業情報・事業所・部署",
    },
    employeeManagement: {
      label: "従業員管理",
      subtitle: "従業員・退職者・タグ",
    },
    billing: {
      label: "プラン・請求",
      subtitle: "プラン、利用枠、請求",
    },
    settings: {
      label: "設定",
      subtitle: "アカウントとセキュリティ",
    },
    personalLineIntegration: {
      label: "LINE 連携",
      subtitle: "LINE アカウントの連携と受信ワークスペース管理",
    },
    feedback: {
      label: "自分のフィードバック",
      subtitle: "フィードバック履歴と返信を確認",
    },
    notifications: {
      label: "通知センター",
      subtitle: "アプリ内通知と更新",
    },
  },
  workspace: {
    switcher: { placeholder: "ワークスペースを選択" },
    accessSource: {
      DIRECT: "直接メンバー",
      FIRM_ENGAGEMENT: "事務所権限",
      FIRM_ASSIGNMENT: "事務所割当",
      firmEngagement: "事務所権限",
    },
    actions: {
      createPersonal: "個人ワークスペースを作成",
      createFirm: "ワークスペースを作成",
      lineIntegration: "LINE 連携",
    },
    line: {
      unavailable: "LINE連携は現在利用できません",
    },
    form: {
      name: "ワークスペース名",
      personalPlaceholder: "例：個人帳簿",
      firmPlaceholder: "例：東京税理士事務所",
      defaults:
        "初期版では Asia/Tokyo、ja-JP、JPY、会計年度開始日は 1 月 1 日です。",
    },
    page: {
      title: "ワークスペース",
      description:
        "Workspace は確証、銀行明細、会計ドラフト、レビュー、エクスポートの操作境界です。",
      noAccess:
        "現在のワークスペースにアクセスできません。別のワークスペースを選択するか管理者に連絡してください。",
      emptyTitle: "アクセス可能なワークスペースがありません",
      emptyDescription:
        "会計データを処理するには、少なくとも 1 つの Workspace に参加している必要があります。",
    },
    table: {
      name: "名称",
      type: "種類",
      status: "状態",
      roles: "ロール",
      actions: "操作",
    },
    type: {
      PERSONAL: "個人",
      FIRM_INTERNAL: "税理士事務所",
      CLIENT_COMPANY: "顧問先企業",
    },
    status: { ACTIVE: "有効", SUSPENDED: "停止", ARCHIVED: "アーカイブ" },
    role: {
      PERSONAL_OWNER: "個人所有者",
      FIRM_OWNER: "事務所所有者",
      FIRM_ADMIN: "事務所管理者",
      ACCOUNTANT: "税理士担当",
      REVIEWER: "レビュー担当",
      ASSISTANT: "アシスタント",
      COMPANY_OWNER: "企業所有者",
      COMPANY_ADMIN: "企業管理者",
      COMPANY_MEMBER: "企業メンバー",
      COMPANY_VIEWER: "企業閲覧者",
    },
  },
  chartOfAccounts: {
    title: "勘定科目",
    subtitle: "有効な会計帳簿の勘定科目を管理します。",
    emptyNoBook: {
      title: "有効な会計帳簿がありません",
      description: "科目を管理する前に、帳簿設定で会計帳簿を作成してください。",
      openSettings: "帳簿設定を開く",
    },
    conflict: {
      title: "複数の有効な帳簿があります",
      description:
        "科目を管理する前に、帳簿設定で有効な帳簿を1つにしてください。",
      openSettings: "帳簿設定を開く",
    },
    actions: {
      createAccount: "科目を追加",
      edit: "編集",
      archive: "アーカイブ",
      initialize: "初期化",
    },
    initialize: {
      confirmDescription:
        "不足しているデフォルト勘定科目のみを追加します。既存の科目のコード・名称は変更しません。",
    },
    fields: {
      code: "コード",
      name: "名称",
      accountType: "Type",
      normalBalance: "貸借",
      status: "状態",
    },
    errors: {
      loadFailed: "勘定科目の読み込みに失敗しました。",
      bookAccessRequired:
        "勘定科目を管理するには、有効な帳簿を読み込むための帳簿設定アクセス権限が必要です。",
      initializeFailed: "勘定科目の初期化に失敗しました。",
    },
  },
  accountingBookSettings: {
    title: "帳簿設定",
    subtitle: "ワークスペースの有効な会計帳簿と会計期間を管理します。",
    tabs: {
      summary: "概要",
      accounts: "勘定科目",
      periods: "会計期間",
    },
    empty: {
      title: "有効な会計帳簿がありません",
      description: "会計ドラフトや元帳を使う前に帳簿を作成してください。",
      create: "帳簿を作成",
    },
    conflict: {
      title: "複数の有効な帳簿があります",
      description:
        "会計期間の管理を続けるには、有効な帳簿を1つだけ残すようアーカイブしてください。",
      archive: "アーカイブ",
    },
    history: {
      title: "過去の帳簿",
    },
    actions: {
      edit: "編集",
      archive: "アーカイブ",
      createAccount: "科目を追加",
      initializePeriods: "年度を初期化",
    },
    fields: {
      name: "名称",
      accountingBasis: "記帳基礎",
      fiscalYearStart: "会計年度開始",
      defaultTaxTreatment: "既定税区分",
      currency: "通貨",
      status: "状態",
      fiscalYear: "会計年度",
    },
    errors: {
      loadFailed: "帳簿の読み込みに失敗しました。",
      createFailed: "帳簿の作成に失敗しました。",
      updateFailed: "帳簿の更新に失敗しました。",
      archiveFailed: "帳簿のアーカイブに失敗しました。",
      accountCreateFailed: "科目の作成に失敗しました。",
      accountUpdateFailed: "科目の更新に失敗しました。",
      accountArchiveFailed: "科目のアーカイブに失敗しました。",
      periodInitFailed: "会計期間の初期化に失敗しました。",
    },
  },
  documents: {
    transaction: {
      field: {},
      type: {
        EXPENSE: "経費",
        PURCHASE: "仕入",
        SALE: "売上",
        INCOME: "収入",
        PAYMENT: "支払",
        RECEIPT: "入金",
        TRANSFER: "振替",
        REFUND: "返金",
        UNKNOWN: "不明",
      },
      status: {
        DRAFT: "ドラフト",
        REVIEW_REQUIRED: "確認待ち",
        CONFIRMED: "確認済み",
        REJECTED: "却下済み",
        SUPERSEDED: "新しいドラフトで置換済み",
        CANCELLED: "キャンセル済み",
      },
      validation: {},
      warning: {
        TRANSACTION_DATE_FUTURE_EXTREME:
          "取引日が対応範囲から大きく外れています。",
        TRANSACTION_DATE_PRECISION_UNSUPPORTED:
          "日付精度が不足しているため自動補完できません。",
      },
    },
    accounting: {
      posted: "転記済み",
      book: {
        defaultName: "標準会計帳簿",
        openSettings: "帳簿設定へ",
      },
      classification: {
        status: {
          SUGGESTED: "提案済み",
          REVIEW_REQUIRED: "確認待ち",
          CONFIRMED: "確認済み",
          REJECTED: "却下済み",
          SUPERSEDED: "差替済み",
          CANCELLED: "取消済み",
        },
      },
      journal: {
        status: {
          DRAFT: "草稿",
          REVIEW_REQUIRED: "確認待ち",
          CONFIRMED: "草稿確認済み",
          REJECTED: "却下済み",
          SUPERSEDED: "差替済み",
          CANCELLED: "取消済み",
        },
      },
      validation: {
        VALID: "貸借一致",
        WARNING: "警告あり",
        INVALID: "確認不可",
      },
      tax: {
        DISPLAYED_TAX_10: "表示税率 10%",
        DISPLAYED_REDUCED_TAX_8: "表示税率 8%",
        DISPLAYED_EXEMPT: "表示免税",
        DISPLAYED_MIXED: "表示混在",
        UNKNOWN: "税務提案不明",
      },
      period: {
        range: "{start} 〜 {end}",
        status: {
          OPEN: "開放",
          SOFT_LOCKED: "ソフトロック",
          CLOSED: "締切済み",
        },
      },
      posting: {
        title: "転記",
        request: "転記申請",
        processingHint: "転記リクエストはキューに入り、処理中です。",
        status: {
          NOT_REQUESTED: "未申請",
          QUEUED: "キュー待ち",
          PROCESSING: "処理中",
          SUCCEEDED: "転記済み",
          RETRYABLE_FAILED: "失敗（再試行可）",
          PERMANENTLY_FAILED: "恒久的失敗",
          CANCELLED: "取消済み",
        },
      },
      postedJournal: {
        title: "Posted Journal",
      },
      reversal: {
        title: "取消仕訳",
        create: "取消申請を作成",
        submit: "レビュー提出",
        reversalDate: "取消日",
        reasonCode: "理由コード",
        reasonText: "取消理由",
        displayStatus: {
          none: "未取消",
          pending: "取消処理中",
          posted: "取消済み",
        },
        status: {},
      },
      amendment: {
        displayStatus: {},
        types: {},
        status: {},
      },
    },
    ledger: {
      title: "総勘定元帳",
      backToDocuments: "書類一覧へ戻る",
      financialReports: "財務レポート",
      accountFilter: "勘定科目",
      allAccounts: "全科目",
      dateRange: "日付範囲",
      journalNumber: "仕訳番号",
      search: "検索",
      empty: "元帳明細はまだありません。",
      noPermission: "このワークスペースで元帳閲覧権限がありません。",
      columns: {
        date: "日付",
        journal: "仕訳",
        account: "科目",
        side: "借貸",
        amount: "金額",
      },
      journalType: {
        STANDARD: "標準",
        REVERSAL: "取消",
        AMENDMENT: "訂正",
      },
      reversesJournal: "{value} を取消",
      reversedByJournal: "{value} により取消",
      amendsJournal: "{value} を訂正",
      amendedByJournal: "{value} により訂正",
      periodClose: {
        period: "会計期間",
        summaryTitle: "期間サマリー",
        title: "期間締め",
        ledgerEntryCount: "総勘定元帳件数",
        postedJournalCount: "転記済み仕訳数",
        totalDebit: "借方合計",
        totalCredit: "貸方合計",
        softLock: "期間をソフトロック",
        create: "締め申請を作成",
        validate: "検証を実行",
        submit: "レビューに提出",
        cancel: "申請を取消",
        checksTitle: "締め検証項目",
        snapshotTitle: "元帳スナップショット",
        snapshotGeneratedAt: "生成日時 {value}",
        openingBalanceWarning:
          "この期間の期首残高が未生成です。前期間の締め処理後に繰越を完了してから期間締めを行ってください。",
        summaryNone: "締め申請はまだ作成されていません。",
        summaryClosed: "この期間は既に締め済みです。",
        summarySoftLockRequired:
          "締め申請の前に期間をソフトロックしてください。",
        status: {
          DRAFT: "下書き",
          VALIDATING: "検証中",
          VALIDATION_FAILED: "検証失敗",
          REVIEW_REQUIRED: "レビュー待ち",
          APPROVED: "承認済み",
          CLOSING: "締め処理中",
          CLOSED: "締め済み",
          REJECTED: "却下",
          CANCELLED: "取消",
          SUPERSEDED: "置換済み",
          FAILED: "失敗",
        },
        checkStatus: {
          PASSED: "合格",
          WARNING: "警告",
          FAILED: "不合格",
          NOT_APPLICABLE: "対象外",
        },
        snapshotColumns: {
          code: "科目コード",
          account: "科目名",
          periodDebit: "当期借方",
          periodCredit: "当期貸方",
          closingDebit: "期末借方",
          closingCredit: "期末貸方",
        },
        checkMessages: {
          POSTING_IN_PROGRESS_PASSED: "処理中の転記リクエストはありません。",
          POSTING_IN_PROGRESS_FAILED: "処理中の転記リクエストがあります。",
          POSTING_FAILED_PASSED: "恒久的失敗の転記リクエストはありません。",
          POSTING_FAILED_FAILED: "恒久的失敗の転記リクエストがあります。",
          APPROVED_REVERSAL_NOT_POSTED_PASSED:
            "転記待ちの承認済み逆仕訳はありません。",
          APPROVED_REVERSAL_NOT_POSTED_FAILED: "承認済みの逆仕訳が未転記です。",
          APPROVED_AMENDMENT_NOT_POSTED_PASSED:
            "転記待ちの承認済み訂正はありません。",
          APPROVED_AMENDMENT_NOT_POSTED_FAILED: "承認済みの訂正が未転記です。",
          POSTED_JOURNAL_BALANCE_PASSED: "転記済み仕訳は貸借一致しています。",
          POSTED_JOURNAL_BALANCE_FAILED: "転記済み仕訳の貸借が一致しません。",
          LEDGER_LINE_COUNT_PASSED: "元帳件数と転記行数が一致しています。",
          LEDGER_LINE_COUNT_FAILED: "元帳件数と転記行数が一致しません。",
          LEDGER_AMOUNT_MATCH_PASSED: "元帳金額は転記行と一致しています。",
          LEDGER_AMOUNT_MATCH_FAILED: "元帳金額が転記行と一致しません。",
          ORPHAN_LEDGER_ENTRY_PASSED: "孤立した元帳行はありません。",
          ORPHAN_LEDGER_ENTRY_FAILED: "孤立した元帳行があります。",
          DUPLICATE_LEDGER_ENTRY_PASSED: "重複した元帳行はありません。",
          DUPLICATE_LEDGER_ENTRY_FAILED: "重複した元帳行があります。",
          PERIOD_JOURNAL_DATE_PASSED: "仕訳日はすべて期間内です。",
          PERIOD_JOURNAL_DATE_FAILED: "期間外の仕訳日があります。",
          PERIOD_LEDGER_DATE_PASSED: "元帳日付はすべて期間内です。",
          PERIOD_LEDGER_DATE_FAILED: "期間外の元帳日付があります。",
          JOURNAL_TYPE_RELATION_PASSED: "仕訳タイプの関連は正常です。",
          JOURNAL_TYPE_RELATION_FAILED: "仕訳タイプの関連に異常があります。",
          TOTAL_DEBIT_CREDIT_PASSED: "元帳の借方・貸方合計は一致しています。",
          TOTAL_DEBIT_CREDIT_FAILED: "元帳の借方・貸方合計が一致しません。",
          UNCONFIRMED_JOURNAL_DRAFTS_PASSED:
            "未確認の仕訳ドラフトはありません。",
          UNCONFIRMED_JOURNAL_DRAFTS_WARNING:
            "未確認の仕訳ドラフトがあります。",
          UNCONFIRMED_JOURNAL_DRAFTS_NOT_APPLICABLE:
            "未確認ドラフト検証は対象外です。",
          OPEN_REVIEWS_PASSED: "未完了のレビュー案件はありません。",
          OPEN_REVIEWS_WARNING: "未完了のレビュー案件があります。",
          OPEN_REVIEWS_NOT_APPLICABLE: "レビュー案件検証は対象外です。",
          UNPOSTED_DOCUMENTS_PASSED: "未転記の確証はありません。",
          UNPOSTED_DOCUMENTS_WARNING: "未転記の確証があります。",
          UNPOSTED_DOCUMENTS_NOT_APPLICABLE: "未転記確証検証は対象外です。",
          OPENING_BALANCE_REQUIRED_PASSED: "この期間の期首残高が存在します。",
          OPENING_BALANCE_REQUIRED_FAILED:
            "第2期以降は期首残高の繰越が必要です。",
          OPENING_BALANCE_CHECKSUM_PASSED: "期首残高チェックサムは有効です。",
          OPENING_BALANCE_CHECKSUM_FAILED: "期首残高チェックサムが無効です。",
        },
      },
      trialBalance: {
        title: "試算表",
        columns: {
          code: "科目コード",
          account: "科目名",
          openingDebit: "期首借方",
          openingCredit: "期首貸方",
          periodDebit: "当期借方",
          periodCredit: "当期貸方",
          closingDebit: "期末借方",
          closingCredit: "期末貸方",
        },
      },
      carryForward: {
        title: "期間繰越",
        crossYearTitle: "会計年度跨ぎ期首繰越",
        create: "繰越申請を作成",
        validate: "検証を実行",
        submit: "レビュー提出",
        cancel: "申請取消",
        checksTitle: "繰越検証項目",
        summaryNone: "繰越申請はまだ作成されていません。",
        summaryCrossYearNone:
          "前会計年度の決算完了後、年度跨ぎ期首繰越申請を作成できます。",
        summaryCrossYearCompleted:
          "当年度第1期の年度跨ぎ期首残高が生成済みです。",
        summaryCompleted: "この期間の期首残高は既に生成済みです。",
        summarySourceNotClosed: "前期間を締めてから繰越してください。",
        summaryNotApplicable: "第1期は同年度繰越不要です。",
        crossYearDisclaimerRevenueExpense:
          "収益・費用科目は次年度へ繰り越されません。",
        crossYearDisclaimerCurrentYearProfit:
          "当期純利益科目は決算後ゼロである必要があります。",
        crossYearDisclaimerRetainedEarnings:
          "利益剰余金には当期損益が既に反映され、決算後残高で繰り越されます。",
        crossYearDisclaimerNoJournal:
          "本操作は新しい仕訳や元帳エントリを作成しません。",
        crossYearDisclaimerNoFinancialStatements:
          "正式な財務諸表や税務申告は本操作では完了しません。",
        status: {
          DRAFT: "下書き",
          VALIDATING: "検証中",
          VALIDATION_FAILED: "検証失敗",
          REVIEW_REQUIRED: "レビュー待ち",
          APPROVED: "承認済み",
          PROCESSING: "処理中",
          COMPLETED: "完了",
          REJECTED: "却下",
          CANCELLED: "取消",
          SUPERSEDED: "置換済み",
          FAILED: "失敗",
        },
        checkStatus: {
          PASSED: "合格",
          WARNING: "警告",
          FAILED: "失敗",
          NOT_APPLICABLE: "対象外",
        },
        checkMessages: {
          SOURCE_PERIOD_CLOSED_PASSED: "繰越元期間は締め済みです。",
          SOURCE_PERIOD_CLOSED_FAILED: "繰越元期間が未締めです。",
          TARGET_PERIOD_OPEN_PASSED: "繰越先期間はオープンです。",
          TARGET_PERIOD_OPEN_FAILED: "繰越先期間がオープンではありません。",
          SAME_ACCOUNTING_BOOK_PASSED: "繰越元と繰越先は同一帳簿です。",
          SAME_ACCOUNTING_BOOK_FAILED:
            "繰越元と繰越先が同一帳簿ではありません。",
          SAME_FISCAL_YEAR_PASSED: "繰越元と繰越先は同一会計年度です。",
          SAME_FISCAL_YEAR_FAILED:
            "繰越元と繰越先が同一会計年度ではありません。",
          PERIOD_ADJACENT_PASSED: "繰越元と繰越先は隣接期間です。",
          PERIOD_ADJACENT_FAILED: "繰越元と繰越先が隣接していません。",
          SOURCE_SNAPSHOT_EXISTS_PASSED:
            "繰越元の元帳スナップショットが存在します。",
          SOURCE_SNAPSHOT_EXISTS_FAILED:
            "繰越元の元帳スナップショットがありません。",
          SOURCE_SNAPSHOT_CHECKSUM_PASSED:
            "繰越元スナップショットのチェックサムは有効です。",
          SOURCE_SNAPSHOT_CHECKSUM_FAILED:
            "繰越元スナップショットのチェックサムが無効です。",
          SOURCE_SNAPSHOT_TOTAL_BALANCE_PASSED:
            "繰越元スナップショットの合計は均衡しています。",
          SOURCE_SNAPSHOT_TOTAL_BALANCE_FAILED:
            "繰越元スナップショットの合計が不均衡です。",
          SOURCE_ACCOUNT_BALANCE_VALID_PASSED: "繰越元科目残高は有効です。",
          SOURCE_ACCOUNT_BALANCE_VALID_FAILED: "繰越元科目残高が無効です。",
          TARGET_NO_OPENING_BALANCE_PASSED:
            "繰越先期間に期首残高はありません。",
          TARGET_NO_OPENING_BALANCE_FAILED:
            "繰越先期間に既に期首残高があります。",
          TARGET_NO_POSTED_JOURNALS_PASSED:
            "繰越先期間に転記済み仕訳はありません。",
          TARGET_NO_POSTED_JOURNALS_FAILED:
            "繰越先期間に既に転記済み仕訳があります。",
          TARGET_NO_CLOSE_REQUEST_PASSED:
            "繰越先期間に進行中の締め申請はありません。",
          TARGET_NO_CLOSE_REQUEST_FAILED:
            "繰越先期間に進行中の締め申請があります。",
          BOOK_ACTIVE_PASSED: "会計帳簿は有効です。",
          BOOK_ACTIVE_FAILED: "会計帳簿が有効ではありません。",
          REQUEST_VERSION_CURRENT_PASSED: "繰越申請バージョンは最新です。",
          REQUEST_VERSION_CURRENT_FAILED:
            "繰越申請バージョンが古くなっています。",
          ARCHIVED_ACCOUNTS_INCLUDED_PASSED:
            "繰越元にアーカイブ科目は含まれていません。",
          ARCHIVED_ACCOUNTS_INCLUDED_WARNING:
            "繰越元にアーカイブ科目が含まれています。",
          ABNORMAL_ACCOUNT_BALANCE_PASSED:
            "異常な科目残高は検出されませんでした。",
          ABNORMAL_ACCOUNT_BALANCE_WARNING: "異常な科目残高が検出されました。",
          ZERO_BALANCE_ACCOUNTS_PASSED: "繰越元にゼロ残高科目はありません。",
          ZERO_BALANCE_ACCOUNTS_WARNING:
            "繰越元にゼロ残高科目が含まれています。",
        },
      },
      yearEndClose: {
        fiscalYear: "会計年度",
        title: "年度決算",
        create: "決算申請を作成",
        validate: "検証を実行",
        generate: "決算行を生成",
        submit: "レビュー提出",
        cancel: "申請を取消",
        retry: "仕訳を再試行",
        checksTitle: "決算検証項目",
        snapshotTitle: "年度決算スナップショット",
        snapshotGeneratedAt: "生成日時 {value}",
        totalRevenue: "収益合計",
        totalExpense: "費用合計",
        profitBeforeTransfer: "振替前利益",
        summaryNone: "年度決算申請はまだ作成されていません。",
        summaryCompleted: "この会計年度は決算済みです。",
        summaryNoPeriods: "この会計年度の会計期間がありません。",
        summaryPeriodsNotClosed:
          "未締め期間が {count} 件あります。全期間締め後に決算できます。",
        summaryPolicyNotConfigured:
          "先に帳簿の当期純利益・利益剰余金科目を設定してください。",
        disclaimerNoNextFyOpening:
          "本フェーズでは次年度の期首残高や年度跨ぎ繰越は自動生成しません。",
        disclaimerNoFinancialStatements:
          "本フェーズでは財務諸表は出力しません。",
        disclaimerNoReopen:
          "年度決算完了後は再開や決算仕訳の取消はできません。",
        progress: {
          validating: "決算検証を実行中…",
          approved: "レビュー承認済み。仕訳を開始します…",
          postingQueued:
            "決算仕訳をキューに登録しました。しばらくお待ちください…",
          partiallyPosted: "損益振替は完了。利益剰余金振替を処理中…",
          completed: "年度決算が完了しました。",
        },
        status: {
          DRAFT: "下書き",
          VALIDATING: "検証中",
          VALIDATION_FAILED: "検証失敗",
          REVIEW_REQUIRED: "レビュー待ち",
          APPROVED: "承認済み",
          POSTING_QUEUED: "仕訳待ち",
          PARTIALLY_POSTED: "一部仕訳済み",
          COMPLETED: "完了",
          REJECTED: "却下",
          CANCELLED: "取消",
          SUPERSEDED: "置換済み",
          FAILED: "失敗",
        },
        checkStatus: {
          PASSED: "合格",
          WARNING: "警告",
          FAILED: "失敗",
          NOT_APPLICABLE: "対象外",
        },
        lineGroups: {
          PROFIT_AND_LOSS_CLOSING: "損益振替",
          RETAINED_EARNINGS_TRANSFER: "利益剰余金振替",
        },
        lineColumns: {
          code: "科目コード",
          account: "科目名",
          side: "借貸",
          amount: "金額",
        },
        snapshotColumns: {
          code: "科目コード",
          account: "科目名",
          preCloseDebit: "決算前借方",
          preCloseCredit: "決算前貸方",
          postCloseDebit: "決算後借方",
          postCloseCredit: "決算後貸方",
          treatment: "決算処理",
        },
        treatment: {
          CARRIED_FORWARD: "繰越",
          CLOSED_TO_PROFIT: "当期純利益へ振替",
          CURRENT_YEAR_PROFIT: "当期純利益",
          RETAINED_EARNINGS: "利益剰余金",
          ZERO_BALANCE: "ゼロ残高",
        },
        checkMessages: {
          FINAL_PERIOD_EXISTS_PASSED: "最終期間が存在します。",
          FINAL_PERIOD_EXISTS_FAILED: "最終期間が存在しません。",
          FINAL_PERIOD_CLOSED_PASSED: "最終期間は締め済みです。",
          FINAL_PERIOD_CLOSED_FAILED: "最終期間が未締めです。",
          ALL_PERIODS_CLOSED_PASSED: "全期間が締め済みです。",
          ALL_PERIODS_CLOSED_FAILED: "未締め期間があります。",
          PERIOD_SEQUENCE_COMPLETE_PASSED: "期間連番は完全です。",
          PERIOD_SEQUENCE_COMPLETE_FAILED: "期間連番が不完全です。",
          FINAL_LEDGER_SNAPSHOT_EXISTS_PASSED:
            "最終元帳スナップショットが存在します。",
          FINAL_LEDGER_SNAPSHOT_EXISTS_FAILED:
            "最終元帳スナップショットがありません。",
          FINAL_LEDGER_SNAPSHOT_CHECKSUM_PASSED:
            "元帳スナップショットのチェックサムは有効です。",
          FINAL_LEDGER_SNAPSHOT_CHECKSUM_FAILED:
            "元帳スナップショットのチェックサムが無効です。",
          TEMPORARY_ACCOUNT_BALANCES_VALID_PASSED: "仮勘定残高は有効です。",
          TEMPORARY_ACCOUNT_BALANCES_VALID_FAILED: "仮勘定残高が無効です。",
          OPENING_BALANCE_CHAIN_COMPLETE_PASSED: "期首残高チェーンは完全です。",
          OPENING_BALANCE_CHAIN_COMPLETE_FAILED:
            "期首残高チェーンが不完全です。",
          CARRY_FORWARD_CHAIN_COMPLETE_PASSED: "繰越チェーンは完全です。",
          CARRY_FORWARD_CHAIN_COMPLETE_FAILED: "繰越チェーンが不完全です。",
          NO_POSTING_IN_PROGRESS_PASSED: "進行中の仕訳リクエストはありません。",
          NO_POSTING_IN_PROGRESS_FAILED: "進行中の仕訳リクエストがあります。",
          NO_UNRESOLVED_POSTING_FAILURE_PASSED:
            "未解決の仕訳失敗はありません。",
          NO_UNRESOLVED_POSTING_FAILURE_FAILED: "未解決の仕訳失敗があります。",
          NO_PENDING_REVERSAL_PASSED: "保留中の逆仕訳申請はありません。",
          NO_PENDING_REVERSAL_FAILED: "保留中の逆仕訳申請があります。",
          NO_PENDING_AMENDMENT_PASSED: "保留中の訂正申請はありません。",
          NO_PENDING_AMENDMENT_FAILED: "保留中の訂正申請があります。",
          NO_ACTIVE_PERIOD_CLOSE_PASSED: "進行中の期間締め申請はありません。",
          NO_ACTIVE_PERIOD_CLOSE_FAILED: "進行中の期間締め申請があります。",
          NO_ACTIVE_CARRY_FORWARD_PASSED: "進行中の繰越申請はありません。",
          NO_ACTIVE_CARRY_FORWARD_FAILED: "進行中の繰越申請があります。",
          BOOK_ACTIVE_PASSED: "帳簿は有効です。",
          BOOK_ACTIVE_FAILED: "帳簿が有効ではありません。",
          YEAR_NOT_ALREADY_CLOSED_PASSED: "会計年度は未決算です。",
          YEAR_NOT_ALREADY_CLOSED_FAILED: "会計年度は決算済みです。",
          YEAR_END_POLICY_CONFIGURED_PASSED: "年度決算ポリシーは設定済みです。",
          YEAR_END_POLICY_CONFIGURED_FAILED: "年度決算ポリシーが未設定です。",
          YEAR_END_ACCOUNTS_VALID_PASSED: "決算科目設定は有効です。",
          YEAR_END_ACCOUNTS_VALID_FAILED: "決算科目設定が無効です。",
          GENERATED_LINES_BALANCED_PASSED: "生成された決算行は貸借一致です。",
          GENERATED_LINES_BALANCED_FAILED: "生成された決算行が貸借不一致です。",
          REQUEST_VERSION_CURRENT_PASSED: "決算申請バージョンは最新です。",
          REQUEST_VERSION_CURRENT_FAILED: "決算申請バージョンが古いです。",
          ARCHIVED_ACCOUNTS_INCLUDED_PASSED:
            "スナップショットにアーカイブ科目はありません。",
          ARCHIVED_ACCOUNTS_INCLUDED_WARNING:
            "スナップショットにアーカイブ科目が含まれます。",
          ABNORMAL_ACCOUNT_BALANCE_PASSED:
            "異常な科目残高は検出されませんでした。",
          ABNORMAL_ACCOUNT_BALANCE_WARNING: "異常な科目残高が検出されました。",
          UNCONFIRMED_JOURNAL_DRAFTS_PASSED:
            "未確認の仕訳ドラフトはありません。",
          UNCONFIRMED_JOURNAL_DRAFTS_WARNING:
            "未確認の仕訳ドラフトがあります。",
          UNCONFIRMED_JOURNAL_DRAFTS_NOT_APPLICABLE:
            "未確認仕訳ドラフト検査は対象外です。",
          OPEN_REVIEWS_PASSED: "未完了レビュー案件はありません。",
          OPEN_REVIEWS_WARNING: "未完了レビュー案件があります。",
          OPEN_REVIEWS_NOT_APPLICABLE: "レビュー案件検査は対象外です。",
        },
      },
    },
    review: {
      staleWarning: "対象バージョンが古くなっています",
      status: {
        DRAFT: "下書き",
        PENDING: "保留",
        IN_REVIEW: "レビュー中",
        CHANGES_REQUESTED: "修正依頼",
        APPROVED: "承認済み",
        REJECTED: "却下済み",
        CANCELLED: "取消済み",
        SUPERSEDED: "差替済み",
      },
      stepStatus: {},
      subjectType: {
        EXTRACTION: "抽出",
        BUSINESS_TRANSACTION: "取引",
        ACCOUNTING_CLASSIFICATION: "会計分類",
        JOURNAL_DRAFT: "仕訳草稿",
      },
      actionType: {},
      actions: {
        submit: "提出",
        claim: "受領",
        approve: "承認",
        requestChanges: "修正依頼",
        reject: "却下",
        cancel: "取消",
        reassign: "再割当",
      },
      inbox: {
        title: "レビュー受信箱",
        subtitle: "自分に割り当てられたレビューケース",
        backToDocuments: "確証に戻る",
        subject: "対象",
        type: "種別",
        status: "状態",
        step: "ステップ",
        actions: "操作",
        empty: "受信箱にレビューケースはありません。",
      },
    },
  },
  operator: {
    menuGroups: {
      healthManagement: "健康認定",
      overview: "概要",
      tenantOperations: "テナント運用",
      commercial: "商用管理",
      platformCapabilities: "プラットフォーム機能",
      dataOperations: "データ・運用",
      system: "システム",
    },
    certificationStandards: "認定基準",
    certificationStandardsSubtitle: "基準版、要求項目、公開の管理",
    overview: "運用サマリー",
    overviewSubtitle: "プラットフォーム主要指標",
    ops: "運用ダッシュボード",
    opsSubtitle: "プロセス健全性・依存接続・キュー滞留",
    tenants: "テナント管理",
    tenantsSubtitle: "開通、編集、機能スイッチ",
    trialApplications: "トライアル申請",
    trialApplicationsSubtitle: "申請を審査してトライアルテナントを開通",
    plans: "プラン管理",
    plansSubtitle: "利用枠とメニュー機能の設定",
    billing: "サブスクリプション・請求",
    billingSubtitle: "プランバージョン、契約、請求、入金",
    billingEnhancements: "請求強化",
    billingEnhancementsSubtitle:
      "クーポン、プラン変更シミュレーション、督促状態",
    featureFlags: "機能フラグ",
    featureFlagsSubtitle: "段階リリース、環境制御、対象別オーバーライド",
    backups: "バックアップ・復元",
    backupsSubtitle: "MySQL 暗号化バックアップとデータ削除管理",
    reportDemo: "レポートデモ",
    reportDemoSubtitle: "テストデータで PDF レポートを生成",
    featureDemo: "機能デモ",
    importDemo: "インポートデモ",
    importDemoSubtitle: "一括インポート/エクスポートとバッチ処理デモ",
    usage: "利用状況",
    usageSubtitle: "各テナントの利用量とコスト",
    apiPlatform: "API プラットフォーム",
    apiPlatformSubtitle: "テナント API キーの利用量とエラー統計",
    apiRequestLogs: "API 呼び出しログ",
    apiRequestLogsSubtitle: "サードパーティ API キーのリクエスト履歴",
    ai: "AI 管理",
    aiSubtitle: "モデル、シークレット、プロンプト、呼び出しログ",
    userFeedbacks: "ユーザーフィードバック",
    userFeedbacksSubtitle: "テナントからのフィードバックと返信",
    notificationSend: "通知送信",
    notificationSendSubtitle: "全体・テナント・ユーザーへサイト内通知を送信",
    notificationHistory: "通知履歴",
    notificationHistorySubtitle: "送信済み通知と内容プレビューを確認",
    logs: "ログ",
    auditLogs: "監査ログ",
    auditLogsSubtitle: "テナント横断の操作記録",
    webhookLogs: "Webhook ログ",
    webhookLogsSubtitle: "配信記録とエラー",
    reportLogs: "レポートログ",
    reportLogsSubtitle: "PDF レポート出力記録",
    outbox: "Outbox メッセージ",
    outboxSubtitle: "非同期配信メッセージの明細・状態絞り込み・手動再送",
    emailLogs: "メールログ",
    emailLogsSubtitle: "送信状態、内容、再送",
    emailTemplates: "メールテンプレート",
    emailTemplatesSubtitle: "共通レイアウトと差し込み項目の管理",
    systemSettings: "システム設定",
    systemSettingsSubtitle: "プラットフォーム全体設定",
  },
  operatorCertificationStandards: {
    title: "認定基準",
    description: "認定基準、出典および変更不可の公開版を管理します",
    newStandard: "基準を作成",
    empty: "認定基準はまだありません",
    requirements: "件の要求",
    noRequirements: "この版には要求項目がありません",
    source: "版の出典",
    addRequirement: "要求を追加",
    publish: "公開",
    createRevision: "改訂版を作成",
    code: "基準コード",
    program: "認定プログラム",
    division: "認定区分",
    year: "認定年度",
    nameJa: "日本語名",
    nameZh: "中国語名",
    nameEn: "英語名",
    stableKey: "安定キー",
    kind: "種別",
    parent: "上位要求",
    order: "順序",
    titleJa: "日本語タイトル",
    titleZh: "中国語タイトル",
    titleEn: "英語タイトル",
    requirement: "要求項目",
    createDescription: "基準と最初のドラフト版を作成します。",
    sourceDescription:
      "公開前に公式 URL とファイルの SHA-256 を記録してください。",
    requirementDescription:
      "公開後も同じ安定キーを使用し、版をまたいで追跡します。",
    status: { DRAFT: "ドラフト", PUBLISHED: "公開済み", RETIRED: "廃止" },
    kinds: { section: "区分", question: "設問", criterion: "評価項目" },
    messages: {
      created: "基準を作成しました",
      saved: "保存しました",
      deleted: "要求を削除しました",
      published: "版を公開しました",
      revisionCreated: "改訂版を作成しました",
      deleteConfirm: "要求を削除しますか？",
      publishConfirm: "この版を公開しますか？",
      publishImmutable:
        "公開後の内容は変更できません。変更する場合は新しい改訂版を作成してください。",
    },
  },
  operatorFormat: {
    tenantStatuses: {
      ACTIVE: "有効",
      SUSPENDED: "一時停止",
      DELETED: "削除済み",
    },
    memberRoles: {
      ADMIN: "管理者",
      MANAGER: "マネージャー",
      OPERATOR: "オペレーター",
      VIEWER: "閲覧のみ",
      EMPLOYEE: "従業員",
    },
  },
  auditActions: {
    CREATE: "作成",
    UPDATE: "更新",
    DELETE: "削除",
    ASSIGN: "割り当て",
    ARCHIVE: "アーカイブ",
    SEND: "送信",
    RETRY: "再試行",
    TEST: "テスト",
    PUBLISH: "公開",
    LOGIN: "ログイン",
    LOGIN_FAILED: "ログイン失敗",
    SSO_LOGIN: "SSO ログイン",
    SSO_LOGIN_FAILED: "SSO ログイン失敗",
    LOGOUT: "ログアウト",
    MFA_VERIFY: "MFA 検証",
    UPDATE_PROFILE: "プロフィール更新",
    UPDATE_AVATAR: "アバター更新",
    CHANGE_PASSWORD: "パスワード変更",
    RECOVERY_CODES_REGENERATED: "リカバリーコード再生成",
    REVOKE_API_KEY: "API Key 失効",
    PASSWORD_RESET_REQUESTED: "パスワード再設定リクエスト",
    PASSWORD_RESET_COMPLETED: "パスワード再設定完了",
    USER_INVITED: "ユーザー招待",
    INVITATION_ACCEPTED: "招待承諾",
    ACCOUNT_UNLOCKED: "アカウントロック解除",
    IMPERSONATE_START: "代行開始",
    IMPERSONATE_END: "代行終了",
    TRIAL_APPLICATION_SUBMITTED: "トライアル申請提出",
    TRIAL_APPLICATION_APPROVED: "トライアル申請承認",
    TRIAL_APPLICATION_REJECTED: "トライアル申請却下",
    transaction: {
      draft_created: "取引ドラフト作成",
      validation_warning: "取引検証警告",
      updated: "取引更新",
      confirmed: "取引確認",
      rejected: "取引却下",
      cancelled: "取引キャンセル",
      superseded: "取引置換",
      regenerated: "取引再生成",
    },
    accounting_classification: {
      pending: "会計分類待ち",
    },
    accounting_book: {
      created: "会計帳簿を作成",
      updated: "会計帳簿を更新",
      archived: "会計帳簿をアーカイブ",
    },
    account: {
      created: "勘定科目を作成",
      updated: "勘定科目を更新",
      archived: "勘定科目をアーカイブ",
    },
    classification: {
      created: "分類を作成",
      suggested: "分類案を生成",
      updated: "分類を更新",
      confirmed: "分類を確認",
      rejected: "分類を却下",
      superseded: "分類を差替",
    },
    accounting: {
      classification: {
        requested: "会計分類をリクエスト",
        started: "会計分類を開始",
        failed: "会計分類に失敗",
      },
      journal_draft: {
        requested: "仕訳草稿生成をリクエスト",
      },
      posting: {
        requested_from_foundation: "Foundation 仕訳転記をリクエスト",
        completed_from_foundation: "Foundation 仕訳転記を完了",
      },
    },
    journal_draft: {
      created: "仕訳草稿を作成",
      updated: "仕訳草稿を更新",
      confirmed: "仕訳草稿を確認",
      rejected: "仕訳草稿を却下",
      cancelled: "仕訳草稿を取消",
      superseded: "仕訳草稿を差替",
    },
    posting: { pending: "将来の転記フェーズ待ち" },
    financial_report: {
      requested: "財務レポート生成を要求",
      started: "財務レポート生成を開始",
      completed: "財務レポート生成が完了",
      failed: "財務レポート生成に失敗",
      cancelled: "財務レポート生成を取消",
      retried: "財務レポート生成を再試行",
    },
    financial_report_snapshot: {
      created: "財務レポートスナップショットを作成",
    },
    financial_report_mapping: {
      created: "科目レポートマッピングを作成",
      updated: "科目レポートマッピングを更新",
    },
    document_accounting_draft: {
      created: "書類会計ドラフトを作成",
      updated: "書類会計ドラフトを更新",
      validated: "書類会計ドラフトを検証",
      voided: "書類会計ドラフトを取消",
    },
    document_accounting_posting: {
      confirmed: "書類会計仕訳計上を確認",
      succeeded: "書類会計仕訳計上が成功",
      failed: "書類会計仕訳計上に失敗",
      retried: "書類会計仕訳計上を再試行",
    },
    document_intake: {
      upload_session: { created: "書類受付アップロードセッションを作成" },
      upload: { completed: "書類受付アップロード完了" },
      original: { download_issued: "書類原本ダウンロード URL を発行" },
      reparse: { requested: "書類再解析を要求" },
      review: { submitted: "書類レビューを提出" },
      ownership: { assigned: "書類帰属を割当" },
      duplicate: { marked: "書類を重複としてマーク" },
      deletion: { requested: "書類削除を要求" },
      retention: { locked: "書類保持ロックを適用" },
      legal_hold: { applied: "書類リーガルホールドを適用" },
      purged: "書類を削除済み",
    },
    document: {
      processing: {
        queued: "書類処理をキュー投入",
        retry_requested: "書類処理の再試行を要求",
        exhausted: "書類処理の再試行上限に到達",
      },
      ocr: {
        started: "書類 OCR を開始",
        completed: "書類 OCR を完了",
        failed: "書類 OCR に失敗",
      },
      ai_extraction: {
        started: "書類 AI 抽出を開始",
        completed: "書類 AI 抽出を完了",
        failed: "書類 AI 抽出に失敗",
      },
      review_candidate: {
        created: "書類レビュー候補を作成",
      },
      accounting_bridge: {
        requested: "書類会計ブリッジを要求",
        started: "書類会計ブリッジを開始",
        succeeded: "書類会計ブリッジが成功",
        failed: "書類会計ブリッジが失敗",
        ineligible: "書類会計ブリッジは対象外",
        cancelled: "書類会計ブリッジをキャンセル",
        amendment_required: "書類会計ブリッジは修正が必要",
      },
    },
    business_transaction: {
      created_from_document_review: "書類レビューから業務取引を作成",
    },
    ar_ap: {
      obligation_created: "売掛買掛義務を作成",
      obligation_updated: "売掛買掛義務を更新",
      obligation_opened: "売掛買掛義務をオープン",
      obligation_cancelled: "売掛買掛義務を取消",
      obligation_superseded: "売掛買掛義務を置換",
      obligation_settled: "売掛買掛義務を消込完了",
      obligation_reopened: "売掛買掛義務を再オープン",
      opening_import_batch_created: "期首売掛買掛インポートバッチを作成",
      opening_import_batch_validated: "期首売掛買掛インポートバッチを検証",
      opening_import_batch_executed: "期首売掛買掛インポートバッチの実行を開始",
      opening_import_batch_completed: "期首売掛買掛インポートバッチが完了",
      opening_import_batch_failed: "期首売掛買掛インポートバッチが失敗",
      opening_import_batch_cancelled: "期首売掛買掛インポートバッチを取消",
    },
    payment: {
      created: "入出金を作成",
      updated: "入出金を更新",
      confirmed: "入出金を確認（業務事実）",
      cancelled: "入出金を取消",
    },
    bank_match: {
      payment_draft_created: "銀行照合から入出金下書きを作成",
    },
    bank_evidence: {
      linked: "銀行明細×伝票照合を紐付け",
      excluded: "銀行明細×伝票照合を除外",
      unlinked: "銀行明細×伝票照合を解除",
      candidates_refreshed: "銀行明細×伝票照合の候補を再生成",
      feature_disabled: "銀行明細×伝票照合機能が無効",
    },
    settlement: {
      allocation_created: "消込を作成",
      allocation_voided: "消込を取消",
      accounting_date_resolved: "消込の会計日付を確定",
      accounting_transaction_created: "消込の会計取引を作成",
      accounting_linked: "消込会計リンクを確立",
      accounting_orchestration_requested: "消込会計オーケストレーションを要求",
      accounting_orchestration_completed: "消込会計オーケストレーション完了",
      accounting_orchestration_failed: "消込会計オーケストレーション失敗",
      accounting_classification_ensured: "消込分類提案を確保",
      accounting_journal_ensured: "消込仕訳下書きを確保",
      accounting_posting_requested: "消込会計転記リクエストを作成",
      accounting_orchestration_waiting: "消込会計オーケストレーション待機中",
      accounting_orchestration_recovered: "消込会計オーケストレーションを回復",
    },
    line_webhook: {
      received: "LINE Webhook を受信",
      queued: "LINE Webhook をキュー投入",
    },
    line_media: {
      fetch_started: "LINE メディア取得を開始",
      fetch_succeeded: "LINE メディア取得が成功",
      fetch_failed: "LINE メディア取得に失敗",
    },
    line_document_intake: {
      submitted: "LINE 書類受付を提出",
      duplicate_suppressed: "LINE 重複書類受付を抑止",
    },
    line: {
      account_link: {
        token_issued: "LINE アカウント連携トークンを発行",
        nonce_created: "LINE アカウント連携 nonce を作成",
        completed: "LINE アカウント連携を完了",
        failed: "LINE アカウント連携に失敗",
        conflict: "LINE アカウント連携が競合",
      },
      account_unlinked: "LINE アカウント連携を解除",
      document: {
        received: "LINE 書類を受信",
        binding_rejected: "LINE 書類の連携を拒否",
        download_started: "LINE 書類の取得を開始",
        download_failed: "LINE 書類の取得に失敗",
        storage_completed: "LINE 書類の保存を完了",
        intake_created: "LINE 書類受付を作成",
        processing_enqueued: "LINE 書類処理をキュー投入",
        duplicate_ignored: "LINE 重複書類を無視",
        rejected: "LINE 書類を拒否",
      },
      production_gate: { changed: "LINE 本番ゲートを変更" },
    },
    financial_report_export: {
      requested: "財務レポートエクスポートを要求",
      queued: "財務レポートエクスポートをキュー投入",
      started: "財務レポートエクスポートを開始",
      completed: "財務レポートエクスポートを完了",
      failed: "財務レポートエクスポートに失敗",
      retried: "財務レポートエクスポートを再試行",
      cancelled: "財務レポートエクスポートをキャンセル",
      expired: "財務レポートエクスポートの期限切れ",
      download_url_issued: "財務レポートエクスポートのダウンロードURLを発行",
      artifact_deleted: "財務レポートエクスポートファイルを削除",
      orphan_cleanup_failed: "財務レポートエクスポートの孤立ファイル削除に失敗",
    },
    HTTP_ERROR: "HTTP エラー",
    REQUEST_PERF: "リクエスト性能",
    AUDIT_DB_WRITE_FAILED: "監査書き込み失敗",
    LOGIN_ATTEMPT_WRITE_FAILED: "ログイン試行書き込み失敗",
  },
  operatorAuditLogs: {
    filters: {
      tenantName: "テナント名",
      userName: "ユーザー名 / メール",
      allActions: "すべての操作",
    },
    columns: {
      time: "日時",
      tenant: "テナント",
      user: "ユーザー",
      action: "操作",
      resource: "リソース",
      details: "詳細",
    },
  },
  operatorFeatureChecklist: {
    menuPermissions: "メニュー権限",
    featureToggles: "機能スイッチ",
    features: {
      apiKeys: "API Key 管理",
      mfa: "多要素認証",
      dataExport: "データエクスポート",
      aiGateway: "AI ゲートウェイ呼び出し",
    },
  },
  operatorUsage: {
    refreshStats: "統計を更新",
    filters: {
      dateRange: "期間",
      tenant: "テナント",
      tenantRequired: "テナントを選択してください",
    },
    units: "リソース利用量",
    apiCalls: "API 呼び出し",
    storage: "ストレージ",
    cost: "推計コスト",
    documentCount: "伝票数",
    aiRequestCount: "AI リクエスト数",
    inputTokens: "トークン入力",
    outputTokens: "トークン出力",
    planLabel: "プラン: {name}",
    planComparison: "プランとの比較",
    planComparisonHint:
      "バーは used / limit を表示します。80% 以上で警告、100% 以上で超過です。",
    noPlanLimit: "プラン上限なし",
    costEstimateHint: "Gemini トークン単価に基づく推計",
    storageSnapshotHint: "全量スナップショット（期間増分ではありません）",
    unlimited: "無制限",
    selectTenant: "テナントを選択してください",
    selectTenantDescription:
      "テナントを選ぶと、選択期間の利用状況 KPI とプラン比較を表示します。",
    empty: "利用状況データがありません",
    emptyDescription: "このテナントには、選択期間の利用実績がありません。",
    notes: {
      noPlanLimitMetrics:
        "伝票数とトークンは観測指標のみで、現時点ではプラン上限はありません。",
      costEstimate: "コストは Gemini トークン単価に基づく推計です（USD）。",
      storageSnapshot:
        "ストレージは stored_object の全量スナップショットで、期間増分ではありません。",
    },
    messages: {
      loadFailed: "利用状況を読み込めません",
      loadFailedDescription:
        "ログイン状態またはネットワーク接続を確認して再試行してください。",
    },
  },
  operatorApiPlatform: {
    refresh: "統計を更新",
    viewLogs: "呼び出しログを見る",
    openDocs: "API ドキュメントを開く",
    requestCount: "リクエスト数",
    activeApiKeys: "アクティブキー",
    errorCount: "エラー数",
    avgDuration: "平均応答時間",
    apiKeyFilter: "API Key ID",
    apiKeyColumn: "API Key",
    methodColumn: "メソッド",
    pathColumn: "パス",
    durationColumn: "応答時間",
  },
  apiDocs: {
    title: "API ドキュメント",
    subtitle: "OpenAPI ベースの API リファレンス",
    backToLogin: "ログインに戻る",
  },
  apiScopes: {
    webhooks: {
      read: "Webhook 読み取り",
      write: "Webhook 書き込み",
      delete: "Webhook 削除",
    },
    batch: {
      read: "バッチ読み取り",
      write: "バッチ書き込み",
    },
  },
  operatorUserFeedbacks: {
    filters: {
      tenantName: "テナント名",
      allSubjects: "すべての件名",
    },
    columns: {
      time: "日時",
      tenant: "テナント",
      user: "ユーザー",
      subject: "件名",
      status: "ステータス",
      summary: "概要",
      actions: "操作",
    },
    actions: {
      details: "詳細",
    },
    detail: {
      title: "フィードバック詳細",
      description:
        "フィードバック内容を確認し、ステータスを更新してユーザーへ返信します。",
      tenant: "テナント",
      user: "ユーザー",
      email: "メール",
      subject: "件名",
      status: "ステータス",
    },
    reply: {
      placeholder: "ユーザーへ返信...",
      sending: "送信中...",
      send: "返信を送信",
    },
    messages: {
      loadDetailFailed: "詳細の読み込みに失敗しました",
      statusUpdated: "ステータスを更新しました",
      updateFailed: "更新に失敗しました",
      replyRequired: "返信内容を入力してください",
      replySent: "返信を送信しました",
      sendFailed: "送信に失敗しました",
    },
  },
  operatorNotifications: {
    form: {
      title: "サイト内通知を送信",
      description:
        "有効な全ユーザー、特定テナント、または特定ユーザーへ通知を配信します。",
    },
    fields: {
      audience: "送信範囲",
      tenant: "対象テナント",
      user: "対象ユーザー",
      severity: "重要度",
      title: "タイトル",
      body: "本文",
      actionUrl: "遷移先 URL",
    },
    audience: {
      all: "全ユーザー",
      tenant: "特定テナント",
      user: "特定ユーザー",
    },
    placeholders: {
      tenant: "テナントを選択",
      user: "ユーザーを選択",
      title: "例: メンテナンスのお知らせ",
      actionUrl: "/billing",
    },
    hints: {
      actionUrl:
        "任意。サイト内パス（例: /billing）または完全な URL を指定できます。",
    },
    actions: {
      send: "通知を送信",
      sending: "送信中...",
    },
    validation: {
      titleRequired: "タイトルを入力してください",
      tenantRequired: "対象テナントを選択してください",
      userRequired: "対象ユーザーを選択してください",
    },
    toast: {
      sent: "{count} 件の通知を送信しました",
      failed: "通知の送信に失敗しました",
    },
  },
  operatorNotificationHistory: {
    filters: {
      allAudiences: "すべての範囲",
    },
    columns: {
      sentAt: "送信日時",
      audience: "送信範囲",
      title: "タイトル",
      recipients: "送信人数",
      severity: "重要度",
      status: "状態",
      actions: "操作",
    },
    status: {
      active: "有効",
      revoked: "取り消し済み",
    },
    actions: {
      preview: "プレビュー",
      revoke: "取り消し",
      delete: "完全削除",
    },
    confirm: {
      revokeTitle: "この通知を取り消しますか？",
      revokeDescription:
        "取り消し後、ユーザーには表示されなくなりますが、運営側の履歴は残ります。",
      deleteTitle: "この通知を完全に削除しますか？",
      deleteDescription:
        "削除後は元に戻せません。関連するユーザー通知もすべて削除されます。",
    },
    messages: {
      revoked: "通知を取り消しました",
      deleted: "通知を削除しました",
      revokeFailed: "通知の取り消しに失敗しました",
      deleteFailed: "通知の削除に失敗しました",
    },
    previewDescription: "送信済み通知の全文を確認します。",
  },
  notificationDetail: {
    title: "通知詳細",
    emptyBody: "本文はありません",
  },
  operatorLogPages: {
    filters: {
      tenantName: "テナント名",
    },
    columns: {
      time: "日時",
      tenant: "テナント",
      event: "イベント",
      statusCode: "ステータスコード",
      error: "エラー",
    },
  },
  operatorEmailLogs: {
    filters: {
      allStatuses: "すべてのステータス",
    },
    columns: {
      recipient: "宛先",
      subject: "件名",
      status: "ステータス",
      actions: "操作",
    },
    actions: {
      details: "詳細",
      retry: "再送",
    },
    statuses: {
      QUEUED: "キュー待ち",
      SENDING: "送信中",
      SENT: "送信済み",
      FAILED: "失敗",
    },
    detail: {
      title: "メール詳細",
      recipient: "宛先",
      tenant: "テナント",
      status: "ステータス",
      subject: "件名",
      template: "テンプレート",
      attempts: "試行回数",
    },
    messages: {
      retryQueued: "メール送信を再度キューに追加しました",
    },
  },
  operatorOutbox: {
    filters: {
      allStatuses: "すべてのステータス",
      allChannels: "すべてのチャネル",
      tenantId: "テナント ID",
    },
    columns: {
      time: "時間",
      status: "ステータス",
      channel: "チャネル",
      eventType: "イベント種別",
      tenantId: "テナント ID",
      attempts: "試行回数",
      lastError: "直近エラー",
      actions: "操作",
    },
    actions: {
      retry: "再送",
      retrying: "再送中…",
    },
    statuses: {
      PENDING: "配信待ち",
      PROCESSING: "処理中",
      COMPLETED: "完了",
      DEAD: "デッドレター",
    },
    channels: {
      audit: "監査",
      webhook: "Webhook",
      email: "メール",
      notification: "通知",
      ai_call_log: "AI 呼び出しログ",
      report_log: "レポートログ",
      batch_event: "バッチイベント",
    },
    messages: {
      retried: "配信キューへ再投入しました",
      retryFailed: "Outbox メッセージの再送に失敗しました",
    },
  },
  operatorReports: {
    demo: {
      title: "レポート出力デモ",
      subtitle:
        "多言語テキスト、日付、金額、表、ネスト JSON を含むテスト PDF を生成します。",
      printButton: "テストレポートを出力",
      previewTitle: "テストデータプレビュー",
      previewHint:
        "この画面は概要のみです。PDF には画像 {images} 枚と明細 {rows} 行が含まれ、自動でページ分割されます。",
    },
    confirm: {
      title: "レポート出力の確認",
      description: "テスト PDF を生成し、現在の画面でプレビューします。",
      submit: "出力する",
    },
    preview: {
      title: "レポートプレビュー",
      description:
        "ページ移動、拡大縮小、ダウンロード、印刷に対応。全ページを連続表示します。",
    },
    messages: {
      generating: "レポートを生成しています...",
      printStarted: "レポートを生成しました",
    },
  },
  operatorImportDemo: {
    title: "一括インポートデモ",
    subtitle:
      "CSV/Excel をアップロードし、プレビュー確認後にバッチインポート。列選択エクスポートにも対応。",
    importButton: "一括インポート",
    exportButton: "データをエクスポート",
    requiredColumnsHint: "必須列: {columns}",
    recordsTitle: "インポート成功レコード",
    resultsTitle: "インポート結果明細",
    resultsHint:
      "インポート完了後、「明細を読み込む」で行単位の成功/失敗を確認できます。",
    loadResults: "明細を読み込む",
    importDialog: {
      title: "一括インポート",
      description:
        "CSV または Excel を選択し、プレビュー確認後にインポートします。",
      dropHint: "ファイルをドロップするか、下のボタンで選択してください",
      chooseFile: "ファイルを選択",
      previewTitle: "データプレビュー",
      previewCount: "先頭 {count} 行を表示",
      progress: "インポート進捗",
      missingColumns: "必須列が不足しています",
      submit: "インポート開始",
    },
    exportDialog: {
      title: "データをエクスポート",
      description: "エクスポートする列と形式を選択してください。",
      columns: "エクスポート列",
      selectAll: "すべて選択",
      deselectAll: "すべて解除",
      csv: "CSV をエクスポート",
      xlsx: "Excel をエクスポート",
    },
    resultTable: {
      rowNo: "行番号",
      status: "状態",
      error: "エラー",
      success: "成功",
      fail: "失敗",
      empty: "結果はまだありません",
    },
  },
  operatorReportLogs: {
    filters: {
      templateName: "テンプレート名",
      actor: "出力者",
      allStatuses: "すべてのステータス",
    },
    columns: {
      template: "テンプレート",
      fileName: "ファイル名",
      status: "ステータス",
      actor: "出力者",
      locale: "言語",
      duration: "所要時間",
      size: "サイズ",
      actions: "操作",
    },
    status: {
      PENDING: "処理中",
      SUCCEEDED: "成功",
      FAILED: "失敗",
    },
    detail: {
      title: "レポートログ詳細",
      dataSnapshot: "データスナップショット",
      downloadReprint: "再出力レポートをダウンロード",
      reprintLoading: "レポートを再出力しています...",
      reprintUnavailable:
        "成功済みでデータスナップショットが完全なログのみ再出力できます",
    },
    reprintConfirm: {
      title: "再出力の確認",
      description:
        "このログのデータスナップショットから PDF を再出力し、ダイアログでプレビューします。",
      submit: "再出力する",
    },
    reprintPreview: {
      title: "再出力レポートプレビュー",
      description:
        "ページ移動、拡大縮小、ダウンロード、印刷に対応。全ページを連続表示します。",
    },
    messages: {
      reprintStarted: "再出力レポートを生成しました",
    },
  },
  operatorEmailTemplates: {
    testEmail: {
      label: "テストメール",
      send: "テストメールを送信",
      hint: "メールはキューで非同期送信されます。レンダリング内容と最終ステータスはメールログで確認できます。",
      recipientRequired: "宛先メールアドレスを入力してください",
      queued: "送信キューに追加しました",
      queuedWithId: "送信キューに追加しました（{logId}）",
      sendFailed: "送信に失敗しました",
    },
    actions: {
      newTemplate: "テンプレートを作成",
      preview: "プレビュー",
      edit: "編集",
      add: "追加",
      delete: "削除",
      cancel: "キャンセル",
      save: "保存",
    },
    dialog: {
      createTitle: "テンプレートを作成",
      editTitle: "テンプレートを編集",
      previewTitle: "テンプレートプレビュー",
      formDescription: "基本情報、本文、差し込み項目を設定します。",
      previewDescription: "レンダリング後のメールをプレビューします。",
    },
    tabs: {
      basic: "基本情報",
      body: "本文",
      placeholders: "差し込み項目",
    },
    themes: {
      success: "成功",
      warning: "警告",
      error: "エラー",
      info: "情報",
    },
    fields: {
      language: "言語",
      name: "名前",
      subject: "メール件名",
      theme: "テーマ色",
      headerTitle: "ヘッダータイトル",
      headerSubtitle: "ヘッダーサブタイトル",
      greeting: "挨拶文",
      introText: "案内文",
      noticeText: "注意文",
      bodyHtml: "本文 HTML",
      customPlaceholders: "カスタム差し込み項目",
      displayName: "表示名",
      exampleValue: "サンプル値",
    },
    placeholders: {
      greeting: "{tenantPlaceholder} 様",
      customLabel: "注文番号",
      emptyCustom:
        "カスタム差し込み項目はまだありません。追加後、送信時に対応する variables を渡すと差し込めます。",
      requiredOnSend: "送信時に必須",
      tagList: "差し込み項目（クリックしてコピーし、左側の項目に貼り付け）",
      livePreview: "ライブプレビュー",
      previewLoading: "プレビューを読み込み中...",
      previewEmpty: "タイトルと件名を入力するとプレビューできます",
    },
    locales: {
      zh_CN: "中国語",
      ja_JP: "日本語",
      en_US: "英語",
    },
    previewExamples: {
      loginAccount: "ログインアカウント",
      loginTime: "ログイン日時",
    },
    validation: {
      keyRequired: "テンプレート Key を入力してください",
      nameRequired: "テンプレート名を入力してください",
      subjectRequired: "メール件名を入力してください",
      titleRequired: "ヘッダータイトルを入力してください",
      placeholderKeyRequired: "カスタム差し込み項目の Key は必須です",
      placeholderKeyInvalid: "差し込み項目 Key の形式が正しくありません: {key}",
      placeholderKeyBuiltinConflict:
        "差し込み項目 Key が組み込み項目と重複しています: {key}",
      placeholderKeyDuplicate: "差し込み項目 Key が重複しています: {key}",
    },
    messages: {
      updated: "テンプレートを更新しました",
      created: "テンプレートを作成しました",
      saveFailed: "保存に失敗しました",
    },
  },
  operatorPlans: {
    actions: {
      newPlan: "クォータプランを作成",
    },
    dialog: {
      createTitle: "クォータプランを作成",
      editTitle: "クォータプランを編集",
      formDescription:
        "クォータ上限、プラン種別、メニュー機能権限を設定します。",
    },
    fields: {
      name: "プラン名",
      description: "説明",
      planType: "プラン種別",
      maxUnits: "最大リソース利用量",
      maxApiCalls: "最大 API 呼び出し",
      maxStorageMb: "最大ストレージ容量 (MB)",
    },
    planTypes: {
      STANDARD: "通常プラン",
      TRIAL: "トライアルプラン",
    },
    statuses: {
      enabled: "有効",
      disabled: "無効",
    },
    card: {
      storage: "ストレージ",
      menus: "メニュー",
      tenants: "テナント",
      defaultAll: "既定ですべて",
    },
    empty: {
      noDescription: "説明なし",
    },
    hints: {
      blankUnlimited: "クォータ項目を空欄にすると無制限になります。",
    },
    errors: {
      nameRequired: "クォータプラン名を入力してください。",
    },
    unlimited: "無制限",
    delete: {
      title: "クォータプランを削除",
      description:
        "削除すると、紐づいているテナントからこのプランが解除されます。",
    },
    messages: {
      saved: "クォータプランを保存しました",
      created: "クォータプランを作成しました",
      saveFailed: "クォータプランの保存に失敗しました",
      deleted: "クォータプランを削除しました",
      deleteFailed: "クォータプランの削除に失敗しました",
    },
  },
  operatorTenantHealth: {
    title: "ヘルス",
    description:
      "テナントヘルス概要：使用量、サブスクリプション、督促、フィードバック、Outbox ステータス。",
    evaluatedAt: "評価日時",
    statuses: {
      healthy: "正常",
      warning: "警告",
      critical: "重大",
      unknown: "不明",
    },
    alerts: {
      title: "アラート",
      none: "アラートなし",
    },
    subscription: {
      title: "サブスクリプション",
      status: "ステータス",
      plan: "プラン",
      periodEnd: "期間終了",
    },
    usage: {
      title: "使用量",
      units: "ユニット",
      apiCalls: "API 呼び出し",
      storageMb: "ストレージ (MB)",
    },
    dunning: {
      title: "督促",
    },
    feedback: {
      unread: "未読フィードバック",
    },
    outbox: {
      dead: "デッドレター",
    },
  },
  operatorTenants: {
    filters: {
      searchPlaceholder: "テナント名またはスラッグを検索",
      allStatuses: "すべてのステータス",
    },
    columns: {
      tenant: "テナント",
      status: "ステータス",
      quotaPlan: "クォータプラン",
      actions: "操作",
      role: "ロール",
    },
    statuses: {
      ACTIVE: "有効",
      SUSPENDED: "停止",
      DELETED: "削除済み",
    },
    userStatuses: {
      ACTIVE: "有効",
      INACTIVE: "停止",
      DELETED: "削除済み",
    },
    quotaPlan: {
      unset: "未設定",
    },
    actions: {
      openTenant: "テナントを開設",
      accounts: "アカウント",
      features: "機能",
      impersonate: "代運営",
      open: "開設",
      addAccount: "アカウントを追加",
      resetPassword: "パスワードを再設定",
      suspendAccount: "アカウントを停止",
      activateAccount: "アカウントを有効化",
    },
    impersonate: {
      failed: "代運営の開始に失敗しました",
      success: "代運営モードに入りました",
      inactiveTenant: "有効なテナントのみ代運営できます",
    },
    dialog: {
      openTenant: "テナントを開設",
      editTenant: "テナントを編集",
      openTenantDescription:
        "テナントの基本情報を入力し、最初の管理者アカウントを作成します。",
      editTenantDescription:
        "テナント名、ステータス、クォータプラン、ブランド設定を変更します。",
      features: "機能スイッチ",
      featuresFor: "{name} · 機能スイッチ",
      featuresDescription:
        "テナントが利用できるメニューと機能スイッチを設定します。",
      accounts: "アカウント管理",
      accountsFor: "{name} · アカウント管理",
      accountsDescription:
        "テナントメンバーのアカウントを管理し、新規アカウントを追加します。",
    },
    fields: {
      tenantName: "テナント名",
      tenantSlug: "テナントスラッグ",
      adminEmail: "管理者メール",
      adminPassword: "管理者パスワード",
      email: "メール",
      name: "氏名",
      initialPassword: "初期パスワード",
      newPassword: "新しいパスワード",
      logo: "サイドバー Logo",
    },
    logo: {
      upload: "Logo をアップロード",
      uploading: "アップロード中...",
      reset: "デフォルトに戻す",
      cropTitle: "Logo をトリミング",
      confirmCrop: "トリミングを適用",
      zoom: "ズーム",
      hint: "PNG / JPEG / WebP / SVG、最大 2MB。ビットマップは正方形にトリミング、SVG はそのままアップロードします。",
      saveTenantFirst:
        "Logo をアップロードする前にテナントを保存してください。",
      invalidType: "PNG、JPEG、WebP、SVG のみ対応しています",
      tooLarge: "画像サイズは 2MB 以下にしてください",
      invalidImage:
        "画像を読み込めません。ファイルが破損していないか、形式が正しいか確認してください。",
      emptyFile: "ファイルが空です。有効な画像を選択してください。",
      uploadFailed: "Logo のアップロードに失敗しました",
      uploaded:
        "Logo をアップロードしました。テナントを保存すると反映されます。",
    },
    errors: {
      nameRequired: "テナント名を入力してください",
      slugRequired: "テナントスラッグを入力してください",
      adminEmailRequired: "管理者メールを入力してください",
      adminPasswordRequired: "管理者パスワードを入力してください",
      emailRequired: "メールを入力してください",
      userNameRequired: "氏名を入力してください",
      initialPasswordRequired: "初期パスワードを入力してください",
      roleRequired: "ロールを選択してください",
      passwordMinLength: "パスワードは8文字以上にしてください",
    },
    messages: {
      tenantSaved: "テナントを保存しました",
      tenantOpened: "テナントを開設しました",
      tenantSaveFailed: "テナントの保存に失敗しました",
      featuresUpdated: "テナント機能を更新しました",
      featuresSaveFailed: "機能設定の保存に失敗しました",
      accountCreated: "アカウントを作成しました",
      accountCreateFailed: "アカウントの作成に失敗しました",
      passwordReset: "パスワードを再設定しました",
      passwordResetFailed: "パスワードの再設定に失敗しました",
      accountSuspended: "アカウントを停止しました",
      accountActivated: "アカウントを有効化しました",
      accountStatusFailed: "アカウント状態の更新に失敗しました",
    },
    confirm: {
      suspendAccountTitle: "アカウントを停止しますか",
      suspendAccountDescription: "{name} はログインできなくなります。",
    },
  },
  operatorFeatureFlags: {
    filters: {
      includeArchived: "アーカイブ済みを含む",
      environmentAll: "すべての環境",
      environmentUnrestricted: "制限なし",
      statusAll: "すべてのステータス",
    },
    columns: {
      key: "Key",
      name: "名称",
      status: "ステータス",
      defaultValue: "デフォルト値",
      rollout: "段階リリース",
      environments: "環境制限",
      overrides: "オーバーライド数",
      actions: "操作",
    },
    overrideColumns: {
      scopeType: "対象",
      scopeId: "対象 ID",
      value: "値",
      reason: "理由",
      actions: "操作",
    },
    actions: {
      create: "機能フラグを作成",
      overrides: "オーバーライド管理",
      archive: "アーカイブ",
      evaluate: "評価デバッグ",
      runEvaluate: "評価を実行",
      evaluating: "評価中…",
    },
    evaluate: {
      title: "評価デバッグ",
      description:
        "テナント／ユーザーと環境を指定して機能フラグの判定結果を模擬します。設定は変更されません。",
      loadHint:
        "パラメータを入力して「評価を実行」してください（ページ表示時には自動リクエストしません）。",
      reason: "判定理由",
      rolloutBucket: "ロールアウトバケット",
      flagId: "フラグ ID",
    },
    evaluateReasons: {
      not_found: "未検出",
      archived: "アーカイブ済み",
      disabled: "無効",
      environment: "環境不一致",
      user_override: "ユーザー上書き",
      tenant_override: "テナント上書き",
      default: "デフォルト値",
      rollout: "パーセントロールアウト",
    },
    dialog: {
      createTitle: "機能フラグを作成",
      createDescription:
        "段階リリース、デフォルト値、環境制御を設定します。名称と説明は日本語で記入してください。",
      editTitle: "機能フラグを編集",
      editDescription:
        "「テナント機能メニュー」とは別に、実行時の挙動を管理します。",
    },
    overrideDialog: {
      title: "オーバーライド管理 · {key}",
      description:
        "テナントまたはユーザー単位で機能フラグの判定を上書きします。",
    },
    fields: {
      key: "フラグ Key",
      name: "名称",
      namePlaceholder: "例: 銀行証憑リンク",
      nameLocaleHint: "名称と説明は日本語で記入してください。",
      description: "説明",
      descriptionPlaceholder:
        "例: 銀行明細と証憑候補の紐付け・確認を有効化する。",
      rolloutPercentage: "段階リリース率 (0-100)",
      environments: "環境制限",
      environmentsPlaceholder: "例: production, staging",
      isEnabled: "この Flag を有効化",
      defaultValue: "デフォルト値を有効にする",
      scopeType: "対象種別",
      scopeId: "対象 ID（UUID）",
      scopeIdPlaceholder: "テナントまたはユーザー UUID を入力",
      overrideEnabled: "上書き値を有効にする",
      overrideReason: "上書き理由",
      evaluateEnvironment: "環境",
      evaluateEnvironmentPlaceholder: "例: production",
      evaluateTenantId: "テナント ID（任意）",
      evaluateUserId: "ユーザー ID（任意）",
    },
    scope: {
      tenant: "テナント",
      user: "ユーザー",
    },
    status: {
      enabled: "有効",
      disabled: "無効",
      archived: "アーカイブ済み",
    },
    empty: "機能フラグはまだありません",
    emptyDescription:
      "最初の実行時スイッチを作成すると、段階リリース、デフォルト値、オーバーライドをここで管理できます。",
    overrideEmpty: "オーバーライドはまだありません",
    errors: {
      keyRequired: "フラグ Key を入力してください",
      nameRequired: "名称を入力してください",
      rolloutRange: "段階リリース率は 0 から 100 の範囲で入力してください",
      scopeIdRequired: "対象 ID を入力してください",
    },
    confirm: {
      archiveTitle: "機能フラグ「{key}」をアーカイブしますか？",
      archiveDescription:
        "アーカイブ後は評価対象から外れますが、履歴は保持されます。",
    },
    messages: {
      loadFailed: "機能フラグを読み込めません",
      loadFailedDescription:
        "ログイン状態またはネットワーク接続を確認して再試行してください。",
      created: "機能フラグを作成しました",
      updated: "機能フラグを更新しました",
      saveFailed: "機能フラグの保存に失敗しました",
      archived: "機能フラグをアーカイブしました",
      archiveFailed: "機能フラグのアーカイブに失敗しました",
      overrideSaved: "オーバーライドを保存しました",
      overrideSaveFailed: "オーバーライドの保存に失敗しました",
      overrideCleared: "オーバーライドを削除しました",
      overrideClearFailed: "オーバーライドの削除に失敗しました",
      evaluateFailed: "機能フラグの評価に失敗しました",
    },
  },
  operatorOverview: {
    header: {
      thisMonth: "今月 {range}",
      rangeSeparator: "から",
    },
    metrics: {
      tenantTotal: "テナント総数",
      tenantHelper: "{active} 件有効、{suspended} 件停止",
      monthlyUnits: "今月のリソース利用量",
      unitsHelper: "累計 {total} 件",
      monthlyApiCalls: "今月の API 呼び出し",
      apiCallsHelper: "ストレージスナップショット {storage}",
      monthlyCost: "推計コスト",
      costHelper: "平均 {average} / AI 回 · Gemini トークン単価",
      documents: "伝票数",
      documentsHelper: "今月作成（UTC）",
      aiRequests: "AI リクエスト数",
      aiRequestsHelper: "今月の ai_call_log（UTC）",
      tokens: "トークン",
      tokensHelper: "入力 {input} / 出力 {output}",
      feedbackHelper: "{unread} 件未読、今月 {month} 件",
    },
    health: {
      title: "プラットフォーム状態",
      description: "テナント状態、API 配信、メール送信",
      activeTenantRate: "テナント有効率",
      activeTenantDetail: "{active} / {total} テナントが有効",
      apiUsage: "API 利用",
      emailSending: "メール送信",
      recentFailures: "直近の失敗 {count} 件",
      loadHint: "配信失敗を確認するには先に直近のリスクを読み込んでください",
    },
    feedback: {
      title: "ユーザーフィードバック",
      summary: "{open} 件対応待ち · {unread} 件未読",
      total: "累計フィードバック",
      monthlyNew: "今月の新規",
      open: "対応待ち",
      noUnread: "未読フィードバックはありません",
    },
    quick: {
      title: "クイックリンク",
      description: "よく使う運用操作",
      openTenant: "テナントを開設",
      userFeedback: "ユーザーフィードバック",
      configurePlans: "プラン設定",
      viewUsage: "利用状況を表示",
      auditLogs: "監査ログ",
      emailTemplates: "メールテンプレート",
      webhookLogs: "Webhookログ",
    },
    usage: {
      title: "今月の利用ランキング",
      description: "コスト順のテナント利用状況",
      empty: "今月の利用状況はありません",
    },
    risks: {
      title: "直近のリスク",
      description: "Webhook とメールの異常",
      itemCount: "{count} 件",
      empty: "直近の異常ログはありません",
      loadHint:
        "直近の Webhook とメール異常は、初期表示を軽く保つため明示操作後に読み込みます。",
      webhookType: "Webhook",
      emailType: "メール",
      emailFailed: "送信に失敗しました",
    },
    focus: {
      title: "運用注視ポイント",
      description: "優先して確認すべき指標",
      planCoverage: "プラン適用状況",
      planCoverageDetail: "{covered} / {total} テナントにプランが設定済み",
      costConcentration: "コスト集中度",
      costConcentrationDetail:
        "{tenant} が今月コストの {percent} を占めています",
      noCostRecords: "コスト記録はありません",
      feedbackDetail: "{unread} 件未読、{open} 件対応待ち",
      incidentHandling: "異常対応",
      incidentDetail: "直近の異常 {count} 件を確認してください",
      incidentPendingDetail:
        "異常対応の状態を評価する前に直近のリスクを読み込んでください。",
    },
    units: {
      apiCallsWithCount: "{count} 回 API 呼び出し",
      unitsWithCount: "{count} 件のリソース",
      documentsWithCount: "{count} 件の伝票",
      tokensWithCount: "{count} トークン",
    },
    badges: {
      normal: "正常",
      watch: "要確認",
      pending: "対応待ち",
      incomplete: "未完了",
      notLoaded: "未読込",
    },
    actions: {
      loadRisks: "直近のリスクを読み込む",
    },
    fallback: {
      unknownTenant: "不明なテナント",
      event: "イベント",
      noResponse: "応答なし",
      platform: "プラットフォーム",
      recipient: "宛先",
    },
    messages: {
      loadFailed: "運用サマリーの読み込みに失敗しました",
    },
  },
  operatorOps: {
    header: {
      generatedAt: "更新時刻：{time}",
    },
    processes: {
      api: "API プロセス",
      worker: "Worker プロセス",
      scheduler: "Scheduler プロセス",
      lastBeat: "最終ハートビート {time}",
      noHeartbeat: "ハートビートなし",
    },
    dependencies: {
      title: "依存接続",
      description:
        "DB・キャッシュ・オブジェクトストレージ・キュー（機密情報なし）",
      mysql: "MySQL",
      redis: "Redis",
      objectStorage: "オブジェクトストレージ",
      queue: "ジョブキュー",
      latency: "遅延 {ms} ms",
      provider: "プロバイダ {provider}",
    },
    queues: {
      title: "キュー滞留",
      description: "キューごとの待機・実行中・失敗ジョブ数",
      waiting: "待機 {count}",
      active: "実行 {count}",
      failed: "失敗 {count}",
      empty: "キューデータなし",
    },
    outbox: {
      title: "Outbox 状態",
      description: "非同期メッセージ配送の概要",
      pending: "待機",
      processing: "処理中",
      completed: "完了",
      dead: "デッド",
    },
    failedJobs: {
      title: "失敗ジョブ",
      description: "各キューの最近の失敗ジョブ",
      empty: "失敗ジョブなし",
    },
    recentErrors: {
      title: "最近のエラー",
      description: "過去 24 時間の HTTP エラー概要",
      empty: "エラーなし",
    },
    slowEndpoints: {
      title: "遅いエンドポイント",
      description: "DB 時間またはクエリ数が高い API Key ルート",
      summary:
        "{count} リクエスト · 平均 DB {avgDb} ms · 平均クエリ {avgQueries}",
      empty: "遅いエンドポイントなし",
    },
    highErrorEndpoints: {
      title: "高エラー率エンドポイント",
      description: "過去 24 時間でエラー率 ≥ 10% の API Key ルート",
      summary: "{count} リクエスト · {errors} エラー · 率 {rate}",
      empty: "高エラー率エンドポイントなし",
    },
    statuses: {
      up: "正常",
      down: "異常",
      unknown: "不明",
      ready: "準備完了",
      not_ready: "未準備",
      ok: "正常",
    },
    messages: {
      loadFailed: "運用ダッシュボードの読み込みに失敗しました",
    },
  },
  operatorBackups: {
    backups: {
      title: "MySQL 暗号化バックアップ",
    },
    deletions: {
      title: "データ削除申請",
    },
    columns: {
      time: "日時",
      status: "ステータス",
      size: "サイズ",
      backupFile: "バックアップファイル",
      checksum: "チェックサム",
      actions: "操作",
      resource: "リソース",
      tenant: "テナント",
      executionTime: "実行日時",
      step: "ステップ",
    },
    actions: {
      runBackup: "今すぐバックアップ",
      download: "ダウンロード",
      encryptedVersion: "暗号化版 (.age)",
      decryptedVersion: "復号版 (.tar.gz)",
      restoreDatabase: "データベースを復元",
      restoreDrill: "復元演習",
      confirmRestore: "復元を確認",
      restore: "復元",
      deleteNow: "今すぐ削除",
      retry: "再試行",
    },
    backupStatuses: {
      PENDING: "実行待ち",
      RUNNING: "実行中",
      COMPLETED: "完了",
      FAILED: "失敗",
    },
    deletionStatuses: {
      PENDING: "削除待ち",
      CANCELED: "復元済み",
      PROCESSING: "削除中",
      COMPLETED: "削除済み",
      FAILED: "失敗",
    },
    hints: {
      requiresAgeIdentityFile:
        "backend/.env に AGE_IDENTITY_FILE を設定してください",
      requiresAgeIdentity: "AGE_IDENTITY_FILE の設定が必要です",
      drillSafe: "隔離コンテナでバックアップを検証し、本番データは変更しません",
    },
    empty: {
      noBackups: "バックアップ記録はありません",
      noDeletionRequests: "削除申請はありません",
    },
    fallback: {
      thisBackup: "このバックアップ",
    },
    confirm: {
      restoreTitle: "データベースを復元",
      restoreDescription:
        "現在の MySQL データベースをバックアップで上書きします。この操作は元に戻せません。\n\nバックアップファイル: {fileName}",
      deleteBackupTitle: "バックアップを削除",
      deleteBackupDescription:
        "このバックアップファイルを削除しますか？\n{fileName}",
      restoreDeletionTitle: "削除申請を復元",
      restoreDeletionDescription:
        "この削除申請を取り消します。関連リソースは削除されません。",
      executeDeletionTitle: "今すぐ削除",
      executeDeletionDescription:
        "待機期間をスキップしてデータ削除を即時実行します。この操作は元に戻せません。",
    },
    messages: {
      backupCompleted: "バックアップが完了しました",
      backupFailed: "バックアップに失敗しました",
      drillCompleted:
        "復元演習が完了しました（本番データベースは変更していません）",
      drillFailed: "復元演習に失敗しました",
      databaseRestored:
        ".env の DATABASE_URL に設定されたデータベースへ復元しました。ページを更新してください",
      databaseRestoreFailed: "データベースの復元に失敗しました",
      missingAgeIdentity:
        "AGE_IDENTITY_FILE が未設定のため、復号版をダウンロードできません",
      encryptedDownloadStarted:
        "暗号化バックアップのダウンロードを開始しました",
      decryptedDownloadStarted: "復号バックアップのダウンロードを開始しました",
      downloadFailed: "ダウンロードに失敗しました",
      backupDeleted: "バックアップを削除しました",
      deleteFailed: "削除に失敗しました",
      deletionRestored: "削除申請を復元しました",
      restoreFailed: "復元に失敗しました",
      deletionSubmitted: "削除ジョブを送信しました",
      submitFailed: "送信に失敗しました",
      deletionRetried: "削除ジョブを再試行しました",
      retryFailed: "再試行に失敗しました",
    },
  },
  operatorAi: {
    metrics: {
      providers: "Provider 数",
      models: "モデル数",
      prompts: "プロンプト数",
    },
    providers: {
      title: "Provider 設定",
      description: "モデル Provider、API Key、接続状態を一元管理します。",
    },
    models: {
      title: "モデルプロファイル",
      description:
        "デフォルトモデル、能力種別、呼び出しパラメータを定義します。",
    },
    prompts: {
      title: "プロンプトテンプレート",
      description:
        "安定した key で業務プロンプト、変数、公開バージョンを管理します。",
    },
    logs: {
      title: "呼び出しログ",
      description:
        "実際の provider、model、token、所要時間、失敗概要を記録します。",
      loadHint:
        "初期表示を軽く保つため、呼び出しログは明示操作後にのみ読み込みます。",
    },
    fields: {
      name: "名称",
      providerType: "Provider 種別",
      baseUrl: "Base URL",
      apiKey: "API Key",
      enabled: "有効",
      provider: "Provider",
      model: "モデル",
      capability: "能力",
      temperature: "温度",
      defaultModel: "デフォルトモデル",
      promptKey: "Prompt Key",
      purpose: "用途",
      systemPrompt: "System Prompt",
      userPrompt: "User Prompt",
      variablesSchema: "変数 Schema",
      outputSchema: "出力 Schema",
      status: "状態",
      tokens: "Tokens",
      duration: "所要時間",
    },
    hints: {
      apiKey:
        "保存後に平文は再表示されません。一覧にはマスク済みの末尾のみ表示します。",
    },
    providerTypes: {
      OPENAI_COMPATIBLE: "OpenAI 互換",
      ANTHROPIC_COMPATIBLE: "Anthropic 互換",
      PRIVATE_GATEWAY: "プライベートゲートウェイ",
    },
    capabilities: {
      TEXT: "テキスト",
      JSON: "JSON",
      EMBEDDING: "埋め込み",
    },
    healthStatuses: {
      UNKNOWN: "不明",
      HEALTHY: "正常",
      UNHEALTHY: "異常",
    },
    promptVersionStatuses: {
      DRAFT: "下書き",
      PUBLISHED: "公開済み",
      ARCHIVED: "アーカイブ済み",
    },
    callStatuses: {
      SUCCESS: "成功",
      FAILED: "失敗",
    },
    placeholders: {
      selectProvider: "Provider を選択",
    },
    actions: {
      test: "接続テスト",
      publish: "公開",
      loadLogs: "呼び出しログを読み込む",
    },
    status: {
      default: "デフォルト",
      available: "利用可能",
      published: "公開済み",
      draft: "下書き",
    },
    empty: {
      providers: "Provider はまだありません",
      models: "モデルはまだありません",
      prompts: "プロンプトはまだありません",
      logs: "呼び出しログはありません",
      noApiKey: "API Key 未設定",
      noPurpose: "用途未設定",
    },
    messages: {
      providerCreated: "Provider を作成しました",
      providerSaved: "Provider を保存しました",
      providerHealthy: "Provider に接続できます",
      providerUnhealthy: "Provider に接続できません",
      modelCreated: "モデルを作成しました",
      modelSaved: "モデルを保存しました",
      promptCreated: "プロンプトを作成しました",
      promptSaved: "プロンプトを保存しました",
      promptPublished: "プロンプトを公開しました",
      saveFailed: "保存に失敗しました",
    },
  },
  operatorSystemSettings: {
    title: "プラットフォーム設定",
    description: "運用側のグローバル設定です。保存後すぐに反映されます。",
    fields: {
      feedbackNotifyEmail: "フィードバック通知先メール",
      auditLogRetentionDays: "監査ログ保持日数",
      apiRequestLogRetentionDays: "API リクエストログ保持日数",
      reportLogRetentionDays: "レポートログ保持日数",
      batchAuditLogRetentionDays: "バッチ監査ログ保持日数",
      webhookLogRetentionDays: "Webhook 配信ログ保持日数",
      emailLogRetentionDays: "メールログ保持日数",
      aiCallLogRetentionDays: "AI 呼び出しログ保持日数",
      logRetentionArchiveEnabled: "削除前にオブジェクトストレージへアーカイブ",
    },
    logRetention: {
      title: "ログ保持ポリシー",
      description:
        "各種プラットフォームログの保持日数とアーカイブを一元設定します。scheduler で毎日 04:00 にクリーンアップされます。",
    },
    hints: {
      feedbackNotifyEmail:
        "テナントが新しいフィードバックを送信すると、ここに設定したメールアドレスへ通知します。1行に1件、またはカンマ区切りで入力してください。空欄の場合は送信しません。",
      auditLogRetentionDays:
        "指定日数を超えた AuditLog を削除します。既定値は 365 日です。",
      apiRequestLogRetentionDays:
        "指定日数を超えた ApiRequestLog を削除します。既定値は 90 日です。",
      reportLogRetentionDays:
        "指定日数を超えた ReportLog を削除します。既定値は 180 日です。",
      batchAuditLogRetentionDays:
        "指定日数を超えた BatchAuditLog を削除します。既定値は 180 日です。",
      webhookLogRetentionDays:
        "指定日数を超えた WebhookLog を削除します。既定値は 90 日です。",
      emailLogRetentionDays:
        "指定日数を超えた EmailLog を削除します。既定値は 180 日です。",
      aiCallLogRetentionDays:
        "指定日数を超えた AiCallLog を削除します。既定値は 90 日です。",
      logRetentionArchiveEnabled:
        "有効時、削除前に NDJSON を gzip 圧縮してオブジェクトストレージへ保存します（S3 設定が必要）。",
    },
    lastUpdated: "最終更新: {time}",
    saving: "保存中...",
    save: "設定を保存",
    validation: {
      retentionDaysRange: "1 から 3650 の範囲で入力してください",
    },
    messages: {
      saved: "プラットフォーム設定を保存しました",
      saveFailed: "保存に失敗しました",
    },
    lineChannelBinding: {
      title: "LINE プラットフォーム Bot（line_channel_binding）",
      description:
        "サーバー環境変数から共有 LINE Bot バインディングを冪等に登録し、Webhook 署名検証とルーティングに使用します。Secret/Token はブラウザに表示・保存しません。",
      statusActive: "登録済み",
      statusMissing: "未登録",
      webhookUrl: "Webhook URL",
      envReady: "設定済み",
      envMissing: "未設定",
      bindingId: "Binding ID: {value}",
      destination: "Destination（マスク）: {value}",
      channelId: "Channel ID: {value}",
      lastUpdated: "最終更新: {time}",
      bootstrap: "LINE Bot バインディングを登録 / 更新",
      bootstrapping: "書き込み中...",
      loadFailed: "LINE バインディング状態の読み込みに失敗しました",
      messages: {
        created: "LINE Bot バインディングを作成しました",
        updated: "LINE Bot バインディングを更新しました（冪等）",
        failed: "LINE Bot バインディングの書き込みに失敗しました",
      },
    },
  },
  operatorBilling: {
    subscriptions: {
      title: "テナント契約",
      cancelAtPeriodEnd: "期間終了時に解約",
    },
    invoices: {
      title: "請求書",
    },
    planVersions: {
      title: "公開済みプランバージョン",
      month: "月",
    },
    columns: {
      tenant: "テナント",
      planVersion: "プランバージョン",
      status: "ステータス",
      periodEnd: "期間終了日",
      actions: "操作",
      amountPaid: "入金済み",
    },
    actions: {
      generateInvoice: "請求書を生成",
      resume: "再開",
      suspend: "停止",
      cancelAtPeriodEnd: "期間終了時に解約",
      startCheckout: "Stripe 決済を開始",
    },
    subscriptionStatuses: {
      TRIALING: "トライアル中",
      ACTIVE: "有効",
      PAST_DUE: "支払期限超過",
      SUSPENDED: "停止中",
      CANCELED: "解約済み",
    },
    invoiceStatuses: {
      DRAFT: "下書き",
      OPEN: "未払い",
      PAID: "支払い済み",
      OVERDUE: "期限超過",
      VOID: "無効",
    },
    messages: {
      invoiceCreated: "請求書を生成しました",
      invoiceCreateFailed: "請求書の生成に失敗しました",
      resume: "契約を再開しました",
      "suspend-now": "契約を停止しました",
      "cancel-at-period-end": "期間終了時の解約を設定しました",
      statusUpdateFailed: "契約ステータスの更新に失敗しました",
      checkoutCreated: "Stripe Checkout を開きました",
      checkoutFailed: "Stripe 決済の開始に失敗しました",
    },
  },
  operatorBillingEnhancements: {
    common: {
      tenantId: "テナント ID",
      tenantIdPlaceholder: "テナント UUID を入力",
      loadContext: "契約コンテキストを読込",
      openBilling: "課金ページを開く",
      optional: "任意",
      selectSubscription: "契約を選択",
      selectPlanVersion: "対象プランバージョンを選択",
    },
    coupon: {
      title: "クーポン検証 / 交換",
      description:
        "指定テナントでクーポン割引を検証し、トライアルや請求減額に交換できます。",
      redeemBoundary:
        "境界：交換は記録のみです。即時の価格・請求への反映は後続の課金/決済フロー次第で、契約単価は自動変更されません。",
      code: "クーポンコード",
      amountMinor: "金額（最小通貨単位）",
      currency: "通貨",
      subscriptionId: "契約 ID（交換時任意）",
      validate: "検証",
      redeem: "交換",
    },
    simulation: {
      title: "プラン変更シミュレーション",
      description:
        "proration 差額をプレビューします。永続化しても実契約は変更しません。",
      subscriptionId: "契約",
      targetPlanVersionId: "対象プランバージョン",
      effectiveAt: "適用日時（任意）",
      persist: "シミュレーション記録を保存",
      run: "実行",
      changeType: "変更種別",
      prorationCharge: "按分請求（最小単位）",
      prorationCredit: "按分控除（最小単位）",
      netAmount: "純額（最小単位）",
    },
    dunning: {
      title: "督促（Dunning）状態",
      description:
        "期限超過請求と督促段階を評価し、OPEN/OVERDUE 請求書および PAST_DUE 契約と関連付けます。",
      refresh: "状態を更新",
      empty: "このテナントには契約、または評価可能な督促状態がありません。",
      status: "ステータス",
      daysPastDue: "延滞日数",
      overdueInvoice: "関連する延滞請求",
      nextActionAt: "次回アクション日時",
      pastDueSubscriptions: "PAST_DUE 契約",
      openBillingToResume: "課金ページで契約を手動再開",
      collectableInvoices: "回収可能な請求（OPEN / OVERDUE）",
      noCollectableInvoices: "未払い残高のある OPEN/OVERDUE 請求はありません。",
      invoiceNumber: "請求書番号",
      invoiceStatus: "ステータス",
      amountDue: "未払い額（最小単位）",
      actions: "操作",
      collectPayment: "決済を開始",
      linkedToDunning: "督促リンク",
      statuses: {
        NONE: "なし",
        REMINDER_1: "リマインド 1",
        REMINDER_2: "リマインド 2",
        FINAL_NOTICE: "最終通知",
        ESCALATED: "エスカレーション済",
      },
    },
    messages: {
      tenantRequired: "先にテナント ID を入力してください",
      contextLoaded:
        "契約 {subscriptions} 件（PAST_DUE {pastDue}）、プランバージョン {plans} 件、請求 {invoices} 件（回収可 {openOrOverdue}）を読み込みました",
      contextLoadFailed: "契約コンテキストの読込に失敗しました",
      couponCodeRequired: "クーポンコードを入力してください",
      couponValidated: "クーポンを検証しました",
      couponValidateFailed: "クーポン検証に失敗しました",
      couponRedeemed:
        "クーポン交換を記録しました（価格は自動変更されません。後続の課金/決済フロー次第です）",
      couponRedeemFailed: "クーポン交換に失敗しました",
      simulationRequired: "契約と対象プランバージョンを選択してください",
      simulationDone: "プラン変更シミュレーションが完了しました",
      simulationFailed: "プラン変更シミュレーションに失敗しました",
      dunningFailed: "督促状態の読込に失敗しました",
      checkoutCreated: "Stripe Checkout を開きました",
      checkoutFailed: "決済の開始に失敗しました",
    },
  },
  operatorTrialApplications: {
    filters: {
      searchPlaceholder: "企業、担当者、メールで検索",
      allStatuses: "すべてのステータス",
    },
    columns: {
      organization: "企業",
      contact: "担当者",
      expectedUnits: "想定月間利用量",
      status: "ステータス",
      submittedAt: "申請日時",
      actions: "操作",
    },
    actions: {
      details: "詳細",
      approve: "承認",
      reject: "却下",
    },
    empty: "トライアル申請はありません",
    statuses: {
      PENDING: "審査待ち",
      APPROVED: "承認済み",
      REJECTED: "却下済み",
      CANCELED: "キャンセル済み",
    },
    detail: {
      title: "トライアル申請詳細",
      description: "申請者が提出した企業情報と連絡先を確認します。",
      organization: "企業",
      contact: "担当者",
      email: "メール",
      phone: "電話番号",
      useCase: "利用シーン",
      notes: "備考",
    },
    approve: {
      title: "トライアル申請を承認",
      description:
        "トライアルプランと終了日を選択し、トライアルテナントを開通します。",
      trialPlan: "トライアルプラン",
      selectPlaceholder: "選択してください",
      trialEndsAt: "トライアル終了日",
      tenantSlug: "テナント識別子（任意）",
      tenantSlugPlaceholder: "企業名から自動生成",
      confirm: "承認して開通",
    },
    reject: {
      title: "トライアル申請を却下",
      description: "却下理由を入力します。申請者へ通知メールが送信されます。",
      reason: "却下理由",
      confirm: "却下を確定",
    },
    messages: {
      approveSuccess: "トライアルテナントを開通し、招待メールを送信しました",
      approveFailed: "トライアルテナントの開通に失敗しました",
      trialPlanRequired: "トライアルプランを選択してください",
      trialEndsAtRequired: "トライアル終了日を選択してください",
      rejectReasonRequired: "却下理由を入力してください",
      rejectSuccess: "申請を却下し、通知を送信しました",
      rejectFailed: "操作に失敗しました",
    },
  },
  dashboardPage: {
    title: "ダッシュボード",
    noWorkspaceTitle: "ワークスペースが選択されていません",
    noWorkspaceDescription:
      "作業を始める前にワークスペースを選択してください。",
    openWorkspaces: "ワークスペースを開く",
    viewBilling: "請求を見る",
    kpis: {
      pendingDocumentReview: "確認待ち伝票",
      pendingDocumentReviewHelper: "レビューが必要な受信伝票",
      unlinkedBankEvidence: "未照合の銀行明細",
      unlinkedBankEvidenceHelper: "伝票と未照合の出金明細",
      pendingJournalReview: "レビュー待ち仕訳",
      pendingJournalReviewHelper: "レビュー受信箱の未処理",
      confirmedDocumentsThisMonth: "今月の確認済み伝票",
      confirmedDocumentsThisMonthHelper: "今月承認された伝票数（JST）",
    },
    actions: {
      title: "要対応",
      description: "いま処理すべき作業",
      empty: "現在、対応が必要な事項はありません。",
      pendingDocumentReview: "確認待ち伝票を処理",
      unlinkedBankEvidence: "銀行明細を照合",
      pendingJournalReview: "仕訳レビューを処理",
    },
    recentImports: {
      title: "最近の銀行明細インポート",
      description: "直近のインポート状況",
      empty: "最近のインポートはありません。",
    },
    platform: {
      title: "テナント設定",
      description: "請求・メンバー・連携の概要",
      manageMembers: "メンバーを管理",
      manageWebhooks: "Webhook を管理",
    },
    errors: {
      loadFailed: "ダッシュボードの読み込みに失敗しました。",
    },
  },
  webhooksPage: {
    createWebhook: "Webhook を作成",
    createFirstWebhook: "最初の Webhook を作成",
    empty: "Webhook はまだありません",
    enabled: "有効",
    disabled: "無効",
    test: "テスト",
    logs: "ログ",
    logsTitle: "Webhook ログ",
    logsDescription:
      "この Webhook の配信履歴を確認し、失敗したリクエストを再試行できます。",
    editTitle: "Webhook を編集",
    createTitle: "Webhook を作成",
    createDescription:
      "Webhook 名、コールバック URL、トリガーイベント、カスタム Headers を設定します。",
    editDescription:
      "Webhook 設定を変更します。Secret を空欄のままにすると既存値を保持します。",
    name: "名称",
    callbackUrl: "コールバック URL",
    secretPlaceholder:
      "空欄の場合は自動生成されます。編集時に空欄のままにすると既存値を変更しません",
    triggerEvents: "トリガーイベント",
    customHeaders: "カスタム Headers（JSON）",
    enableWebhook: "Webhook を有効化",
    saving: "保存中...",
    event: "イベント",
    eventsColumn: "イベント",
    status: "状態",
    time: "日時",
    actions: "操作",
    retry: "再試行",
    details: "詳細",
    noLogs: "ログはまだありません",
    detailTitle: "Webhook 詳細",
    detailDescription: "Webhook の設定内容とトリガーイベントを確認します。",
    testResultTitle: "Webhook テスト結果",
    testResultDescription:
      "テストリクエストの応答ステータスと返却内容を確認します。",
    logDetailTitle: "Webhook ログ詳細",
    logDetailDescription: "単一配信のリクエストとレスポンス詳細を確認します。",
    saved: "Webhook を保存しました",
    created: "Webhook を作成しました",
    saveFailed: "Webhook の保存に失敗しました",
    deleteTitle: "Webhook を削除",
    deleteDescription: "この Webhook を削除しますか？",
    deleted: "Webhook を削除しました",
    deleteFailed: "Webhook の削除に失敗しました",
    testSuccess:
      "テストに成功しました。サーバー側でリクエストを受信できたか確認してください。",
    testFailed: "テストに失敗しました：{error}",
    unknownError: "不明なエラー",
    testRequestFailed: "テストリクエストに失敗しました",
    retrySuccess: "Webhook を再試行しました",
    retryFailed: "再試行に失敗しました",
    events: {
      resource_created: "リソース作成",
      resource_updated: "リソース更新",
      resource_deleted: "リソース削除",
      resource_failed: "リソース処理失敗",
    },
    errors: {
      nameRequired: "Webhook 名を入力してください。",
      urlRequired: "有効なコールバック URL を入力してください。",
      selectEvent: "トリガーイベントを 1 つ以上選択してください",
      headersJson: "Headers は有効な JSON で入力してください",
      headersObject: "Headers は JSON オブジェクトで入力してください",
      headerValueString: "Header {key} の値は文字列である必要があります",
    },
  },
  billingPage: {
    currentSubscription: "現在のサブスクリプション",
    loading: "読み込み中...",
    plan: "プラン",
    monthlyFee: "月額料金",
    trialEndsAt: "試用期限",
    currentPeriod: "現在の期間",
    planDetails: "プラン内容",
    noPlanDescription: "プラン説明はありません。",
    includedFeatures: "含まれる機能",
    addOnFeatures: "追加機能",
    noItems: "なし",
    quotaLimits: "利用枠の上限",
    usage: "使用量",
    invoices: "請求書",
    invoiceNumber: "請求書番号",
    period: "期間",
    amount: "金額",
    status: "ステータス",
    noInvoices: "請求書はまだありません",
    unlimited: "無制限",
    accumulated: "累計",
    current: "現在",
    statuses: {
      TRIALING: "試用中",
      ACTIVE: "有効",
      PAST_DUE: "期限超過",
      SUSPENDED: "一時停止中",
      CANCELED: "キャンセル済み",
    },
    invoiceStatuses: {
      DRAFT: "下書き",
      OPEN: "支払い待ち",
      PAID: "支払い済み",
      OVERDUE: "期限超過",
      VOID: "無効",
    },
    quota: {
      units: "リソース利用量",
      apiCalls: "API 呼び出し",
      storage: "ストレージ",
      unitsUnit: "件",
      apiCallsUnit: "回",
      storageUnit: "MB",
    },
  },
  notificationsPage: {
    title: "通知センター",
    markAllRead: "すべて既読",
    markRead: "既読にする",
    archive: "アーカイブ",
    openAction: "開く",
    loading: "読み込み中...",
    empty: "通知はまだありません",
    unread: "未読",
    previousPage: "前へ",
    nextPage: "次へ",
    filters: {
      all: "すべて",
      unread: "未読",
      read: "既読",
    },
    severity: {
      INFO: "情報",
      SUCCESS: "成功",
      WARNING: "警告",
      ERROR: "エラー",
    },
  },
  feedbackPage: {
    title: "自分のフィードバック",
    newFeedback: "新規フィードバック",
    allStatuses: "すべてのステータス",
    loading: "読み込み中...",
    empty: "フィードバックはまだありません",
    unread: "未読",
    previousPage: "前へ",
    nextPage: "次へ",
    createdAt: "作成日時 {time} · {status}",
    closeFeedback: "フィードバックを閉じる",
    selectHint: "詳細を表示するフィードバックを選択してください",
    followUpPlaceholder: "追加で問い合わせる...",
    sending: "送信中...",
    sendFollowUp: "追加入力を送信",
    loadDetailFailed: "詳細の読み込みに失敗しました",
    closeConfirmTitle: "フィードバックを閉じる",
    closeConfirmDescription:
      "閉じると追加の問い合わせはできず、再開もできません。閉じますか？",
    closeSuccess: "フィードバックを閉じました",
    closeFailed: "閉じる処理に失敗しました",
    followUpRequired: "追加入力の内容を入力してください",
    followUpSent: "追加入力を送信しました",
    sendFailed: "送信に失敗しました",
    statuses: {
      OPEN: "未対応",
      IN_PROGRESS: "対応中",
      RESOLVED: "解決済み",
      CLOSED: "クローズ済み",
    },
    subjects: {
      bug: "不具合報告",
      feature: "機能要望",
      billing: "請求と利用枠",
      account: "アカウントとセキュリティ",
      other: "その他",
    },
  },
  teamPage: {
    roles: {
      title: "ロール",
      create: "ロールを追加",
      edit: "ロールを編集",
      delete: "ロールを削除",
      refresh: "ロールを更新",
      empty: "ロールはまだありません",
      name: "ロール名",
      namePlaceholder: "例：経理担当",
      menuPermissions: "メニュー権限",
      refreshSuccess: "ロール一覧を更新しました",
      nameRequired: "ロール名を入力してください。",
      selectMenuPermission: "少なくとも 1 つのメニュー権限を選択してください。",
      createSuccess: "ロールを作成しました",
      saveSuccess: "ロールを保存しました",
      saveFailed: "保存に失敗しました",
      createOtherRoleFirst:
        "先に別のロールを作成し、メンバーを移動してから削除してください。",
      deleteConfirmTitle: "ロール「{name}」を削除しますか？",
      deleteConfirmDescription: "削除後は元に戻せません。",
      deleteSuccess: "ロールを削除しました",
      deleteFailed: "削除に失敗しました",
      deleteWithMembersPrefix: "ロール「{name}」にはまだ ",
      deleteWithMembersSuffix:
        " 人のメンバーがいます。移動先ロールを選択してから削除してください。",
      moveToRole: "移動先ロール",
      moveMembersAndDelete: "メンバーを移動して削除",
      selectTargetRole: "移動先ロールを選択してください。",
      targetRoleSame: "移動先ロールに現在のロールは選択できません。",
    },
    members: {
      title: "メンバー",
      add: "メンバーを追加",
      searchPlaceholder: "名前またはメールで検索",
      selectRoleHint: "左側のロールを選択してメンバーを表示してください。",
      account: "アカウント",
      loginEmail: "ログインメール",
      actions: "操作",
      resetPassword: "パスワード再設定",
      edit: "メンバーを編集",
      name: "名前",
      initialPassword: "初期パスワード",
      memberRole: "所属ロール",
      createSuccess: "メンバーを作成しました",
      createFailed: "作成に失敗しました",
      updateSuccess: "メンバーを更新しました",
      updateFailed: "更新に失敗しました",
      statusUpdated: "ステータスを更新しました",
      resetPasswordDescription:
        "{name}（{email}）の新しいログインパスワードを設定します。",
      confirmReset: "再設定を確定",
      emailRequired: "有効なメールアドレスを入力してください。",
      nameRequired: "メンバー名を入力してください。",
      roleRequired: "メンバーのロールを選択してください。",
      passwordMin: "パスワードは 8 文字以上で入力してください。",
      resetPasswordSuccess: "パスワードを再設定しました",
      resetPasswordFailed: "パスワード再設定に失敗しました",
      selectWorkspaceAccess: "ワークスペース権限を選定",
      workspaceAccessTitle: "ワークスペース権限を選定",
      workspaceAccessDescription:
        "{name} が閲覧・編集できるワークスペースを選択します。未選択のワークスペースは一覧に表示されず、切り替えもできません。",
      workspaceAccessEmpty: "選択できるワークスペースがありません。",
      workspaceAccessSaveSuccess: "ワークスペース権限を保存しました",
      workspaceAccessSaveFailed: "ワークスペース権限の保存に失敗しました",
      workspaceAccessLoadFailed: "ワークスペース権限の読み込みに失敗しました",
    },
    status: {
      label: "ステータス",
      active: "有効",
      inactive: "無効",
      deleted: "削除済み",
    },
    passwordMinPlaceholder: "8 文字以上",
  },
  forbiddenPage: {
    title: "このページにアクセスできません",
    description:
      "現在のプランまたはテナント設定では、この機能は有効化されていません。管理者にお問い合わせください。",
    backHome: "ホームへ戻る",
  },
  enterpriseIdentity: {
    title: "エンタープライズ ID",
    description:
      "テナント SSO、MFA 強制、ログイン IP 許可リストを設定します。OIDC と SAML の両方に対応しています。",
    fields: {
      ssoEnabled: "エンタープライズ SSO を有効化",
      allowPasswordLogin: "パスワードログインを許可",
      requireMfa: "全ユーザーに MFA を必須化",
      loginIpWhitelistEnabled: "ログイン IP 許可リストを有効化",
      loginIpWhitelist: "許可する IP / CIDR",
    },
    hints: {
      loginIpWhitelist:
        "1 行に 1 つの IP または CIDR。例: 203.0.113.10 または 10.0.0.0/8",
    },
    providers: {
      title: "ID プロバイダー",
      description:
        "OIDC または SAML IdP を設定します。SAML は対応する機能フラグが必要です。",
      add: "プロバイダーを追加",
      empty: "ID プロバイダーはまだ設定されていません",
      default: "デフォルト",
      createTitle: "プロバイダーを追加",
      editTitle: "プロバイダーを編集",
      dialogDescription:
        "OIDC コールバック URL は /api/v1/auth/sso/callback 固定です",
      fields: {
        name: "表示名",
        issuer: "Issuer / EntityID",
        clientId: "Client ID",
        clientSecret: "Client Secret",
        providerType: "プロバイダータイプ",
      },
    },
    saml: {
      dialogDescription: "SAML ACS URL は /api/v1/auth/sso/saml/acs 固定です",
      acsUrl: "ACS URL",
      metadataUrl: "SP Metadata",
      acsHint: "この ACS URL と SP EntityID を IdP 設定に登録してください。",
      fields: {
        idpMetadataUrl: "IdP Metadata URL（任意）",
        idpSsoUrl: "IdP SSO URL",
        idpCertificatePem: "IdP 証明書（PEM）",
        spEntityId: "SP EntityID",
        wantAssertionsSigned: "署名付きアサーションを必須化（推奨）",
        signAuthnRequests: "AuthnRequest に署名",
      },
    },
    scim: {
      title: "SCIM ユーザープロビジョニング",
      description:
        "SCIM 2.0 インバウンドユーザープロビジョニングを設定します。IdP は Bearer Token でユーザーライフサイクルを管理します。",
      fields: {
        scimEnabled: "SCIM を有効化",
        scimDefaultMemberRoleId: "デフォルトメンバーロール ID",
        scimAllowCreate: "SCIM によるユーザー作成を許可",
        scimAllowDeactivate: "SCIM によるユーザー無効化を許可",
      },
      token: {
        title: "SCIM Bearer Token",
        generate: "トークンを生成",
        rotate: "トークンをローテート",
        revoke: "トークンを失効",
        generated: "トークンを生成しました",
        rotated: "トークンをローテートしました",
        revoked: "トークンを失効しました",
        lastRotatedAt: "最終ローテート",
        endpointHint: "SCIM エンドポイント",
        oneTimeWarning:
          "今すぐこのトークンをコピーしてください。再度表示されません。",
      },
    },
    messages: {
      policySaved: "エンタープライズ ID ポリシーを保存しました",
      providerSaved: "ID プロバイダーを保存しました",
      providerDeleted: "ID プロバイダーを削除しました",
      saveFailed: "保存に失敗しました",
    },
  },
  settingsPage: {
    createdAt: "作成日 {date}",
    lastUsedAt: "最終使用 {date}",
    passkeys: {
      title: "Passkey セキュリティキー",
      description:
        "端末の生体認証やセキュリティキーを使って、すばやく安全にログインできます",
      browserSupported: "ブラウザ対応",
      browserUnsupported: "ブラウザ非対応",
      empty: "登録済みのセキュリティキーはありません",
      platformKey: "端末キー",
      securityKey: "セキュリティキー",
      backupEligible: "バックアップ可能",
      deleteTitle: "このキーを削除",
      add: "セキュリティキーを追加",
      verifyPasswordHint: "本人確認のためパスワードを入力してください",
      passwordPlaceholder: "パスワードを入力",
      keyNameOptional: "キー名（任意）",
      keyNamePlaceholder: "例：MacBook Touch ID",
      registering: "登録中...",
      nextStep: "次へ",
      useSecurityKey: "セキュリティキーを使用",
      browserPrompt: "ブラウザの案内に従って登録を完了してください",
      registerSuccess: "セキュリティキーの登録が完了しました",
      registerSuccessDescription:
        "このセキュリティキーでログインできるようになりました。",
      registerSuccessTitle: "登録完了",
      registerTitle: "セキュリティキーを登録",
      passwordRequired: "パスワードを入力してください",
      invalidServerResponse: "サーバーの応答形式が不正です",
      registerRequestFailed:
        "登録リクエストに失敗しました。パスワードが正しいか確認してください。",
      registerFailed: "登録に失敗しました。再試行してください。",
      deleteConfirmTitle: "セキュリティキーを削除",
      deleteConfirmDescription:
        "このセキュリティキーを削除しますか？削除後はこのキーでログインできません。",
      deleteSuccess: "セキュリティキーを削除しました",
    },
    mfa: {
      title: "多要素認証 (MFA)",
      description:
        "Google Authenticator などのアプリで 6 桁のワンタイムコードを生成します",
      enabledMessage: "MFA は有効です。ログイン時に認証コードが必要です。",
      disabledMessage: "有効化後、QR コードを読み取って設定を完了します",
      setupTitle: "認証アプリを設定",
      disableTitle: "MFA を無効化",
      setupDescription:
        "Google Authenticator などの TOTP アプリで下の QR コードを読み取り、6 桁のコードを入力して設定を完了してください。",
      disableDescription:
        "MFA を無効化するには、現在のパスワードと認証アプリのコードを入力してください。",
      qrAlt: "MFA QR コード",
      manualSecretHint: "読み取れない場合は、このキーを手入力してください：",
      loginPassword: "ログインパスワード",
      sixDigitCode: "6 桁の認証コード",
      passwordRequired: "ログインパスワードを入力してください。",
      codeRequired: "6 桁の認証コードを入力してください。",
      confirmEnable: "有効化",
      confirmDisable: "無効化",
      qrFailed:
        "QR コードの生成に失敗しました。下のキーを手動で追加してください。",
      setupFailed: "MFA の初期化に失敗しました",
      enableSuccess: "MFA を有効化しました",
      disableSuccess: "MFA を無効化しました",
    },
    apiKeys: {
      description: "API Key を使って公開 API にアクセスします",
      empty: "API Key はまだありません",
      rateLimit: "1 分あたり {count} 回",
      rateLimitLabel: "1 分あたりの上限",
      expiresAt: "有効期限 {date}",
      expiresAtLabel: "有効期限（任意）",
      scopes: "スコープ",
      scopesRequired: "少なくとも 1 つのスコープを選択してください",
      create: "API Key を作成",
      createTitle: "API Key を作成",
      createDescription:
        "API Key の名称を設定します。作成後はすぐにキーを保存してください。",
      namePlaceholder: "例：Production Key",
      nameRequired: "API Key 名を入力してください。",
      revealedOnce: "API Key（一度だけ表示）",
      loadFailed: "API Key の読み込みに失敗しました",
      createSuccess: "API Key を作成しました。今すぐ保存してください。",
      createFailed: "API Key の作成に失敗しました",
      deleteTitle: "API Key を削除",
      deleteDescription: "この API Key を削除しますか？",
      revokeSuccess: "API Key を失効しました",
      revokeFailed: "API Key の失効に失敗しました",
    },
    apiRequestLogs: {
      title: "API 呼び出しログ",
      description:
        "API Key リクエストのメタデータのみ保存します。本文やシークレットは記録しません。",
      empty: "API 呼び出しログはまだありません",
      apiKeyFilter: "API Key ID で絞り込み",
      columns: {
        time: "時刻",
        method: "メソッド",
        path: "パス",
        status: "ステータス",
        duration: "応答時間",
      },
    },
    profile: {
      title: "プロフィール",
      avatar: "アバター",
      avatarUpload: "アバターをアップロード",
      avatarUploading: "アップロード中...",
      avatarHint:
        "PNG、JPG、WebP に対応。最大 2 MB。保存前に正方形へトリミングします。",
      avatarCropTitle: "アバターをトリミング",
      avatarConfirmCrop: "アバターに設定",
      avatarZoom: "ズーム",
      avatarInvalid: "有効な画像ファイルをアップロードしてください。",
      avatarTooLarge: "アバター画像は 2 MB 以下にしてください。",
      avatarSaveSuccess: "アバターを更新しました",
      avatarSaveFailed: "アバターの更新に失敗しました",
      name: "名前",
      save: "変更を保存",
      saveSuccess: "プロフィールを保存しました",
      saveFailed: "プロフィールの保存に失敗しました",
    },
    security: {
      title: "セキュリティ設定",
      description: "ログインパスワードを変更します",
      currentPassword: "現在のパスワード",
      newPassword: "新しいパスワード",
      confirmPassword: "新しいパスワード（確認）",
      changePassword: "パスワードを変更",
      currentPasswordRequired: "現在のパスワードを入力してください。",
      passwordMismatch: "入力したパスワードが一致しません",
      passwordTooShort: "パスワードは 8 文字以上で入力してください",
      changeSuccess: "パスワードを変更しました。再度ログインしてください。",
      changeFailed: "パスワードの変更に失敗しました",
    },
  },
  dataTable: {
    loading: "読み込み中...",
    empty: "レコードはありません",
    total: "合計 {total} 件",
    perPage: "{size} / ページ",
    goTo: "移動",
    page: "ページ",
    sortAsc: "{label} を昇順で並べ替え",
    sortDesc: "{label} を降順で並べ替え",
    sortable: "{label} で並べ替え",
  },
  datePicker: {
    placeholder: "日付を選択",
    rangePlaceholder: "日付範囲を選択",
    clear: "日付をクリア",
    year: "{year}年",
    month: "{month}月",
    yearPlaceholder: "年",
    monthPlaceholder: "月",
  },
  pdfPreview: {
    title: "PDF プレビュー",
    description:
      "上下にスクロールして全ページを確認できます。ページ送りボタンで該当ページへ移動します。",
    loading: "PDF を読み込み中...",
    rendering: "ページを描画中...",
    previousPage: "前のページ",
    nextPage: "次のページ",
    zoomOut: "縮小",
    zoomIn: "拡大",
    fitWidth: "幅に合わせる",
    download: "ダウンロード",
    print: "印刷",
    pageLabel: "{page} / {total} ページ",
  },
  dialog: {
    discardTitle: "未保存の変更を破棄しますか？",
    discardDescription:
      "このダイアログには未保存の変更があります。閉じると変更は破棄されます。",
    discardNavigationDescription:
      "このページには未保存の変更があるダイアログがあります。ページを離れると変更は破棄されます。",
    discardConfirm: "変更を破棄",
    keepEditing: "編集を続ける",
    defaultDescription: "ダイアログの内容",
  },

  openingArApImport: {
    page: {
      title: "期首売掛・買掛残高取込",
      description:
        "切替日時点の未消込残高を取り込みます。OPEN 義務のみ作成し、仕訳は作成しません。",
    },
    actions: {
      upload: "CSV をアップロード",
      execute: "取込を実行",
      retry: "失敗した実行を再試行",
      cancelBatch: "バッチを取消",
      viewReceivable: "売掛を表示",
      viewPayable: "買掛を表示",
      viewReceivablesAging: "売掛エイジング",
      viewPayablesAging: "買掛エイジング",
      openMigration: "期首残高を取り込む",
    },
    empty: {
      title: "期首取込バッチはまだありません",
      description:
        "UTF-8 CSV をアップロードして、切替日の未消込残高を移行してください。",
    },
    filters: {
      allStatuses: "すべてのステータス",
    },
    upload: {
      title: "期首売掛・買掛 CSV アップロード",
      description:
        "UTF-8 CSV のみ。金額は切替日の未消込残高であり、履歴請求書の元金額ではありません。",
      utf8Only: "UTF-8 CSV のみ（OPENING_AR_AP_CSV_V1）",
      shiftJisUnsupported:
        "Shift-JIS は非対応です。アップロード前に UTF-8 へ変換してください。",
      requiredColumns: "必須列",
      optionalColumns: "任意列",
      downloadTemplate: "UTF-8 テンプレートをダウンロード",
      fileLabel: "CSV ファイル",
      defaultReceivableAccount: "既定の売掛金科目",
      defaultPayableAccount: "既定の買掛金科目",
      cutoverDate: "切替日（任意）",
      sourceSystem: "ソースシステム（任意）",
      memo: "メモ（任意）",
      submit: "アップロードして検証",
    },
    amountSemantics: {
      title: "取込金額 = 切替日の未消込残高",
      body: "システム利用開始時点で未清算の未収・未払残高を入力してください。履歴請求書の元金額ではありません。",
      example: "例: 履歴請求書 1,000,000、既払 400,000 → 取込は 600,000。",
      noHistoryReconstruction: "履歴の入金・出金や消込は再構築しません。",
    },
    zeroAccounting: {
      title: "取込では仕訳を作成しません",
      body: "この取込では期首の未収・未払残高のみ登録し、仕訳は作成しません。",
    },
    summary: {
      title: "バッチサマリー",
      file: "ファイル",
      totalRows: "総行数",
      validRows: "有効行",
      invalidRows: "無効行",
      receivableTotal: "売掛合計",
      payableTotal: "買掛合計",
      importedRows: "取込済み",
      failedRows: "失敗",
      cutoverDate: "切替日",
      accountingBook: "会計帳簿",
      bookAtExecute: "実行時に解決（ACTIVE）",
      defaultReceivableAccount: "既定売掛科目",
      defaultPayableAccount: "既定買掛科目",
    },
    table: {
      rowNumber: "行番号",
      side: "区分",
      counterparty: "取引先",
      externalReference: "外部参照番号",
      amount: "未消込残高",
      dueDate: "支払期日",
      account: "売掛/買掛科目",
      status: "ステータス",
      error: "エラー",
      override: "上書き",
    },
    dueDate: {
      none: "期日なし",
    },
    side: {
      RECEIVABLE: "売掛",
      PAYABLE: "買掛",
      unknown: "—",
    },
    batchStatus: {
      RECEIVED: "受信済み",
      VALIDATING: "検証中",
      READY: "プレビュー準備完了",
      VALIDATION_FAILED: "検証失敗",
      EXECUTING: "実行中",
      COMPLETED: "完了",
      COMPLETED_WITH_ERRORS: "エラーあり完了",
      FAILED: "失敗",
      CANCELLED: "取消済み",
    },
    rowStatus: {
      PENDING: "保留",
      VALID: "有効",
      INVALID: "無効",
      DUPLICATE_CONFLICT: "重複競合",
      IMPORTING: "取込中",
      IMPORTED: "取込済み",
      FAILED: "失敗",
      SKIPPED: "スキップ",
    },
    history: {
      createdAt: "作成日時",
      file: "ファイル",
      status: "ステータス",
      rows: "行数",
      imported: "取込済み",
      failed: "失敗",
      executedAt: "実行日時",
    },
    executeDialog: {
      title: "期首取込の実行確認",
      description:
        "有効行に対して OPEN 義務を直接作成します。プレビューが人的ゲートであり、実行は明示操作です。",
      validRows: "取込対象の有効行",
      invalidRows: "取込しない無効行",
      receivableTotal: "売掛合計",
      payableTotal: "買掛合計",
      accountingBook: "有効な会計帳簿",
      noAutoExecute: "アップロード後に自動実行はしません。",
      confirm: "取込を実行",
      executing: "実行中…",
    },
    progress: {
      executing: "取込を実行中です。完了まで自動更新します。",
    },
    partialSuccess: {
      banner:
        "部分成功: 一部行は取込済み、一部は失敗です。バッチ全体の失敗ではありません。",
      noRetry:
        "エラーあり完了は再試行できません。競合を解消して新しいバッチをアップロードしてください。",
    },
    correction: {
      guidance:
        "未消込の期首項目を修正する場合は、売掛/買掛明細で取消してから新しいファイルで再取込してください。バッチ取消はありません。",
    },
    settlement: {
      note: "取込後の OPEN 義務は通常の売掛・買掛と同様に入金/出金消込できます。",
    },
    featureDisabled: {
      title: "期首売掛・買掛取込は無効です",
      body: "機能フラグ accounting.ar_ap.opening_migration.enabled がオフです。アップロードと実行はできません。",
    },
    cancelDialog: {
      title: "このバッチを取消しますか？",
      description:
        "実行前のバッチを取消します。既に取込済みの義務は削除されません。",
    },
    errors: {
      generic: "期首取込リクエストに失敗しました",
      permissionDenied: "期首取込の権限がありません",
      permissionDeniedBody:
        "この画面には ar_ap.opening_import.read が必要です。",
    },
    failureCodes: {
      GENERIC: "期首取込エラー",
      AR_AP_OPENING_MIGRATION_FEATURE_DISABLED: "期首移行機能が無効です",
      AR_AP_FEATURE_DISABLED: "売掛買掛機能が無効です",
      AR_AP_OPENING_IMPORT_NOT_FOUND: "期首取込バッチが見つかりません",
      AR_AP_OPENING_IMPORT_STATUS_TRANSITION_INVALID:
        "バッチ状態遷移が無効です",
      AR_AP_OPENING_IMPORT_VERSION_CONFLICT:
        "バッチ版競合です。更新して再試行してください",
      AR_AP_OPENING_CSV_ENCODING_UNSUPPORTED:
        "未対応の CSV エンコーディングです（UTF-8 必須 / Shift-JIS 非対応）",
      AR_AP_OPENING_CSV_HEADER_REQUIRED: "CSV ヘッダーが必要です",
      AR_AP_OPENING_CSV_HEADER_INVALID: "CSV ヘッダーが無効です",
      AR_AP_OPENING_CSV_HEADER_DUPLICATE: "CSV ヘッダー列が重複しています",
      AR_AP_OPENING_CSV_HEADER_MISSING_REQUIRED: "必須 CSV 列が不足しています",
      AR_AP_OPENING_CSV_FORBIDDEN_COLUMN: "禁止された CSV 列があります",
      AR_AP_OPENING_FORMAT_UNSUPPORTED: "未対応のフォーマットです",
      AR_AP_OPENING_FILENAME_INVALID: "ファイル名が無効です",
      AR_AP_OPENING_FILE_SIZE_INVALID: "ファイルサイズが無効です",
      AR_AP_OPENING_CONTENT_TYPE_INVALID:
        "コンテンツタイプが無効です（CSV 必須）",
      AR_AP_OPENING_FILE_REQUIRED: "CSV ファイルが必要です",
      AR_AP_OPENING_SIDE_INVALID:
        "区分は RECEIVABLE または PAYABLE である必要があります",
      AR_AP_OPENING_COUNTERPARTY_REQUIRED: "取引先は必須です",
      AR_AP_OPENING_COUNTERPARTY_TOO_LONG: "取引先が長すぎます",
      AR_AP_OPENING_AMOUNT_INVALID:
        "金額は正の整数（最小単位文字列）である必要があります",
      AR_AP_OPENING_EXTERNAL_REFERENCE_REQUIRED: "外部参照番号は必須です",
      AR_AP_OPENING_EXTERNAL_REFERENCE_TOO_LONG: "外部参照番号が長すぎます",
      AR_AP_OPENING_EXTERNAL_REFERENCE_INVALID: "外部参照番号が無効です",
      AR_AP_OPENING_EXTERNAL_REFERENCE_DUPLICATE_IN_BATCH:
        "同一バッチ内で外部参照番号が重複しています",
      AR_AP_OPENING_EXTERNAL_REFERENCE_CONFLICT:
        "このワークスペースに同一外部参照の有効な期首義務が既に存在します",
      AR_AP_OPENING_DUE_DATE_INVALID:
        "支払期日は YYYY-MM-DD である必要があります",
      AR_AP_OPENING_ACCOUNT_REQUIRED: "売掛/買掛科目を解決できません",
      AR_AP_OPENING_ACCOUNT_NOT_FOUND: "科目が見つかりません",
      AR_AP_OPENING_ACCOUNT_ID_INVALID: "科目 ID が無効です",
      AR_AP_OPENING_NO_VALID_ROWS: "実行可能な有効行がありません",
      AR_AP_OPENING_ROW_INCOMPLETE: "行データが不完全です",
      AR_AP_OPENING_ROW_IMPORT_FAILED: "行の取込に失敗しました",
      ACCOUNTING_BOOK_ACTIVE_REQUIRED: "有効な会計帳簿が必要です",
      SETTLEMENT_ACCOUNTING_ACCOUNT_NOT_ELIGIBLE:
        "科目が売掛/買掛に適格ではありません",
      WORKSPACE_PERMISSION_DENIED: "ワークスペース権限がありません",
      IDEMPOTENCY_KEY_REUSED: "異なる内容で冪等キーが再利用されました",
      IDEMPOTENCY_KEY_REQUIRED: "Idempotency-Key が必要です",
    },
  },
  arAp: {
    pages: {
      receivables: {
        title: "売掛金",
        subtitle:
          "運用上の売掛義務です。OPEN は未決済オープン項目を意味し、転記済みや照合済みではありません。",
      },
      payables: {
        title: "買掛金",
        subtitle:
          "運用上の買掛義務です。OPEN は未決済オープン項目を意味し、転記済みや照合済みではありません。",
      },
    },
    status: {
      DRAFT: "下書き",
      OPEN: "未決済",
      SETTLED: "決済済み",
      CANCELLED: "取消済み",
      SUPERSEDED: "差替済み",
    },
    side: {
      RECEIVABLE: "売掛",
      PAYABLE: "買掛",
    },
    source: {
      MANUAL: "手動",
      BUSINESS_TRANSACTION: "業務取引",
    },
    table: {
      counterparty: "取引先",
      counterpartyEmpty: "（取引先未設定）",
      amount: "金額",
      dueDate: "支払期限",
      dueDateEmpty: "—",
      status: "ステータス",
      source: "ソース",
      createdAt: "作成日時",
      updatedAt: "更新日時",
      actions: "操作",
    },
    filters: {
      status: "ステータス",
      sourceType: "ソース",
      dueFrom: "期限（開始）",
      dueTo: "期限（終了）",
      allStatuses: "すべてのステータス",
      allSources: "すべてのソース",
      apply: "適用",
      reset: "リセット",
    },
    actions: {
      create: "義務を作成",
      refresh: "更新",
      viewDetail: "詳細",
      edit: "編集",
      save: "保存",
      confirm: "未決済として確定",
      cancel: "義務を取消",
    },
    fields: {
      side: "区分",
      status: "ステータス",
      amount: "金額（円）",
      currency: "通貨",
      dueDate: "支払期限",
      counterparty: "取引先",
      registrationNumber: "適格請求書発行事業者登録番号",
      sourceType: "ソース種別",
      sourceId: "ソース ID",
      version: "バージョン",
      createdAt: "作成日時",
      openedAt: "オープン日時",
      cancelledAt: "取消日時",
      updatedAt: "更新日時",
      arApAccount: "売掛/買掛科目",
      accountingBook: "会計帳簿",
    },
    create: {
      title: "義務を作成",
      description:
        "下書き義務を作成します。後で未決済（OPEN）として確定できます。",
      amountPlaceholder: "例: 1250000",
      counterpartyHint:
        "未決済として確定する前に取引先が必須です。下書きでは任意です。",
      submit: "下書きを作成",
      submitting: "作成中…",
      errors: {
        amountInvalid: "1円以上の整数金額を入力してください。",
      },
    },
    detail: {
      title: "義務の詳細",
      description:
        "運用オープン項目の詳細です。取消は仕訳や総勘定元帳の取消処理ではありません。",
      loading: "読み込み中…",
      saving: "保存中…",
      businessTransaction: "業務取引",
      businessTransactionHint:
        "血統 ID のみ表示します。本段階では業務取引編集画面はありません。",
      sections: {
        basic: "基本",
        counterparty: "取引先",
        source: "ソース",
        lifecycle: "ライフサイクル",
        accounting: "会計設定",
      },
    },
    account: {
      required: "売掛/買掛科目の設定が必要です",
      immutableHint: "一度設定した科目は変更できません。",
      dialog: {
        title: "売掛/買掛科目を設定",
        description: "この義務と同じ会計帳簿の科目を選択してください。",
      },
      actions: {
        set: "科目を設定",
        save: "科目を保存",
        saving: "保存中…",
      },
    },
    confirmDialog: {
      title: "未決済として確定しますか？",
      description:
        "義務を OPEN（未決済）にします。仕訳・転記・支払は作成されません。",
    },
    cancelDialog: {
      title: "この義務を取り消しますか？",
      description:
        "この債権/債務を取り消します。仕訳や総勘定元帳の取消処理ではありません。",
    },
    empty: {
      receivables: "まだ売掛金はありません",
      payables: "まだ買掛金はありません",
      description: "手動で下書き義務を作成できます。",
      filteredReceivables: "条件に一致する売掛金はありません",
      filteredPayables: "条件に一致する買掛金はありません",
      filteredDescription: "ステータス、ソース、期限の条件を見直してください。",
    },
    featureDisabled: {
      banner:
        "このテナントでは売掛/買掛の更新操作が無効です。既存義務は参照できます。",
    },
    errors: {
      loadFailed: "義務の読み込みに失敗しました",
      loadDetailFailed: "義務詳細の読み込みに失敗しました",
      createFailed: "義務の作成に失敗しました",
      updateFailed: "義務の更新に失敗しました",
      confirmFailed: "義務の確定に失敗しました",
      cancelFailed: "義務の取消に失敗しました",
      setAccountFailed: "科目の設定に失敗しました",
      noPermissionTitle: "アクセス権がありません",
      noPermission: "売掛/買掛義務を表示する権限がありません。",
    },
    failureCodes: {
      AR_AP_OBLIGATION_FEATURE_DISABLED:
        "機能フラグにより売掛/買掛の更新が無効です。",
      AR_AP_OBLIGATION_NOT_FOUND: "義務が見つかりません。",
      AR_AP_OBLIGATION_STATUS_TRANSITION_INVALID:
        "このステータス変更は許可されていません。",
      AR_AP_OBLIGATION_SOURCE_CONFLICT:
        "このソースには既に有効な義務があります。",
      AR_AP_OBLIGATION_AMOUNT_INVALID:
        "金額は正の整数（円）である必要があります。",
      AR_AP_OBLIGATION_SIDE_INVALID: "区分が不正です。",
      AR_AP_OBLIGATION_CURRENCY_UNSUPPORTED: "JPY のみ対応しています。",
      AR_AP_OBLIGATION_VERSION_CONFLICT:
        "他で更新されています。最新版を再読み込みしました。",
      AR_AP_OBLIGATION_COUNTERPARTY_REQUIRED:
        "オープン前に取引先名が必要です。",
      AR_AP_OBLIGATION_BUSINESS_TRANSACTION_NOT_CONFIRMED:
        "業務取引を先に確定してください。",
      AR_AP_OBLIGATION_AR_AP_ACCOUNT_STATUS_INVALID:
        "このステータスでは科目を設定できません。",
      AR_AP_OBLIGATION_AR_AP_ACCOUNT_IMMUTABLE:
        "科目は既に設定されており変更できません。",
      AR_AP_OBLIGATION_ACCOUNTING_BOOK_REQUIRED:
        "先に会計帳簿を設定してください。",
      AR_AP_OBLIGATION_HAS_CONFIRMED_ALLOCATIONS:
        "先にこの画面で消込を取り消し、その後に売掛/買掛を取消してください。操作は自動連結しません。",
      WORKSPACE_PERMISSION_DENIED: "この操作を行う権限がありません。",
      IDEMPOTENCY_KEY_REUSED:
        "このリクエストは別ペイロードで既に送信されています。",
    },
    aging: {
      title: "エイジング・期日オペレーション",
      asOf: "基準日 {date}",
      timezoneHint: "ワークスペースタイムゾーン: {timezone}",
      dueScheduleHint:
        "期日スケジュールは未消込 OPEN 債権債務の残高と期日を表示します。キャッシュ予測ではありません。",
      noDueDate: "期日なし",
      viewMode: {
        groupLabel: "表示モード",
        list: "一覧",
        aging: "エイジング",
      },
      summary: {
        outstanding: "未消込残高",
        overdue: "期日超過",
        dueSoon: "期日間近",
        noDueDate: "期日なし",
        obligationCount: "OPEN {count} 件",
      },
      buckets: {
        groupLabel: "エイジングバケット",
        count: "{count} 件",
        CURRENT: "期限内",
        D1_30: "1–30日",
        D31_60: "31–60日",
        D61_90: "61–90日",
        D90_PLUS: "90日超",
        NO_DUE_DATE: "期日なし",
      },
      dueState: {
        OVERDUE: "期日超過",
        DUE_SOON: "期日間近",
        NOT_DUE: "未到来",
        NO_DUE_DATE: "期日なし",
      },
      daysPastDue: {
        noDueDate: "期日なし",
        today: "本日期日",
        overdue: "期日超過",
        overdueCount: "{days} 日超過",
        notYetDue: "未到来",
      },
      table: {
        original: "当初金額",
        remaining: "残高",
        allocated: "消込済",
        dueState: "期日状態",
        bucket: "バケット",
      },
      filters: {
        asOfDate: "基準日",
        dueState: "期日状態",
        counterparty: "取引先名",
        counterpartyPlaceholder: "スナップショット名（完全一致）",
        allDueStates: "すべて",
      },
      empty: {
        receivables: "未消込売掛金はありません",
        payables: "未消込買掛金はありません",
        filteredReceivables: "条件に一致する売掛金がありません",
        filteredPayables: "条件に一致する買掛金がありません",
        description: "OPEN 債権債務がないか、すべて消込済みです。",
        filteredDescription:
          "基準日・期日状態・取引先フィルタを調整してください。",
      },
      errors: {
        loadFailed: "エイジングデータの読み込みに失敗しました",
      },
    },
  },

  payments: {
    pages: {
      title: "入出金",
      subtitle:
        "運用上の現金事実。確認 ≠ 仕訳計上。消込は義務側で別途行います。",
    },
    status: { DRAFT: "下書き", CONFIRMED: "確認済", CANCELLED: "取消済" },
    direction: { INCOMING: "入金", OUTGOING: "出金" },
    source: { MANUAL: "手入力", BANK_MATCH: "銀行照合" },
    allocationState: {
      UNALLOCATED: "未消込",
      PARTIALLY_ALLOCATED: "一部消込",
      FULLY_ALLOCATED: "消込済",
    },
    table: {
      paymentDate: "支払日",
      direction: "方向",
      counterparty: "取引先",
      counterpartyEmpty: "（取引先なし）",
      amount: "金額",
      allocated: "消込済",
      unallocated: "未消込",
      status: "状態",
      allocation: "消込状態",
      source: "ソース",
      actions: "操作",
    },
    filters: {
      direction: "方向",
      status: "状態",
      paymentDate: "支払日範囲",
      allStatuses: "すべての状態",
      allDirections: "すべての方向",
      allocationAll: "すべて",
      allocationNeeds: "要消込",
      allocationFull: "消込済のみ",
      apply: "適用",
      reset: "リセット",
    },
    actions: {
      create: "新規入出金",
      refresh: "更新",
      viewDetail: "詳細",
      edit: "編集",
      confirm: "入出金を確認",
      cancel: "入出金を取消",
    },
    fields: {
      direction: "方向",
      status: "状態",
      amount: "金額（円）",
      paymentDate: "支払日",
      counterparty: "取引先",
      reference: "参照",
      description: "摘要",
      bankAccount: "銀行口座",
      version: "バージョン",
      confirmedAt: "確認日時",
    },
    form: {
      createTitle: "入出金を作成",
      createDescription:
        "MANUAL 下書きを作成。確認後も仕訳計上ではありません。",
      editTitle: "入出金を編集",
      editDescription: "下書きフィールドを更新します。",
      amountPlaceholder: "例 125000",
      bankAccountEmpty: "（なし）",
      bankMatchHint:
        "銀行由来フィールドは読み取り専用。摘要・取引先のみ修正可。",
      submit: "保存",
      submitting: "保存中…",
      errors: {
        amountInvalid: "正の整数円を入力してください。",
        dateRequired: "支払日を指定してください。",
      },
    },
    detail: {
      title: "入出金詳細",
      description:
        "運用上の現金事実。取消は仕訳・銀行照合・消込を逆転しません。",
      loading: "読み込み中…",
      total: "合計",
      allocated: "消込済",
      unallocated: "未消込",
      provenance: "ソース",
      bankMatchDecision: "決定 ID",
      viewBankReconciliation: "銀行照合を表示",
      cancelBlockedHint:
        "確認済消込がある間は取消できません。先にこの画面で消込を取り消し、その後に入金/出金を取消してください。",
    },
    allocations: {
      title: "消込割当",
      empty: "この入出金に紐づく消込はありません。",
      summary: "{total} 件 · 進行中 {inProgress} · 計上済 {posted}",
      unallocatedGuidance:
        "確認済ですが未消込です。売掛/買掛から消込してください。",
      goReceivables: "売掛金を開く",
      goPayables: "買掛金を開く",
      viewObligation: "義務を表示",
    },
    confirmDialog: {
      title: "入出金を確認しますか？",
      description:
        "運用上の現金事実として確認します。仕訳計上・消込ではありません。",
      bankMatchDescription:
        "銀行連携下書きを確認します。確認前に銀行由来を照合してください。",
    },
    cancelDialog: {
      title: "入出金を取消しますか？",
      description:
        "入出金レコードを取消します。仕訳逆転・照合解除ではありません。",
    },
    featureDisabled: {
      banner: "入出金の変更機能は無効です。一覧の閲覧は可能です。",
    },
    empty: {
      title: "入出金がありません",
      description: "手入力で作成するか、銀行照合から関連付けてください。",
      filteredTitle: "条件に一致する入出金がありません",
      filteredDescription: "フィルタまたは消込チップを調整してください。",
    },
    errors: {
      loadFailed: "入出金の読み込みに失敗しました",
      loadDetailFailed: "詳細の読み込みに失敗しました",
      createFailed: "作成に失敗しました",
      updateFailed: "更新に失敗しました",
      confirmFailed: "確認に失敗しました",
      cancelFailed: "取消に失敗しました",
      cancelBlockedByAllocations: "確認済消込があるため取消できません。",
      noPermissionTitle: "アクセス権限がありません",
      noPermission: "入出金を表示する権限がありません。",
    },
    failureCodes: {
      PAYMENT_FEATURE_DISABLED: "入出金の変更機能は無効です。",
      PAYMENT_NOT_FOUND: "入出金が見つかりません。",
      PAYMENT_STATUS_TRANSITION_INVALID: "この状態変更は許可されていません。",
      PAYMENT_VERSION_CONFLICT:
        "他で更新されました。最新を再読み込みしてください。",
      PAYMENT_AMOUNT_INVALID: "金額は正の整数円である必要があります。",
      PAYMENT_DIRECTION_INVALID: "方向が無効です。",
      PAYMENT_CURRENCY_UNSUPPORTED: "JPY のみ対応しています。",
      PAYMENT_DATE_INVALID: "支払日が無効です。",
      PAYMENT_HAS_CONFIRMED_ALLOCATIONS:
        "取消前に確認済消込を無効化してください。",
      WORKSPACE_PERMISSION_DENIED: "この操作を行う権限がありません。",
      IDEMPOTENCY_KEY_REUSED:
        "このリクエストは別ペイロードで既に送信されています。",
    },
  },

  differenceSettlement: {
    section: {
      title: "差額処理",
      empty: "この義務に紐づく差額処理はありません。",
      viewPayment: "入出金を表示",
    },
    actions: {
      create: "差額処理",
    },
    types: {
      BANK_FEE: "振込手数料",
      SMALL_DIFFERENCE: "少額差額",
    },
    status: {
      CONFIRMED: "確定済",
      CANCELLED: "取消済",
    },
    dialog: {
      createTitle: "差額処理",
      createDescription:
        "入出金消込とは別に、義務残高を減らす差額処理を確定します。",
    },
    confirmDialog: {
      title: "差額処理を確定しますか？",
      description:
        "差額処理を確定すると未消込残高に反映されます。仕訳の計上は別途会計処理の進行状況に従います。",
    },
    fields: {
      type: "差額種別",
      amount: "差額金額",
      maximum: "上限額",
      remaining: "義務残高",
      differenceAccount: "差額科目",
      differenceAccountPlaceholder: "科目を選択",
      reason: "理由（任意）",
      bankFeeContext: "関連入出金（任意）",
      paymentAmount: "入出金金額",
      allocationAmount: "この義務への消込額",
      relatedPaymentOptional:
        "入出金の紐付けは任意です。入出金の未消込額は変わりません。",
    },
    validation: {
      INVALID: "正の整数金額を入力してください。",
      OVER_REMAINING: "義務残高を超えています。",
      OVER_TYPE_MAX: "少額差額の上限を超えています。",
    },
    errors: {
      reloadFailed: "義務バージョンの再読込に失敗しました。",
      versionConflict:
        "他の操作により更新されました。残高を確認して再度確定してください。",
    },
    cancel: {
      title: "差額処理を取り消す",
      description:
        "運用上の差額処理を取消します。転記済み仕訳は自動では取り消されません。",
      reason: "理由（任意）",
      confirm: "差額処理を取り消す",
      reversalRequired: "転記済みのため、取消仕訳が必要です。",
      viewProgress: "会計進捗を表示",
    },
    failureCodes: {
      UNKNOWN: "差額処理に失敗しました。",
      AR_AP_DIFFERENCE_FEATURE_DISABLED: "差額処理は現在無効です。",
      AR_AP_DIFFERENCE_NOT_FOUND: "差額処理が見つかりません。",
      AR_AP_DIFFERENCE_OBLIGATION_NOT_OPEN: "OPEN の義務のみ差額処理できます。",
      AR_AP_DIFFERENCE_AMOUNT_INVALID: "差額金額が無効です。",
      AR_AP_DIFFERENCE_OVER_SETTLEMENT: "義務原価を超える差額です。",
      AR_AP_DIFFERENCE_VERSION_CONFLICT: "義務が同時更新されました。",
      AR_AP_DIFFERENCE_CURRENCY_MISMATCH: "通貨が義務と一致しません。",
      AR_AP_DIFFERENCE_ACCOUNT_MISSING: "差額科目が必要です。",
      AR_AP_DIFFERENCE_ACCOUNT_INVALID: "差額科目が対象外です。",
      AR_AP_DIFFERENCE_ACCOUNT_INACTIVE: "差額科目が無効です。",
      AR_AP_DIFFERENCE_ACCOUNT_REQUIRED: "差額科目が必要です。",
      AR_AP_DIFFERENCE_TYPE_UNSUPPORTED: "差額種別が未対応です。",
      AR_AP_DIFFERENCE_STATUS_TRANSITION_INVALID: "無効な状態遷移です。",
      AR_AP_DIFFERENCE_CANCEL_REQUIRES_REVERSAL:
        "転記済みのため逆仕訳が必要です。",
      AR_AP_DIFFERENCE_PERMISSION_DENIED: "権限がありません。",
      AR_AP_DIFFERENCE_BOOK_REQUIRED: "義務の会計帳簿が必要です。",
    },
  },
  differenceAccounting: {
    panel: { title: "差額会計進捗", differenceAmount: "差額金額" },
    stages: {
      difference: "差額",
      transaction: "取引",
      classification: "仕訳区分",
      journal: "仕訳",
      posting: "Posting",
      posted: "仕訳済",
    },
    actions: {
      retry: "会計を再試行",
      resolveDate: "計上日を設定",
      setDifferenceAccount: "差額科目を設定",
      setArApAccount: "売掛/買掛科目を設定",
    },
    fields: { accountingDate: "計上日", postedJournal: "仕訳済み伝票" },
    warnings: { needsReversal: "仕訳済みのため、取消前に逆仕訳が必要です。" },
    featureDisabled: {
      banner: "差額処理は有効ですが、会計オーケストレーションは無効です。",
    },
    dateDialog: {
      title: "計上日を設定",
      description: "計上日は差額会計/Posting のみに使用します。",
      accountingDate: "計上日",
      openPeriodHint: "OPEN 期間の日付のみ受け付けます。",
      submit: "確定",
      errors: { required: "計上日が必要です。" },
    },
    outcomes: {
      UNKNOWN: { label: "不明", description: "会計進捗を判定できません。" },
      SOURCE_NOT_READY: {
        label: "未準備",
        description: "会計ソースが未準備です。",
      },
      WAITING_ACCOUNTING_DATE: {
        label: "計上日が必要",
        description: "計上日を設定してください。",
      },
      WAITING_AR_AP_ACCOUNT: {
        label: "売掛/買掛科目が必要",
        description: "債権債務に科目を設定してください。",
      },
      WAITING_DIFFERENCE_ACCOUNT: {
        label: "差額科目が必要",
        description: "差額 P/L 科目を設定してください。",
      },
      WAITING_TRANSACTION_CONFIRMATION: {
        label: "取引確認待ち",
        description: "業務取引の確認が必要です。",
      },
      WAITING_CLASSIFICATION_CONFIRMATION: {
        label: "仕訳区分確認待ち",
        description: "仕訳区分の確認が必要です。",
      },
      CLASSIFICATION_ENSURED: {
        label: "仕訳区分作成済",
        description: "仕訳区分の確認待ちです。",
      },
      JOURNAL_ENSURED: {
        label: "仕訳草稿作成済",
        description: "仕訳草稿の確認待ちです。",
      },
      WAITING_JOURNAL_CONFIRMATION: {
        label: "仕訳確認待ち",
        description: "仕訳確認が必要です。",
      },
      WAITING_JOURNAL_REVIEW: {
        label: "仕訳レビュー待ち",
        description: "仕訳レビューが必要です。",
      },
      WAITING_OPEN_PERIOD: {
        label: "OPEN 期間待ち",
        description: "対象期間が OPEN ではありません。",
      },
      ORCHESTRATION_DISABLED: {
        label: "オーケストレーション無効",
        description: "機能フラグにより自動会計は停止中です。",
      },
      POSTING_REQUESTED: {
        label: "Posting 要求済",
        description: "Posting 開始を待っています。",
      },
      POSTING_ALREADY_ENSURED: {
        label: "Posting 要求確保済",
        description: "Posting 要求は既に存在します。",
      },
      POSTING_IN_PROGRESS: {
        label: "Posting 処理中",
        description: "Posting worker が処理中です。",
      },
      POSTED: { label: "仕訳済", description: "仕訳済み伝票が存在します。" },
      POSTING_RETRYABLE_FAILED: {
        label: "Posting 失敗（再試行可）",
        description: "再試行可能な失敗状態です。",
      },
      POSTING_PERMANENTLY_FAILED: {
        label: "Posting 失敗（恒久）",
        description: "恒久失敗です。",
      },
      NEEDS_REVERSAL: {
        label: "逆仕訳が必要",
        description: "仕訳済みのため逆仕訳フローを使用してください。",
      },
      ACCOUNTING_REVERSED: {
        label: "会計逆仕訳済",
        description: "逆仕訳が完了しました。",
      },
      TARGET_TERMINAL: {
        label: "終端",
        description: "これ以上の会計 ensure は不要です。",
      },
      FAILED: {
        label: "失敗",
        description: "会計処理に失敗しました。再試行できます。",
      },
      ALREADY_READY_FOR_POSTING: {
        label: "Posting 準備完了",
        description: "人手ゲートは完了しています。",
      },
      POSTING_BLOCKED_FOUNDATION_FLAG: {
        label: "Posting ブロック",
        description: "基盤 Posting フラグによりブロックされています。",
      },
      BOOK_MISMATCH: {
        label: "帳簿不一致",
        description: "会計帳簿が一致しません。",
      },
      ACCOUNT_INACTIVE: {
        label: "無効科目",
        description: "スナップショット科目が ACTIVE ではありません。",
      },
    },
    failureCodes: {
      AR_AP_DIFFERENCE_ACCOUNTING_FEATURE_DISABLED:
        "差額会計オーケストレーションが無効です。",
      AR_AP_DIFFERENCE_ACCOUNTING_BOOK_MISMATCH: "会計帳簿が一致しません。",
      AR_AP_DIFFERENCE_ACCOUNTING_WAITING_ACCOUNTING_DATE: "計上日が必要です。",
      AR_AP_DIFFERENCE_ACCOUNTING_AR_AP_ACCOUNT_REQUIRED:
        "売掛/買掛科目が必要です。",
      AR_AP_DIFFERENCE_ACCOUNTING_DIFFERENCE_ACCOUNT_REQUIRED:
        "差額科目が必要です。",
      AR_AP_DIFFERENCE_ACCOUNTING_PERIOD_NOT_OPEN:
        "会計期間が OPEN ではありません。",
      AR_AP_DIFFERENCE_ACCOUNTING_PERIOD_NOT_FOUND:
        "会計期間が見つかりません。",
      AR_AP_DIFFERENCE_ACCOUNTING_DATE_BEFORE_EVIDENCE_DATE:
        "計上日が確証日より前です。",
      AR_AP_DIFFERENCE_ACCOUNTING_DATE_FISCAL_YEAR_MISMATCH:
        "計上日の会計年度が一致しません。",
      AR_AP_DIFFERENCE_ACCOUNTING_SNAPSHOT_IMMUTABLE:
        "会計スナップショットは不変です。",
      AR_AP_DIFFERENCE_ACCOUNTING_SOURCE_NOT_ELIGIBLE:
        "差額ソースが会計対象外です。",
      AR_AP_DIFFERENCE_ACCOUNTING_ACCOUNT_INACTIVE: "会計科目が無効です。",
      AR_AP_DIFFERENCE_ACCOUNTING_NOT_READY: "差額会計が未準備です。",
      AR_AP_DIFFERENCE_ACCOUNTING_ACCOUNTS_REQUIRED: "会計科目が必要です。",
      AR_AP_DIFFERENCE_ACCOUNTING_ACCOUNT_COLLISION:
        "会計科目衝突が検出されました。",
    },
  },

  settlementWrite: {
    actions: {
      addAllocation: "消込する",
      create: "消込を確定",
      loadMore: "さらに読み込む",
    },
    dialog: {
      createTitle: "消込",
      createDescription:
        "入金/出金と売掛/買掛の間に確定済みの消込を作成します。",
    },
    fields: {
      amount: "消込額",
      suggested: "推奨額",
      maximum: "上限額",
      unallocated: "未消込額",
      remaining: "残額",
      selectPayment: "入金/出金を選択",
      selectObligation: "売掛/買掛を選択",
      searchCandidates: "候補を検索",
    },
    empty: {
      noEligiblePayment: "消込可能な入金/出金がありません",
      noEligibleObligation: "消込可能な売掛/買掛がありません",
    },
    validation: {
      INVALID: "正の整数金額を入力してください。",
      OVER_PAYMENT: "入金の未消込額を超えています。",
      OVER_OBLIGATION: "売掛/買掛の残額を超えています。",
    },
    errors: {
      versionConflict:
        "他の操作により状態が更新されました。残額を確認して再度確定してください。",
      reloadFailed: "バージョンの再読込に失敗しました。",
    },
    void: {
      title: "消込を取り消す",
      description:
        "消込を無効化します。転記済み仕訳は自動では取り消されません。",
      reason: "理由（任意）",
      confirm: "消込を取り消す",
      reversalRequired:
        "仕訳済みのため、消込を取り消す前に取消仕訳が必要です。",
      viewProgress: "会計進捗を表示",
    },
    failureCodes: {
      UNKNOWN: "消込に失敗しました。",
      SETTLEMENT_FEATURE_DISABLED: "消込機能は現在無効です。",
      SETTLEMENT_PAYMENT_NOT_FOUND: "入金/出金が見つかりません。",
      SETTLEMENT_OBLIGATION_NOT_FOUND: "売掛/買掛が見つかりません。",
      SETTLEMENT_ALLOCATION_NOT_FOUND: "消込が見つかりません。",
      SETTLEMENT_PAYMENT_NOT_CONFIRMED: "確定済みの入金/出金のみ消込できます。",
      SETTLEMENT_PAYMENT_CANCELLED: "取消済みの入金/出金は消込できません。",
      SETTLEMENT_OBLIGATION_NOT_OPEN: "OPEN の売掛/買掛のみ消込できます。",
      SETTLEMENT_DIRECTION_MISMATCH:
        "入金/出金の方向と売掛/買掛の区分が一致しません。",
      SETTLEMENT_ACCOUNTING_BOOK_MISMATCH: "会計帳簿が一致しません。",
      SETTLEMENT_CURRENCY_UNSUPPORTED: "JPY のみ対応しています。",
      SETTLEMENT_AMOUNT_INVALID: "消込額が不正です。",
      SETTLEMENT_PAYMENT_OVER_ALLOCATED: "消込額が入金/出金を超えます。",
      SETTLEMENT_OBLIGATION_OVER_ALLOCATED: "消込額が売掛/買掛を超えます。",
      SETTLEMENT_PAYMENT_VERSION_CONFLICT: "入金/出金が同時更新されました。",
      SETTLEMENT_OBLIGATION_VERSION_CONFLICT: "売掛/買掛が同時更新されました。",
      SETTLEMENT_ALLOCATION_VERSION_CONFLICT: "消込が同時更新されました。",
      SETTLEMENT_CONCURRENCY_CONFLICT:
        "消込の同時実行競合です。再試行してください。",
      SETTLEMENT_STATUS_TRANSITION_INVALID: "無効な消込ステータス遷移です。",
      SETTLEMENT_VOID_REQUIRES_REVERSAL: "転記済みのため取消仕訳が必要です。",
      IDEMPOTENCY_KEY_REQUIRED: "冪等キーが必要です。",
      IDEMPOTENCY_KEY_INVALID: "冪等キーが不正です。",
      IDEMPOTENCY_IN_PROGRESS: "同一リクエストが処理中です。",
      IDEMPOTENCY_KEY_PAYLOAD_CONFLICT:
        "冪等キーが別ペイロードで再利用されました。",
    },
  },

  settlementAccounting: {
    section: {
      title: "消込・会計進捗",
      empty: "この義務に紐づく消込はありません。",
      viewPayment: "入出金を表示",
    },
    panel: {
      title: "会計進捗",
      allocationAmount: "消込金額",
      retryHint:
        "再試行は現在の状態から会計処理を再開します。消込・取引・科目・仕訳の再確定は行いません。",
    },
    stages: {
      settlement: "消込",
      transaction: "取引",
      classification: "科目",
      journal: "仕訳",
      posting: "転記",
      posted: "転記済",
    },
    allocationStatus: {
      CONFIRMED: "消込済み",
      VOIDED: "取消済み",
    },
    actions: {
      retry: "会計処理を再試行",
      resolveDate: "仕訳日付を指定",
      configureBankGlMapping: "銀行科目マッピングを設定",
      setArApAccount: "売掛/買掛科目を設定",
    },
    fields: {
      accountingDate: "仕訳日付",
      businessTransaction: "業務取引",
      classification: "勘定科目分類",
      journalDraft: "仕訳下書き",
      posting: "転記リクエスト",
      postedJournal: "転記済仕訳",
    },
    warnings: {
      needsReversal:
        "転記済みのため、取消仕訳が必要です。消込の取消だけでは元帳は戻りません。",
    },
    featureDisabled: {
      banner:
        "消込そのものは有効です。このテナントでは会計オーケストレーションが無効のため、自動会計処理は実行されません。",
    },
    dateDialog: {
      title: "仕訳日付を指定",
      description: "支払日は変更されません。仕訳日付は会計・転記用の日付です。",
      paymentDate: "支払日（参照）",
      paymentDateHint: "支払日は証拠として保持され、変更されません。",
      accountingDate: "仕訳日付",
      openPeriodHint: "OPEN の会計期間に属する日付のみ指定できます。",
      submit: "確定",
      errors: {
        required: "仕訳日付を入力してください。",
      },
    },
    outcomes: {
      UNKNOWN: { label: "状態不明", description: "会計進捗を確認できません。" },
      SOURCE_NOT_READY: {
        label: "準備中",
        description: "会計ソースの準備が完了していません。",
      },
      WAITING_ACCOUNTING_DATE: {
        label: "仕訳日付の指定が必要",
        description:
          "支払日が OPEN 期間でないため、仕訳日付の明示指定が必要です。",
      },
      WAITING_BANK_ACCOUNT_MAPPING: {
        label: "銀行科目マッピング待ち",
        description: "銀行口座の GL マッピングを設定してください。",
      },
      WAITING_AR_AP_ACCOUNT: {
        label: "売掛/買掛科目待ち",
        description: "義務に売掛/買掛科目を設定してください。",
      },
      WAITING_TRANSACTION_CONFIRMATION: {
        label: "取引確認待ち",
        description: "業務取引の確認が必要です。",
      },
      WAITING_CLASSIFICATION_CONFIRMATION: {
        label: "勘定科目確認待ち",
        description: "分類結果の確認が必要です。",
      },
      CLASSIFICATION_ENSURED: {
        label: "科目案を作成済み",
        description: "分類は作成済みです。確認待ちです。",
      },
      JOURNAL_ENSURED: {
        label: "仕訳下書き作成済み",
        description: "仕訳下書きは作成済みです。確認待ちです。",
      },
      WAITING_JOURNAL_CONFIRMATION: {
        label: "仕訳確認待ち",
        description: "仕訳の確認が必要です。",
      },
      WAITING_JOURNAL_REVIEW: {
        label: "仕訳レビュー待ち",
        description: "仕訳レビューの承認が必要です。",
      },
      WAITING_OPEN_PERIOD: {
        label: "会計期間 OPEN 待ち",
        description:
          "対象期間が OPEN ではありません。日付または期間を確認してください。",
      },
      ORCHESTRATION_DISABLED: {
        label: "会計オーケストレーション無効",
        description: "機能フラグにより自動会計処理は停止中です。",
      },
      POSTING_REQUESTED: {
        label: "転記リクエスト済み",
        description: "転記処理の開始を待機しています。",
      },
      POSTING_ALREADY_ENSURED: {
        label: "転記リクエスト確保済み",
        description: "転記リクエストは既に存在します。",
      },
      POSTING_IN_PROGRESS: {
        label: "転記処理中",
        description: "転記ワーカーが処理中です。",
      },
      POSTED: {
        label: "転記済み",
        description:
          "転記済仕訳が作成されています。消込ステータス自体は消込済みのままです。",
      },
      POSTING_RETRYABLE_FAILED: {
        label: "転記失敗（再試行可）",
        description: "転記は再試行可能な失敗状態です。",
      },
      POSTING_PERMANENTLY_FAILED: {
        label: "転記失敗（恒久）",
        description: "転記は恒久失敗です。運用介入が必要です。",
      },
      NEEDS_REVERSAL: {
        label: "取消仕訳が必要",
        description: "転記済みのため、取消仕訳ワークフローが必要です。",
      },
      ACCOUNTING_REVERSED: {
        label: "会計取消済み",
        description: "対応する取消仕訳が完了しています。",
      },
      TARGET_TERMINAL: {
        label: "終端状態",
        description: "これ以上の会計確保は不要です。",
      },
      FAILED: {
        label: "処理失敗",
        description: "会計処理に失敗しました。再試行を検討してください。",
      },
      ALREADY_READY_FOR_POSTING: {
        label: "転記準備完了",
        description: "人的ゲート完了後、転記リクエストを作成できます。",
      },
      POSTING_BLOCKED_FOUNDATION_FLAG: {
        label: "転記ゲートブロック",
        description: "基盤転記フラグにより転記がブロックされています。",
      },
      BOOK_MISMATCH: {
        label: "会計帳簿不一致",
        description: "支払と義務の会計帳簿が一致しません。",
      },
      ACCOUNT_INACTIVE: {
        label: "科目が無効",
        description: "スナップショット科目が ACTIVE ではありません。",
      },
      DIRECTION_SIDE_MISMATCH: {
        label: "方向・区分不一致",
        description: "支払方向と義務区分が整合しません。",
      },
    },
    failureCodes: {
      UNKNOWN: "会計処理に失敗しました。",
      SETTLEMENT_ACCOUNTING_FEATURE_DISABLED:
        "会計オーケストレーションは現在無効です。",
      SETTLEMENT_ACCOUNTING_DATE_REQUIRED: "仕訳日付の指定が必要です。",
      SETTLEMENT_ACCOUNTING_PERIOD_NOT_OPEN:
        "指定日の会計期間が OPEN ではありません。",
      SETTLEMENT_ACCOUNTING_BOOK_MISMATCH: "会計帳簿が一致しません。",
      SETTLEMENT_ACCOUNTING_BANK_ACCOUNT_MAPPING_REQUIRED:
        "銀行 GL マッピングが必要です。",
      SETTLEMENT_ACCOUNTING_AR_AP_ACCOUNT_REQUIRED:
        "売掛/買掛科目の設定が必要です。",
      SETTLEMENT_VOID_REQUIRES_REVERSAL: "転記済みのため取消仕訳が必要です。",
      SETTLEMENT_ALLOCATION_NOT_FOUND: "消込が見つかりません。",
      ACCOUNTING_PERIOD_NOT_OPEN: "会計期間が OPEN ではありません。",
      REVIEW_CASE_NOT_APPROVED: "仕訳レビューが未承認です。",
    },
  },

  bankAccountSettings: {
    page: {
      title: "口座設定",
      subtitle:
        "銀行・カード口座の登録と、会計帳簿への GL 科目マッピングをまとめて管理します。",
    },
    tabs: {
      accounts: "口座マスタ",
      glMappings: "GL マッピング",
    },
  },
  bankGlMapping: {
    page: {
      title: "銀行口座 会計設定",
      subtitle:
        "ワークスペース銀行口座と GL 勘定科目のマッピングを管理します。",
    },
    fields: {
      bankAccount: "銀行口座",
      maskedAccount: "口座番号（マスク）",
      bankBranch: "銀行/支店",
      accountingBook: "会計帳簿",
      mappedAccount: "マッピング科目",
      status: "マッピング状態",
      updatedAt: "更新日時",
      action: "操作",
    },
    filters: {
      bankAccount: "銀行口座",
      mappingStatus: "マッピング状態",
      allBankAccounts: "すべての口座",
      allStatuses: "すべて",
      mapped: "マッピング済み",
      unmapped: "未マッピング",
    },
    status: {
      mapped: "マッピング済み",
      unmapped: "未マッピング",
    },
    actions: {
      configure: "マッピングを設定",
      change: "マッピングを変更",
      save: "マッピングを保存",
      saving: "保存中…",
      archive: "マッピングをアーカイブ",
      archiving: "アーカイブ中…",
      refresh: "更新",
      return: "戻る",
    },
    dialog: {
      createTitle: "銀行科目マッピングを作成",
      editTitle: "銀行科目マッピングを編集",
      description:
        "同一会計帳簿の ACTIVE 資産科目を選択してください。9990 仮勘定は使用できません。",
    },
    archiveDialog: {
      title: "このマッピングをアーカイブしますか？",
      description:
        "アーカイブ後は非アクティブになります。過去の消込会計スナップショットは書き換えられません。",
    },
    selector: {
      placeholder: "科目を選択",
      ariaLabel: "GL 科目セレクター",
    },
    empty: {
      title: "マッピングデータがありません",
      description: "銀行口座を追加するか、フィルターを調整してください。",
      manageAccounts: "銀行口座を管理",
    },
    readOnly: "参照のみ",
    errors: {
      loadFailed: "銀行科目マッピングの読み込みに失敗しました",
      noPermissionTitle: "アクセス権がありません",
      noPermission: "銀行科目マッピングを表示する権限がありません。",
    },
    failureCodes: {
      UNKNOWN: "銀行科目マッピング操作に失敗しました。",
      WORKSPACE_BANK_ACCOUNT_NOT_FOUND: "銀行口座が見つかりません。",
      WORKSPACE_BANK_ACCOUNT_ARCHIVED:
        "銀行口座はアーカイブ済みのため更新できません。",
      SETTLEMENT_ACCOUNTING_BOOK_NOT_ACTIVE: "会計帳簿が有効ではありません。",
      SETTLEMENT_ACCOUNTING_ACCOUNT_INACTIVE:
        "選択した科目は有効ではありません。",
      SETTLEMENT_ACCOUNTING_ACCOUNT_NOT_ELIGIBLE:
        "選択した科目は銀行現金科目として使用できません。",
      BANK_ACCOUNT_GL_MAPPING_NOT_FOUND:
        "マッピングが見つかりません。一覧を更新しました。",
      WORKSPACE_PERMISSION_DENIED:
        "銀行科目マッピングを管理する権限がありません。",
    },
  },

  bankAccounts: {
    page: {
      title: "銀行口座",
      subtitle:
        "ワークスペースの銀行口座・カード口座を登録し、インポートと会計設定の前提を整えます。",
    },
    actions: {
      create: "口座を追加",
      edit: "編集",
      archive: "アーカイブ",
    },
    filters: {
      status: "ステータス",
      active: "有効",
      archived: "アーカイブ済",
      all: "すべて",
    },
    fields: {
      displayName: "表示名",
      accountType: "口座種別",
      bankBranch: "銀行 / 支店",
      bankCode: "銀行コード",
      bankName: "銀行名",
      branchCode: "支店コード",
      branchName: "支店名",
      accountNumberMasked: "口座番号（マスク）",
      externalAccountKey: "外部口座キー",
      currency: "通貨",
      status: "ステータス",
      updatedAt: "更新日時",
      action: "操作",
    },
    accountTypes: {
      ORDINARY: "普通預金",
      CURRENT: "当座預金",
      SAVINGS: "貯蓄預金",
      CREDIT_CARD: "クレジットカード",
      OTHER: "その他",
    },
    status: {
      active: "有効",
      archived: "アーカイブ済",
    },
    placeholders: {
      externalAccountKey: "例：BANK_001",
      accountNumberMasked: "例：****1234",
    },
    hints: {
      externalAccountKey:
        "ワークスペース内で一意の識別子です。作成後は変更できません。",
      accountNumberMasked:
        "平文の口座番号は保存できません。末尾などマスク済みの値のみ入力してください。",
    },
    dialog: {
      createTitle: "銀行口座を追加",
      editTitle: "銀行口座を編集",
      description:
        "表示名と口座属性を設定します。実口座番号の平文は入力しないでください。",
    },
    archiveDialog: {
      title: "この口座をアーカイブしますか？",
      description:
        "「{name}」をアーカイブします。新規インポートでは選べなくなりますが、既存データは保持されます。",
    },
    empty: {
      title: "銀行口座がありません",
      descriptionWithCreate:
        "銀行口座またはカード口座を追加すると、明細インポートと GL マッピングを開始できます。",
      descriptionReadOnly: "表示できる銀行口座はありません。",
      filteredTitle: "条件に一致する口座がありません",
      filteredDescription: "ステータスフィルタを変更してください。",
    },
    readOnly: "参照のみ",
    errors: {
      loadFailed: "銀行口座一覧の読み込みに失敗しました",
      createFailed: "銀行口座の作成に失敗しました",
      updateFailed: "銀行口座の更新に失敗しました",
      archiveFailed: "銀行口座のアーカイブに失敗しました",
      noPermissionTitle: "アクセス権がありません",
      noPermission: "銀行口座を表示する権限がありません。",
    },
  },

  accountingExport: {
    title: "会計データ出力",
    description: "転記済み仕訳を汎用CSV形式でエクスポートします。",
    format: {
      GENERIC_CSV: "汎用CSV",
      unknown: "不明な形式",
    },
    status: {
      REQUESTED: "受付済み",
      GENERATING: "作成中",
      READY: "ダウンロード可能",
      FAILED: "作成失敗",
      EXPIRED: "期限切れ",
      processing: "作成中",
    },
    table: {
      requestedAt: "受付日時",
      book: "会計帳簿",
      period: "仕訳日付期間",
      format: "形式",
      status: "状態",
      lineCount: "行数",
      expiresAt: "有効期限",
      actions: "操作",
    },
    filters: {
      status: "状態",
      book: "会計帳簿",
      allStatuses: "すべての状態",
      allBooks: "すべての帳簿",
      reset: "フィルターをリセット",
    },
    actions: {
      create: "新しいエクスポート",
      download: "ダウンロード",
      retry: "再試行",
      reExport: "同じ条件で新規作成",
    },
    create: {
      title: "新しいエクスポート",
      description:
        "仕訳日付の期間を指定して、転記済み仕訳をエクスポートします。",
      book: "会計帳簿",
      bookPlaceholder: "会計帳簿を選択",
      periodLabel: "仕訳日付の期間",
      periodHint: "仕訳日付（journalDate）の範囲を指定してください。",
      format: "出力形式",
      submit: "エクスポートを作成",
      errors: {
        bookRequired: "会計帳簿を選択してください。",
        periodRequired: "期間を指定してください。",
        invalidPeriod: "開始日は終了日以前である必要があります。",
        periodTooLong: "期間は最大 {maxDays} 日までです。",
      },
    },
    retry: {
      confirmTitle: "エクスポートを再試行しますか？",
      confirmDescription:
        "作成時に凍結されたデータを使用して、同じエクスポート要求からファイルを再生成します。",
    },
    empty: {
      title: "エクスポート履歴がありません",
      descriptionWithCreate:
        "転記済み仕訳をエクスポートして、会計ソフトへ取り込みます。",
      descriptionReadOnly: "表示できるエクスポート履歴はありません。",
      filteredTitle: "該当する記録がありません",
      filteredDescription: "条件に一致するエクスポートは見つかりませんでした。",
    },
    featureDisabled: {
      banner:
        "現在、新しいエクスポートの作成は利用できません。既存のエクスポート履歴は引き続き閲覧・ダウンロードできます。",
    },
    errors: {
      listFailed: "エクスポート一覧の取得に失敗しました。",
      createFailed: "エクスポートの作成に失敗しました。",
      retryFailed: "エクスポートの再試行に失敗しました。",
      downloadFailed: "ダウンロードURLの取得に失敗しました。",
      readForbidden: "このページを表示する権限がありません。",
      genericFailure: "エクスポートの作成に失敗しました。",
    },
    failureCodes: {
      ACCOUNTING_EXPORT_FEATURE_DISABLED:
        "新しいエクスポートの作成は現在利用できません。",
      ACCOUNTING_EXPORT_INVALID_PERIOD: "指定した期間は無効です。",
      ACCOUNTING_EXPORT_TOO_LARGE: "エクスポート対象が大きすぎます。",
      ACCOUNTING_EXPORT_EXPIRED:
        "エクスポートファイルの有効期限が切れています。新しいエクスポートを作成してください。",
      ACCOUNTING_EXPORT_NOT_READY:
        "エクスポートファイルはまだ準備できていません。",
      ACCOUNTING_EXPORT_RETRY_NOT_ALLOWED:
        "このエクスポートは再試行できません。",
      ACCOUNTING_EXPORT_FORMAT_NOT_SUPPORTED:
        "指定した出力形式はサポートされていません。",
      ENQUEUE_FAILED:
        "エクスポート処理の開始に失敗しました。再試行してください。",
      WORKER_TIMEOUT: "エクスポート処理がタイムアウトしました。",
      GENERATION_FAILED: "エクスポートファイルの生成に失敗しました。",
      STORAGE_UPLOAD_FAILED: "エクスポートファイルの保存に失敗しました。",
      ACCOUNTING_EXPORT_SOURCE_QUERY_FAILED:
        "エクスポート元データの取得に失敗しました。",
      WORKSPACE_PERMISSION_DENIED: "この操作を行う権限がありません。",
      IDEMPOTENCY_KEY_REUSED: "同じリクエストが既に処理されています。",
    },
  },
  bankImport: {
    title: "銀行明細インポート",
    description:
      "銀行明細 CSV をアップロードし、インポートバッチの状況を確認します。",
    status: {
      RECEIVED: "受付済",
      QUEUED: "待機中",
      PARSING: "解析中",
      PARSED: "解析完了",
      NORMALIZING: "正規化中",
      READY_FOR_MATCHING: "照合待ち",
      PARTIALLY_READY: "一部対応済",
      FAILED: "インポート失敗",
      CANCELLED: "キャンセル済",
      processing: "処理中",
    },
    statusPhase: {
      WAITING: "待機中",
      RUNNING: "実行中",
      SUCCEEDED: "インポート成功",
      FAILED: "インポート失敗",
    },
    parseStatus: {
      STORED: "保存済",
      PARSE_ERROR: "解析エラー",
    },
    normalizationStatus: {
      NORMALIZED: "正規化済",
      FAILED: "正規化失敗",
      DUPLICATE_SKIPPED: "重複スキップ",
      unknown: "不明",
    },
    direction: {
      WITHDRAWAL: "出金",
      DEPOSIT: "入金",
      unknown: "不明",
    },
    errorStage: {
      PARSING: "解析ステージ",
      NORMALIZATION: "正規化ステージ",
      unknown: "不明",
    },
    table: {
      created: "作成日時",
      bankAccount: "銀行口座",
      file: "ファイル",
      rows: "行数",
      normalized: "正規化済",
      duplicate: "重複",
      failed: "失敗",
      status: "ステータス",
      createdBy: "作成者",
      actions: "操作",
    },
    filters: {
      status: "ステータス",
      bankAccount: "銀行口座",
      allStatuses: "すべてのステータス",
      allAccounts: "すべての口座",
      apply: "絞り込み",
      reset: "リセット",
    },
    actions: {
      upload: "明細をアップロード",
      download: "ダウンロード",
      retry: "再試行",
      cancel: "キャンセル",
      detail: "詳細",
    },
    upload: {
      title: "銀行明細のアップロード",
      description:
        "ワークスペースの口座を選択し、対応フォーマットの CSV をアップロードします。",
      bankAccount: "ワークスペース口座",
      bankAccountPlaceholder: "口座を選択",
      file: "CSV ファイル",
      fileHint:
        ".csv ファイルを選択します。楽天カード e-navi は UTF-8 / Shift-JIS に対応します。",
      fileDrop: "クリックして選択またはファイルをドラッグ",
      clearFile: "ファイルを削除",
      noAccounts: "このワークスペースには利用可能な銀行口座がありません。",
      noCardAccounts:
        "カード明細用のクレジットカード口座がありません。下から作成できます。",
      format: "解析フォーマット",
      formatOptions: {
        GENERIC_BANK_CSV_V1: "GENERIC_BANK_CSV_V1（汎用銀行 CSV）",
        RAKUTEN_ENAVI_CARD_CSV_V1: "楽天カード e-navi CSV",
      },
      formatHints: {
        GENERIC_BANK_CSV_V1:
          "英字ヘッダー（transaction_date, amount, direction, description）の UTF-8 CSV。",
        RAKUTEN_ENAVI_CARD_CSV_V1:
          "利用日 / 利用店名・商品名 / 利用金額 を含む e-navi 明細 CSV。クレジットカード口座が必要です。",
      },
      downloadTemplate: "テンプレートをダウンロード",
      createCardAccountTitle: "クレジットカード口座を作成",
      createCardAccountHint:
        "e-navi 明細は CREDIT_CARD 口座にのみインポートできます。",
      createCardAccountPlaceholder: "例: 楽天カード",
      createCardAccount: "カード口座を作成",
      creatingCardAccount: "作成中…",
      submit: "インポート開始",
      errors: {
        bankAccountRequired: "ワークスペース口座を選択してください。",
        fileRequired: "CSV ファイルを選択してください。",
        fileType: ".csv ファイルのみ対応しています。",
        cardAccountNameRequired: "カード口座名を入力してください。",
      },
    },
    retry: {
      confirmTitle: "このインポートを再試行しますか？",
      confirmDescription: "元のファイルを再解析・正規化します。",
    },
    cancel: {
      confirmTitle: "このインポートをキャンセルしますか？",
      confirmDescription:
        "待機中のバッチはキャンセルされます。処理済みデータは監査のため保持されます。",
    },
    empty: {
      title: "インポートバッチがありません",
      descriptionWithCreate:
        "銀行明細 CSV をアップロードしてインポートを開始します。",
      descriptionReadOnly: "表示可能なインポートバッチがありません。",
      filteredTitle: "条件に一致するバッチがありません",
      filteredDescription: "現在のフィルタ条件に一致するバッチがありません。",
    },
    featureDisabled: {
      banner:
        "現在、新しいインポートバッチを作成できません。既存のバッチ確認とダウンロードは可能です。",
    },
    errors: {
      listFailed: "インポートバッチ一覧の読み込みに失敗しました。",
      createFailed: "インポートバッチの作成に失敗しました。",
      createCardAccountFailed: "クレジットカード口座の作成に失敗しました。",
      retryFailed: "インポートバッチの再試行に失敗しました。",
      cancelFailed: "インポートバッチのキャンセルに失敗しました。",
      downloadFailed: "ダウンロード URL の取得に失敗しました。",
      detailFailed: "バッチ詳細の読み込みに失敗しました。",
      bankAccountsFailed: "銀行口座一覧の読み込みに失敗しました。",
      readForbidden: "このページを表示する権限がありません。",
      genericFailure: "インポート処理に失敗しました。",
    },
    detail: {
      title: "バッチ詳細",
      empty: "データがありません",
      noErrors: "エラーがありません",
      prevPage: "前のページ",
      nextPage: "次のページ",
      pageOf: "{page} / {total} ページ",
      tabs: {
        summary: "概要",
        raw: " raw 行",
        normalized: "正規化行",
        errors: "エラー",
        audit: "監査タイムライン",
      },
      summary: {
        status: "ステータス",
        created: "作成日時",
        finished: "完了日時",
        attempt: "試行回数",
        rawCount: "raw 行数",
        normalizedCount: "正規化行数",
        duplicateCount: "重複行数",
        failedCount: "失敗行数",
        blankCount: "空行数",
      },
      raw: {
        lineNumber: "行番号",
        attempt: "試行",
        parseStatus: "解析状態",
        payload: "生データ",
      },
      normalized: {
        line: "行",
        date: "取引日",
        amount: "金額",
        direction: "方向",
        description: "説明",
        status: "正規化状態",
      },
      errors: {
        line: "行",
        stage: "ステージ",
        code: "エラーコード",
        message: "説明",
      },
      audit: {
        actor: "実行者",
      },
    },
    audit: {
      "bank_import.received": "受付済",
      "bank_import.queued": "キュー投入済",
      "bank_import.retried": "再試行済",
      "bank_import.cancelled": "キャンセル済",
      "bank_import.enqueue_failed": "キュー投入失敗",
      "bank_import.download_url_issued": "ダウンロード URL 発行",
      "bank_import.parsing_started": "解析開始",
      "bank_import.parsed": "解析完了",
      "bank_import.normalization_started": "正規化開始",
      "bank_import.ready_for_matching": "照合待ち完了",
      "bank_import.partially_ready": "一部対応済",
      "bank_import.failed": "インポート失敗",
      "bank_import.line_failed": "行処理失敗",
    },
    lineErrorMessages: {
      BANK_IMPORT_REQUIRED_HEADER_MISSING: "必須ヘッダーが不足しています。",
      BANK_IMPORT_DUPLICATE_HEADER: "重複するヘッダーがあります。",
      BANK_IMPORT_COLUMN_LIMIT_EXCEEDED: "列数が上限を超えています。",
      BANK_IMPORT_ROW_LIMIT_EXCEEDED: "行数が上限を超えています。",
      BANK_IMPORT_CSV_MALFORMED: "CSV 形式が不正です。",
      BANK_IMPORT_ROW_COLUMN_COUNT_MISMATCH:
        "行の列数がヘッダーと一致しません。",
      BANK_LINE_INVALID_DATE: "日付形式が無効です。",
      BANK_LINE_INVALID_AMOUNT: "金額形式が無効です。",
      BANK_LINE_INVALID_DIRECTION: "方向フィールドが無効です。",
      BANK_LINE_UNSUPPORTED_CURRENCY: "未対応の通貨です。",
      BANK_LINE_EMPTY_DESCRIPTION: "説明が空です。",
      BANK_LINE_DUPLICATE: "重複行です。",
      BANK_LINE_NORMALIZATION_FAILED: "正規化に失敗しました。",
    },
    failureCodes: {
      BANK_IMPORT_FEATURE_DISABLED:
        "現在、新しいインポートバッチを作成できません。",
      BANK_IMPORT_ENQUEUE_FAILED:
        "インポート処理の開始に失敗しました。再試行してください。",
      BANK_IMPORT_STORAGE_FAILED: "ファイルの保存に失敗しました。",
      BANK_IMPORT_UNSUPPORTED_FILE_TYPE: "未対応のファイル形式です。",
      BANK_IMPORT_FILE_TOO_LARGE: "ファイルサイズが上限を超えています。",
      BANK_IMPORT_UNSUPPORTED_ENCODING:
        "未対応のファイルエンコーディングです。",
      BANK_IMPORT_EMPTY_FILE: "ファイルが空です。",
      BANK_IMPORT_REQUIRED_HEADER_MISSING: "必須ヘッダーが不足しています。",
      BANK_IMPORT_DUPLICATE_HEADER: "重複するヘッダーがあります。",
      BANK_IMPORT_COLUMN_LIMIT_EXCEEDED: "列数が上限を超えています。",
      BANK_IMPORT_ROW_LIMIT_EXCEEDED: "行数が上限を超えています。",
      BANK_IMPORT_CSV_MALFORMED: "CSV 形式が不正です。",
      BANK_IMPORT_SOURCE_UNAVAILABLE: "元のファイルが利用できません。",
      BANK_IMPORT_PARSING_FAILED: "解析に失敗しました。",
      BANK_IMPORT_NORMALIZATION_FAILED: "正規化に失敗しました。",
      BANK_IMPORT_ORIGINAL_UNAVAILABLE: "元のファイルが利用できません。",
      BANK_IMPORT_ORIGINAL_EXPIRED: "元のファイルの有効期限が切れています。",
      BANK_IMPORT_NOT_FOUND: "インポートバッチが見つかりません。",
      BANK_IMPORT_RETRY_NOT_ALLOWED: "このバッチは再試行できません。",
      BANK_IMPORT_CANCEL_NOT_ALLOWED: "このバッチはキャンセルできません。",
      BANK_LINE_INVALID_DATE: "日付形式が無効です。",
      BANK_LINE_INVALID_AMOUNT: "金額形式が無効です。",
      BANK_LINE_INVALID_DIRECTION: "方向フィールドが無効です。",
      BANK_LINE_UNSUPPORTED_CURRENCY: "未対応の通貨です。",
      BANK_LINE_EMPTY_DESCRIPTION: "説明が空です。",
      BANK_LINE_DUPLICATE: "重複行です。",
      BANK_LINE_NORMALIZATION_FAILED: "正規化に失敗しました。",
      IDEMPOTENCY_KEY_REQUIRED: "冪等キーが不足しています。",
      IDEMPOTENCY_KEY_REUSED: "冪等キーは既に使用済みです。",
      ENQUEUE_FAILED: "キュー投入に失敗しました。",
      BANK_ACCOUNT_NOT_FOUND: "銀行口座が見つかりません。",
      BANK_ACCOUNT_ARCHIVED: "銀行口座はアーカイブされています。",
      BANK_IMPORT_ACCOUNT_TYPE_MISMATCH:
        "選択した口座タイプはこの CSV フォーマットに対応していません。",
      WORKSPACE_PERMISSION_DENIED: "この操作を行う権限がありません。",
    },
  },

  periodReconciliation: {
    title: "期間照合",
    subtitle: "銀行明細と業務取引を期間単位で確認します",
    status: {
      matched: "照合済み",
      bankOnly: "銀行側のみ",
      businessOnly: "業務側のみ",
      possibleMatch: "照合候補あり",
      ignored: "対象外",
    },
    summary: {
      bankMatchRate: "銀行照合率",
      bankMatchRateHelp:
        "銀行明細のうち照合済みの割合（対象外は分母に含みません）",
      businessCoverageRate: "業務カバー率",
      businessCoverageRateHelp: "対象業務取引のうち銀行明細と照合済みの割合",
      bankAmount: "銀行金額",
      businessAmount: "業務取引金額",
      bankCount: "銀行明細 {count} 件",
      businessCount: "業務取引 {count} 件",
      periodGap: "期間金額ギャップ（参考）",
      periodGapTooltip:
        "銀行明細と業務取引の期間合計差であり、会計上の差異確定を示すものではありません。",
      periodGapNote: "参考値です。差異決済や未処理差額の確定ではありません。",
      gapOutgoing: "支出側",
      gapIncoming: "入金側",
    },
    exceptions: {
      bankOnly: "銀行側のみ",
      businessOnly: "業務側のみ",
      possibleMatch: "照合候補あり",
    },
    filters: {
      period: "期間",
      account: "銀行口座",
      matchState: "照合状態",
      direction: "入出金",
      flow: "キャッシュフロー",
      allAccounts: "すべての口座",
      allMatchStates: "すべての状態",
      allDirections: "すべて",
      allFlows: "すべて",
      thisMonth: "当月",
      prevMonth: "前月",
      advanced: "詳細フィルタ",
      includeAllSources: "全対象ソースを表示",
      timezoneHint: "期間はワークスペースタイムゾーン（{timezone}）の暦日です",
    },
    tabs: {
      label: "期間照合タブ",
      overview: "概要",
      bank: "銀行明細",
      business: "業務取引",
      difference: "差異",
    },
    direction: {
      WITHDRAWAL: "出金",
      DEPOSIT: "入金",
    },
    flow: {
      OUTFLOW: "支出",
      INFLOW: "入金",
    },
    bankTable: {
      date: "取引日",
      account: "銀行口座",
      description: "摘要",
      counterparty: "取引先",
      reference: "参照",
      direction: "入出金",
      amount: "金額",
      status: "照合状態",
      actions: "操作",
    },
    businessTable: {
      date: "取引日",
      counterparty: "取引先",
      type: "取引種別",
      amount: "金額",
      paymentMethod: "支払方法",
      source: "ソース",
      status: "ステータス",
      reconStatus: "照合状態",
      actions: "操作",
    },
    actions: {
      refresh: "更新",
      apply: "適用",
      openMatching: "照合を確認",
      openBankLine: "銀行明細を確認",
      openDocument: "元票据を開く",
    },
    difference: {
      bankSection: "銀行側（銀行側のみ / 照合候補あり）",
      bankHint: "銀行明細のページングは独立しています。",
      businessSection: "業務側（業務側のみ）",
      businessHint: "業務取引のページングは独立しています。",
    },
    overview: {
      hint: "例外カードをクリックすると、該当する明細タブへ移動します。",
    },
    empty: {
      noSummary: "期間サマリーを表示できません。",
      noExceptionsTitle: "未照合の差異はありません",
      noExceptionsBody:
        "対象期間に銀行側のみ・業務側のみ・照合候補ありはありません。",
    },
    errors: {
      featureDisabled: "期間照合機能が無効です。",
      featureDisabledHelp:
        "bank.reconciliation.period.enabled を有効にしてください。銀行明細照合には影響しません。",
      invalidPeriod:
        "期間が無効です。有効な YYYY-MM-DD を指定し、開始日は終了日以前にしてください。",
      periodTooLarge: "期間の範囲が 12 か月の上限を超えています。",
      unsupportedCurrency: "期間照合は現在 JPY のみ対応しています。",
      permissionDenied: "期間照合を表示する権限がありません。",
      permissionDeniedHelp:
        "bank_match.read と transaction.read の両方が必要です。",
      summaryFailed: "サマリーの読み込みに失敗しました。",
      bankFailed: "銀行明細の読み込みに失敗しました。",
      businessFailed: "業務取引の読み込みに失敗しました。",
    },
  },
  bankEvidence: {
    title: "銀行明細×伝票照合",
    description:
      "出金明細を確認済み伝票セグメントに照合します。入金は表示されません。",
    lineStatus: {
      UNLINKED: "未照合",
      LINKED: "照合済",
      EXCLUDED: "除外",
      NEEDS_REVIEW: "要確認",
    },
    rule: {
      EXACT: "完全一致",
      FUZZY_AMOUNT_DATE: "金額・日付近似",
      FUZZY_AMOUNT_CPTY: "金額・取引先近似",
      AMOUNT_ONLY: "金額のみ",
      MANUAL: "手動",
      unknown: "不明",
    },
    linkSource: {
      CANDIDATE: "候補",
      MANUAL: "手動",
      AUTO: "一括照合",
    },
    reason: {
      exact: "金額・日付・取引先が一致",
      fuzzyAmountDate: "金額・日付が近い",
      fuzzyAmountCpty: "金額・取引先が近い",
      amountOnly: "金額が一致",
      manual: "手動で選んだ",
      unknown: "不明",
    },
    excludeReasons: {
      FEE: "手数料",
      PERSONAL: "個人利用",
      PAPER_HELD: "紙証憑別保管",
      DUPLICATE_ADJUST: "重複・調整",
      OTHER: "その他",
    },
    historyEvent: {
      CANDIDATES_GENERATED: "候補を生成した",
      LINKED: "伝票と照合した",
      EXCLUDED: "照合対象外にした",
      UNLINKED: "照合を解除した",
      NEEDS_REVIEW: "要確認にした",
      unknown: "不明",
    },
    filters: {
      status: "ステータス",
      bankAccount: "銀行口座",
      dateFrom: "開始日",
      dateTo: "終了日",
      dateFromPlaceholder: "開始日を選択",
      dateToPlaceholder: "終了日を選択",
      allStatuses: "すべてのステータス",
      allAccounts: "すべての口座",
      apply: "絞り込み",
      reset: "リセット",
    },
    table: {
      date: "日付",
      amount: "金額",
      description: "摘要",
      evidenceStatus: "照合状態",
      documentNumber: "伝票番号",
      documentNumberUnknown: "番号不明",
      candidateCount: "候補数",
      actions: "操作",
      total: "全 {total} 件 · {page} ページ目（{pageSize} 件/ページ）",
    },
    pagination: {
      prev: "前へ",
      next: "次へ",
    },
    actions: {
      detail: "詳細",
      link: "照合",
      exclude: "除外",
      unlink: "解除",
      refreshCandidates: "候補を更新",
      batchRefreshCandidates: "一括候補更新",
      batchAutoLink: "一括照合",
      searchSegments: "セグメント検索",
      manualSearch: "手動検索",
      addCandidate: "候補に追加",
    },
    featureDisabled: {
      banner:
        "銀行明細×伝票照合機能は現在無効です。一覧と詳細の閲覧はできますが、照合・除外・解除はできません。",
    },
    empty: {
      title: "出金明細がありません",
      description:
        "先に銀行明細を取り込みしてください。ここでは出金のみ表示されます。",
      filteredTitle: "該当する明細がありません",
      filteredDescription: "ステータス、口座、日付の条件を変更してください。",
    },
    detail: {
      title: "照合詳細",
      tabs: {
        summary: "概要",
        history: "履歴",
      },
      summary: {
        date: "日付",
        amount: "金額",
        evidenceStatus: "照合状態",
        candidateCount: "候補数",
        linkSource: "リンク元",
        segment: "伝票セグメント",
        counterparty: "取引先",
        reference: "参照",
        excludeReason: "除外理由",
        linkedDocument: "照合済み伝票",
      },
    },
    candidate: {
      sectionTitle: "候補伝票",
      hint: "銀行明細と候補伝票を照合し、問題なければ照合してください。",
      empty: "保留中の候補がありません。更新するか手動検索を使ってください。",
      segment: "セグメント",
      score: "スコア",
      matchScore: "一致度 {score}%",
      rule: "ルール",
      reason: "理由",
      date: "日付",
      amount: "金額",
      counterparty: "取引先",
      documentNumber: "伝票番号",
      description: "摘要",
      actions: "操作",
      selected: "照合済",
    },
    manual: {
      title: "手動検索",
      hint: "同額の確認済み伝票セグメントを検索し、候補に追加してから概要で照合します。",
      search: "キーワード",
      searchPlaceholder: "取引先、伝票番号…",
      date: "日付",
      amount: "金額",
      counterparty: "取引先",
      documentNumber: "伝票番号",
      empty: "セグメントが見つかりません。検索条件や日付を変更してください。",
      moreHidden: "他 {count} 件は非表示",
    },
    history: {
      empty: "履歴はまだありません。",
      systemActor: "システム",
    },
    batchRefresh: {
      title: "一括候補更新",
      description:
        "現在のフィルター条件で、未照合明細（最大 1000 件）の候補を非同期更新します。完了後は通知センターで結果を確認できます。",
    },
    batchAutoLink: {
      title: "一括照合",
      description:
        "現在のフィルター条件で未照合明細の候補を更新し、取引日と金額が一致する候補が1件だけの明細は照合済、複数ある明細は要確認にします。",
    },
    toast: {
      batchRefreshQueued:
        "未照合 {count} 件の候補更新をキューに投入しました。完了後に通知します。",
      batchAutoLinkQueued:
        "未照合 {count} 件の一括照合をキューに投入しました。完了後に通知します。",
      candidateAdded: "候補に追加しました。",
    },
    exclude: {
      title: "明細を除外",
      description:
        "この出金を証憑不要として除外します。銀行明細自体は削除されません。",
      reasonLabel: "理由",
      noteLabel: "メモ",
      notePlaceholder: "「その他」の場合は {min} 文字以上",
      noteHint: "「その他」を選んだ場合は {min} 文字以上のメモが必要です。",
    },
    unlink: {
      title: "照合を解除",
      description:
        "有効な照合または除外を解除し、再度照合できるようにします。会計記録は変更されません。",
    },
    failureCodes: {
      BANK_EVIDENCE_FEATURE_DISABLED: "銀行明細×伝票照合機能が無効です。",
      BANK_EVIDENCE_NOT_FOUND: "明細行または候補が見つかりません。",
      BANK_EVIDENCE_NOT_WITHDRAWAL: "出金明細のみ照合できます。",
      BANK_EVIDENCE_SEGMENT_NOT_ELIGIBLE:
        "この伝票セグメントは照合対象外です。",
      BANK_EVIDENCE_EXCLUDE_REASON_REQUIRED: "除外理由を選択してください。",
      BANK_EVIDENCE_EXCLUDE_NOTE_REQUIRED:
        "「その他」を選んだ場合は 8 文字以上のメモが必要です。",
      BANK_EVIDENCE_LINE_ALREADY_ACTIVE:
        "この明細行は既に照合済または除外済です。",
      BANK_EVIDENCE_CANDIDATE_NOT_AVAILABLE:
        "候補の有効期限切れ、または利用できません。更新して再試行してください。",
      BANK_EVIDENCE_BATCH_TOO_LARGE:
        "未照合明細が 1000 件を超えています。フィルターを絞り込んでください。",
      BANK_EVIDENCE_BATCH_EMPTY: "現在の条件に未照合明細がありません。",
      WORKSPACE_PERMISSION_DENIED: "この操作を行う権限がありません。",
      IDEMPOTENCY_KEY_REQUIRED: "冪等キーが不足しています。",
      IDEMPOTENCY_KEY_REUSED: "冪等キーは既に使用済みです。",
      VALIDATION_FAILED: "入力内容が不正です。",
    },
    errors: {
      listFailed: "明細の読み込みに失敗しました。",
      detailFailed: "詳細の読み込みに失敗しました。",
      linkFailed: "照合に失敗しました。",
      excludeFailed: "除外に失敗しました。",
      unlinkFailed: "解除に失敗しました。",
      refreshFailed: "候補の更新に失敗しました。",
      batchRefreshFailed: "一括候補更新に失敗しました。",
      batchAutoLinkFailed: "一括照合に失敗しました。",
      addCandidateFailed: "候補の追加に失敗しました。",
      segmentSearchFailed: "セグメント検索に失敗しました。",
      readForbidden: "銀行明細×伝票照合を表示する権限がありません。",
      conflict:
        "この明細は他で更新されました。再読み込みしてから再試行してください。",
      genericFailure: "処理に失敗しました。もう一度お試しください。",
    },
  },
  bankMatch: {
    title: "銀行明細照合",
    description: "銀行明細行と候補を照合し、確認意思決定を行います。",
    status: {
      UNKNOWN: "未確定",
      UNMATCHED: "未照合",
      CANDIDATES_READY: "候補準備済",
      MATCH_SELECTED: "候補選択済",
      REVIEW_REQUIRED: "レビュー必要",
      CONFIRMED: "確定済",
    },
    lineStatus: {
      UNMATCHED: "未照合",
      MATCHED: "照合済",
      IGNORED: "除外",
    },
    direction: {
      WITHDRAWAL: "出金",
      DEPOSIT: "入金",
      unknown: "不明",
    },
    rule: {
      EXACT: "完全一致",
      FUZZY_AMOUNT_DATE: "金額・日付近似",
      FUZZY_AMOUNT_COUNTERPARTY: "金額・取引先近似",
      AMOUNT_ONLY: "金額のみ",
      unknown: "不明",
    },
    targetType: {
      BUSINESS_TRANSACTION: "取引",
      POSTED_JOURNAL: "仕訳",
      unknown: "不明",
    },
    candidateStatus: {
      PENDING: "保留中",
      SELECTED: "選択済",
      REJECTED: "却下",
      EXPIRED: "期限切れ",
      unknown: "不明",
    },
    historyEvent: {
      CANDIDATE_SELECTED: "候補選択",
      REVIEW_REQUESTED: "レビュー要求",
      REVIEW_REJECTED: "レビュー差戻し",
      MATCH_CONFIRMED: "照合確定",
      MATCH_OVERRIDDEN: "強制上書き",
      VERSION_CONFLICT: "バージョン競合",
      unknown: "不明",
    },
    filters: {
      status: "ステータス",
      bankAccount: "銀行口座",
      dateFrom: "開始日",
      dateFromPlaceholder: "開始日を選択",
      allStatuses: "すべてのステータス",
      allAccounts: "すべての口座",
      reset: "フィルタ解除",
    },
    table: {
      date: "日付",
      amount: "金額",
      direction: "方向",
      description: "説明",
      matchStatus: "照合状態",
      candidateCount: "候補数",
      decisionStatus: "意思決定状態",
      actions: "アクション",
    },
    actions: {
      detail: "詳細",
      select: "選択",
      confirm: "確定",
      override: "上書き",
      ignore: "除外",
      unmatch: "照合解除",
    },
    featureDisabled: {
      banner:
        "銀行明細照合機能は現在無効です。一覧と詳細の参照は可能ですが、選択・確定・上書きはできません。",
    },
    ignore: {
      title: "明細行を除外",
      description:
        "この銀行明細行を照合不要としてマークします。削除はしません。",
    },
    unmatch: {
      title: "照合を解除",
      description:
        "照合を解除しても、作成済みの仕訳・転記済みデータは取り消されません。候補の再生成が開始されます。",
    },
    orchestration: {
      title: "会計連携",
      retry: "再試行",
      lastAttempt: "最終試行",
      postingRequest: "転記リクエスト",
      postedJournal: "転記済み仕訳",
      waitingReason: "待機理由",
      reversedWarning:
        "照合後に取消仕訳が作成されています。照合対象は元の仕訳のままです（自動移行・自動解除は行いません）。",
      waitingReasons: {
        TRANSACTION: "取引の確認待ち",
        CLASSIFICATION: "分類の確認待ち",
        JOURNAL: "仕訳の確認待ち",
        PERIOD: "会計期間の開放待ち",
        FEATURE: "会計連携フラグ待ち",
      },
      labels: {
        reconciliationOnly: "照合済み",
        alreadyComplete: "会計処理完了",
        postingRequested: "転記処理を受け付けました",
        waitingTransaction: "確認待ち（取引）",
        waitingClassification: "確認待ち（分類）",
        waitingJournal: "確認待ち（仕訳）",
        periodBlocked: "会計期間が開いていません",
        featureDisabled: "会計連携は現在無効です",
        targetIssue: "対象に問題があります",
        inProgress: "会計連携を処理中",
      },
      descriptions: {
        reconciliationOnly:
          "既存仕訳との関連付けのみです。銀行照合から再度過帳は行いません。",
        alreadyComplete: "会計処理は完了しています。",
        postingRequested:
          "転記リクエストを受け付けました。ワーカーが処理します。",
        waitingTransaction:
          "対象取引の人手確認が必要です。エラーではありません。",
        waitingClassification:
          "分類の人手確認が必要です。エラーではありません。",
        waitingJournal: "仕訳の人手確認が必要です。エラーではありません。",
        periodBlocked:
          "対象期間が OPEN になるまで転記できません。期間修正後に再試行できます。",
        featureDisabled: "会計連携機能が無効です。有効化後に再試行できます。",
        targetNotFound: "照合対象が見つかりません。",
        targetTerminal: "照合対象は終端状態のため、これ以上進められません。",
        inProgress: "不足している会計段階の確保を実行中です。",
      },
    },
    paymentEvidence: {
      title: "入出金エビデンス",
      description:
        "確定済み銀行照合から業務の入出金下書きを作成します。義務への割当はここでは行いません。",
      createDraft: "入出金下書きを作成",
      featureDisabled:
        "銀行照合→入出金下書きは現在無効です。エビデンスは参照できますが、下書き作成はできません。",
      sourceMatchSuperseded:
        "関連付けられた入出金は残っていますが、この銀行照合は有効なソースではなくなりました。",
      linkedPayment: "関連付けられた入出金",
      viewPayment: "入出金ワークスペースで表示",
      paymentStatus: {
        DRAFT: "下書き",
        CONFIRMED: "確定",
        CANCELLED: "取消済み",
        unknown: "不明",
      },
      eligibility: {
        ELIGIBLE: "入出金下書きを作成できます。",
        NOT_CONFIRMED: "入出金下書きを作成する前に照合を確定してください。",
        LINE_NOT_MATCHED: "明細行が照合済みである必要があります。",
        POSTED_JOURNAL_RECONCILIATION_ONLY:
          "転記済み仕訳との照合は照合専用です。入出金下書きは対象外です。",
        MANUAL_TARGET_NOT_ELIGIBLE:
          "手動照合対象では入出金下書きを作成できません。",
        UNSUPPORTED_TARGET: "この照合対象では入出金下書きを作成できません。",
        PAYMENT_ALREADY_EXISTS:
          "この照合には既に入出金が関連付けられています。",
        PAYMENT_CANCELLED_REPLACEMENT_DEFERRED:
          "取消済み入出金が関連付けられています。差し替えは延期されています。",
        FEATURE_DISABLED: "入出金下書き作成は無効です。",
        UNSUPPORTED_CURRENCY: "JPY 明細のみ入出金下書きを作成できます。",
        INVALID_AMOUNT: "明細金額が入出金下書きに適していません。",
        UNKNOWN: "この照合では入出金下書きを作成できません。",
      },
    },
    candidate: {
      topHint: "スコア上位 {n} 件を表示中",
      empty: "候補がありません。",
      moreHidden: "他 {count} 件の候補があります。",
      type: "種別",
      target: "対象",
      score: "スコア",
      rule: "ルール",
      date: "生成日",
      amount: "状態",
      actions: "アクション",
      selected: "選択中",
    },
    decision: {
      title: "意思決定",
      reviewRequired:
        "この照合はレビューが必要です。確認権限を持つメンバーが確定してください。",
      confirmed: "この明細行は確定済みです。",
      noActions: "現在実行可能なアクションはありません。",
    },
    confirm: {
      title: "照合の確定",
      description: "この候補で照合を確定しますか？",
    },
    override: {
      title: "強制上書き",
      description: "この照合を強制的に確定しますか？上書き権限が必要です。",
    },
    detail: {
      title: "明細行の詳細",
      overridden: "強制上書きによる確定",
      tabs: {
        summary: "サマリー",
        candidates: "候補",
        history: "履歴",
        audit: "監査",
      },
      summary: {
        date: "取引日",
        amount: "金額",
        direction: "方向",
        matchStatus: "照合状態",
        candidateCount: "候補数",
        decisionStatus: "意思決定状態",
        version: "バージョン",
        overridden: "上書き",
        counterparty: "取引先",
        reference: "参照",
      },
    },
    history: {
      empty: "履歴はありません。",
    },
    audit: {
      hint: "監査ログは監査センターから参照してください。",
      viaAuditCenter: "監査センターで確認",
    },
    empty: {
      title: "銀行明細行がありません",
      description: "銀行明細をインポートすると、ここで照合候補を確認できます。",
      filteredTitle: "該当する明細行がありません",
      filteredDescription: "フィルタ条件を変更してください。",
    },
    errors: {
      listFailed: "明細行の一覧取得に失敗しました。",
      detailFailed: "詳細の取得に失敗しました。",
      selectFailed: "候補の選択に失敗しました。",
      confirmFailed: "照合の確定に失敗しました。",
      overrideFailed: "強制上書きに失敗しました。",
      ignoreFailed: "除外に失敗しました。",
      unmatchFailed: "照合解除に失敗しました。",
      retryOrchestrationFailed: "会計連携の再試行に失敗しました。",
      createPaymentDraftFailed: "入出金下書きの作成に失敗しました。",
      versionConflict:
        "この明細行は別のメンバーによって更新されました。最新情報を取得してください。",
      genericFailure: "エラーが発生しました。",
      readForbidden: "銀行明細照合を参照する権限がありません。",
    },
    failureCodes: {
      BANK_MATCH_FEATURE_DISABLED: "銀行明細照合機能が無効です。",
      FEATURE_DISABLED: "期間照合機能が無効です。",
      INVALID_PERIOD:
        "期間が無効です。有効な YYYY-MM-DD を指定し、開始日は終了日以前にしてください。",
      PERIOD_RANGE_TOO_LARGE: "期間の範囲が 12 か月の上限を超えています。",
      UNSUPPORTED_CURRENCY_FILTER: "期間照合は現在 JPY のみ対応しています。",
      BANK_MATCH_NOT_FOUND: "明細行が見つかりません。",
      BANK_MATCH_NOT_READY: "照合の準備ができていません。",
      BANK_MATCH_CANDIDATE_NOT_FOUND: "候補が見つかりません。",
      BANK_MATCH_INVALID_TRANSITION: "現在の状態ではこの操作は実行できません。",
      BANK_MATCH_DECISION_CONFLICT:
        "別のメンバーが同時に更新したため、操作が競合しました。",
      BANK_MATCH_NO_CANDIDATES: "候補または対象が指定されていません。",
      BANK_MATCH_OVERRIDE_REQUIRED: "強制上書き権限が必要です。",
      BANK_MATCH_TARGET_NOT_FOUND: "照合対象が見つかりません。",
      BANK_MATCH_TARGET_ALREADY_CONFIRMED:
        "この対象は既に別の明細行で確定されています。",
      BANK_MATCH_ORCH_RETRY_NOT_CONFIRMED: "確定済みの照合のみ再試行できます。",
      BANK_MATCH_ORCH_RETRY_FLAG_DISABLED:
        "会計連携機能が無効のため再試行できません。",
      BANK_MATCH_PAYMENT_LINK_FEATURE_DISABLED:
        "銀行照合→入出金下書きは無効です。",
      BANK_MATCH_PAYMENT_DECISION_CONFLICT:
        "照合が同時に更新されました。再読み込みして再試行してください。",
      BANK_MATCH_PAYMENT_SOURCE_NOT_CONFIRMED:
        "確定済みかつ有効な銀行照合のみ入出金下書きを作成できます。",
      BANK_MATCH_PAYMENT_TARGET_NOT_ELIGIBLE:
        "この照合対象では入出金下書きを作成できません。",
      BANK_MATCH_PAYMENT_UNSUPPORTED_DIRECTION:
        "この明細方向では入出金下書きを作成できません。",
      BANK_MATCH_PAYMENT_UNSUPPORTED_CURRENCY:
        "JPY 明細のみ入出金下書きを作成できます。",
      BANK_MATCH_PAYMENT_INVALID_AMOUNT:
        "明細金額が入出金下書きに適していません。",
      WORKSPACE_PERMISSION_DENIED: "この操作を行う権限がありません。",
      IDEMPOTENCY_KEY_REQUIRED: "リクエストには冪等キーが必要です。",
      VALIDATION_FAILED: "入力内容が不正です。",
    },
  },
  financialReports: {
    title: "財務レポート",
    subtitle: "不変の会計事実に基づく読み取り専用の投影",
    disclaimer:
      "本レポートはシステム生成の会計投影であり、税務申告や法定提出書類ではありません。",
    filters: {
      reportType: "レポート種別",
      basis: "基準",
      period: "会計期間",
      fiscalYear: "会計年度",
      account: "勘定科目",
      comparativeMode: "比較モード",
    },
    reportTypes: {
      trialBalance: "試算表",
      balanceSheet: "貸借対照表",
      profitAndLoss: "損益計算書",
      accountDetail: "勘定明細",
      fiscalYearSummary: "会計年度サマリー",
    },
    basis: {
      liveLedger: "ライブ元帳（暫定）",
      periodSnapshot: "期間締めスナップショット（確定）",
      yearEndSnapshot: "年次締めスナップショット（確定）",
    },
    comparative: {
      none: "比較なし",
      previousPeriod: "前期",
      previousFiscalYear: "前会計年度",
    },
    actions: { generate: "レポート生成" },
    export: {
      title: "エクスポート",
      disclaimer:
        "このファイルはシステムが生成した会計レポートのエクスポートです。法定申告書または税務提出書類ではありません。",
      format: "エクスポート形式",
      locale: "言語",
      generate: "エクスポート生成",
      download: "ダウンロード",
      cancel: "エクスポート取消",
      retry: "再試行",
      polling: "エクスポート Worker の処理を待機中…",
      status: "状態",
      checksum: "ファイルチェックサム",
      sizeBytes: "ファイルサイズ（バイト）",
      expiresAt: "有効期限",
      noSnapshot: "エクスポート前にレポートスナップショットを生成してください",
      formats: { csv: "CSV", xlsx: "XLSX", json: "JSONパッケージ" },
      statuses: {
        QUEUED: "待機中",
        PROCESSING: "処理中",
        COMPLETED: "完了",
        FAILED: "失敗",
        CANCELLED: "キャンセル",
        EXPIRED: "期限切れ",
      },
      failureCodes: {
        EXPORT_STORAGE_UPLOAD_FAILED:
          "エクスポートファイルのアップロードに失敗しました。後でもう一度お試しください。",
        EXPORT_CHECKSUM_MISMATCH:
          "エクスポートファイルの検証に失敗しました。再試行してください。",
        EXPORT_ARTIFACT_EXPIRED: "このエクスポートファイルは期限切れです。",
      },
      errors: {
        failed: "エクスポート失敗",
        noPermission: "エクスポート権限がありません",
      },
    },
    header: {
      period: "期間",
      basis: "基準",
      version: "バージョン",
      checksum: "チェックサム",
    },
    balanceSheet: {
      equation: "資産 {assets} = 負債 {liabilities} + 純資産 {equity}",
    },
    profitAndLoss: {
      summary: "収益 {revenue} - 費用 {expense} = 当期純利益 {netIncome}",
    },
    sections: { title: "セクション" },
    table: {
      account: "勘定科目",
      amount: "金額",
      comparative: "比較値",
      variance: "差異",
    },
    errors: {
      generateFailed: "レポート生成に失敗しました",
    },
  },
  japaneseFinancialStatements: {
    title: "日本式財務諸表",
    subtitle: "不変の財務レポートスナップショットから生成される日本式列示",
    disclaimer:
      "本書類は、システム上の会計データから生成された財務報告表示です。法定申告書、税務提出書類、監査報告書または公的提出書類ではありません。内容を確認のうえご利用ください。",
    fields: {
      statementType: "諸表種別",
      amountUnit: "金額単位",
      snapshotId: "財務レポートスナップショット ID",
      status: "状態",
      profile: "プロファイル",
      comparativeMode: "比較モード",
      locale: "表示言語",
      period: "期間",
      checksum: "ソースチェックサム",
      sourceChecksum: "ソースレポートチェックサム",
      presentationChecksum: "列示チェックサム",
      generatedAt: "生成日時",
    },
    sourceSnapshot: {
      title: "ソース財務レポートスナップショット",
    },
    profile: {
      profileVersion: "プロファイル版",
      labelVersion: "ラベル版",
      sectionOrderVersion: "区分順序版",
      disclaimerVersion: "免責事項版",
    },
    comparative: {
      currentOnly: "当期のみ",
      currentAndPrior: "当期と前期",
    },
    types: {
      balanceSheet: "貸借対照表",
      profitAndLoss: "損益計算書",
      trialBalance: "試算表",
      accountDetail: "勘定科目内訳",
      comparative: "前期比較",
    },
    amountUnits: {
      yen: "円",
      thousandYen: "千円",
      millionYen: "百万円",
    },
    actions: {
      prepareSource: "ソースレポート生成",
      generate: "日本式列示を生成",
    },
    statuses: {
      QUEUED: "待機中",
      PROCESSING: "処理中",
      COMPLETED: "完了",
      FAILED: "失敗",
      CANCELLED: "キャンセル",
      SUPERSEDED: "置換済み",
    },
    table: {
      section: "区分",
      line: "行",
      amount: "金額",
      comparative: "前期",
      variance: "増減率",
    },
    validation: {
      title: "検証結果",
      infoCount: "情報",
      warningCount: "警告",
      errorCount: "エラー",
      blockingCount: "ブロック",
      severities: {
        INFO: "情報",
        WARNING: "警告",
        ERROR: "エラー",
        BLOCKING: "ブロック",
      },
    },
    unmapped: {
      title: "未マッピング科目",
      linkLabel: "科目マッピングを確認",
    },
    presentation: {
      metadata: "列示メタデータ",
    },
    export: {
      title: "エクスポート",
      disclaimer:
        "このファイルはシステムが生成した日本式財務諸表のエクスポートです。法定申告書または税務提出書類ではありません。",
      format: "エクスポート形式",
      locale: "言語",
      generate: "エクスポート生成",
      download: "ダウンロード",
      polling: "エクスポート Worker の処理を待機中…",
      status: "状態",
      checksum: "ファイルチェックサム",
      sizeBytes: "ファイルサイズ（バイト）",
      blockedHint: "検証ブロックが解消されるまでエクスポートできません。",
      formats: { csv: "CSV", xlsx: "XLSX", json: "JSONパッケージ" },
      statuses: {
        QUEUED: "待機中",
        PROCESSING: "処理中",
        COMPLETED: "完了",
        FAILED: "失敗",
        CANCELLED: "キャンセル",
        EXPIRED: "期限切れ",
      },
      errors: {
        failed: "エクスポート失敗",
        noPermission: "エクスポート権限がありません",
        blocked: "検証ブロックがあるためエクスポートできません",
      },
    },
    warnings: {
      unmapped:
        "未分類の勘定科目があります。科目マッピングを確認してください。",
    },
    errors: {
      noBook: "会計帳簿が見つかりません",
      noPermission: "日本式財務諸表の生成権限がありません",
      generateSourceFailed: "ソースレポートの生成に失敗しました",
      generateFailed: "日本式列示の生成に失敗しました",
    },
  },
  feedback: {
    title: "フィードバックを送信",
    subject: "件名",
    selectPlaceholder: "選択してください",
    details: "詳細",
    detailsPlaceholder: "問題やご要望を入力してください...",
    attachments: "添付ファイル（任意、最大 3 件）",
    submitting: "送信中...",
    incomplete: "必須項目を入力してください。",
    submitted: "フィードバックを送信しました。できるだけ早く確認します。",
    submitFailed: "送信に失敗しました",
    thread: {
      me: "自分",
      operations: "運用",
      user: "ユーザー",
    },
  },
  feedbackLabels: {
    subjects: {
      bug: "不具合報告",
      feature: "機能要望",
      billing: "請求と利用枠",
      account: "アカウントとセキュリティ",
      other: "その他",
    },
    statuses: {
      OPEN: "未対応",
      IN_PROGRESS: "対応中",
      RESOLVED: "解決済み",
      CLOSED: "クローズ",
    },
  },
  emailEditor: {
    bold: "太字",
    italic: "斜体",
    underline: "下線",
    strike: "取り消し線",
    paragraph: "本文",
    heading2: "小見出し",
    heading3: "見出し",
    textColor: "文字色",
    highlight: "背景ハイライト",
    clearFormatting: "色をクリア",
    clearHighlight: "ハイライトをクリア",
    alignLeft: "左揃え",
    alignCenter: "中央揃え",
    alignRight: "右揃え",
    bulletList: "箇条書き",
    numberedList: "番号付きリスト",
    link: "リンク",
    insertTable: "表を挿入",
    undo: "元に戻す",
    redo: "やり直し",
    linkPrompt: "リンク URL",
  },
  addressLocation: {
    label: "住所",
    areaCodePlaceholder: "7 桁の郵便番号を入力",
    prefixPlaceholder: "都道府県 市区町村 町域",
    addressPlaceholder: "番地、建物名、階数、部屋番号など",
    loading: "住所を検索しています...",
    notFound: "該当する住所が見つかりません。",
  },
  employeeManagement: {
    menu: { employees: "従業員一覧", retired: "退職者一覧", tags: "タグ一覧" },
    list: {
      title: "従業員一覧",
      description: "従業員の基本情報、所属、アカウント発行状況を管理します。",
      empty: "従業員がまだ登録されていません。",
    },
    retired: {
      title: "退職者一覧",
      description: "退職処理済みの従業員を確認します。",
      badge: "退職済み",
      retiredNotice: "退職日：{date} / 退職理由：{reason}",
    },
    tags: {
      title: "タグ一覧",
      description: "従業員に付与するタグを管理します。",
      add: "タグを追加",
      edit: "タグを編集",
      empty: "タグがまだ登録されていません。",
      dialogDescription: "タグ名、色、備考を設定します。",
      deleteTitle: "タグを削除しますか",
      importTitle: "タグをインポート",
      importDescription: "タグ名と色を一括登録します。",
      exportTitle: "タグをエクスポート",
      exportDescription: "タグ一覧を出力します。",
    },
    detail: {
      title: "従業員詳細",
      subtitle: "従業員プロフィール",
      profile: "基本プロフィール",
      employment: "雇用情報",
      location: "住所",
      account: "アカウント",
      notFound: "従業員が見つかりません。",
    },
    dialog: {
      addEmployee: "従業員を追加",
      editEmployee: "従業員を編集",
      employeeDescription: "従業員の基本情報と所属情報を入力します。",
    },
    actions: {
      addEmployee: "従業員を追加",
      issueAccount: "アカウント発行",
      resetPassword: "パスワード再設定",
      retire: "退職処理",
      restore: "復元",
      bulkInvite: "一括招待",
      bulkEmail: "一括送信",
      selectVisible: "表示中の従業員を選択",
    },
    summary: {
      total: "従業員数",
      dimension: "集計軸",
      dimensions: {
        employmentType: "雇用形態",
        workStatus: "勤務状況",
        employmentStatus: "雇用状況",
        position: "職位",
        jobType: "職種",
      },
    },
    filters: { keyword: "キーワード" },
    columns: { employee: "従業員", tags: "タグ" },
    fields: {
      employeeNo: "社員番号",
      avatarUrl: "顔写真",
      birthDate: "生年月日",
      gender: "性別",
      name: "氏名",
      nameKanji: "氏名（漢字）",
      familyName: "姓",
      givenName: "名",
      nameKana: "氏名（カタカナ）",
      familyNameKana: "姓（カタカナ）",
      givenNameKana: "名（カタカナ）",
      hiredOn: "入社日",
      retiredOn: "退職日",
      retiredReason: "退職理由",
      hireType: "入社区分",
      phone: "電話番号",
      email: "メールアドレス",
      location: "住所",
      office: "事業所",
      department: "部署",
      workStatus: "勤務状況",
      employmentType: "雇用形態",
      employmentStatus: "雇用状況",
      jobType: "職種",
      position: "職位",
      insuranceNumber: "保険証番号",
      insuranceSymbol: "保険証記号",
      remarks: "備考",
      accountIssueStatus: "アカウント発行状況",
      userId: "システムアカウントID",
      lastLoginAt: "最終ログイン日時",
      tagName: "タグ名",
      tagColor: "タグ色",
      tagColorDescription: "備考",
      employeeCount: "従業員数",
    },
    common: { unselected: "未設定", ageSuffix: "歳", personSuffix: "人" },
    validation: {
      required: "必須項目です。",
      email: "有効なメールアドレスを入力してください。",
      japanesePhone: "有効な日本国内の電話番号を入力してください。",
      maxLength: "{max}文字以内で入力してください。",
    },
    avatar: {
      upload: "顔写真をアップロード",
      uploading: "アップロード中...",
      clear: "削除",
      hint: "PNG、JPG、WebP に対応。最大 2 MB。保存前に正方形へトリミングします。",
      cropTitle: "顔写真をトリミング",
      confirmCrop: "顔写真に設定",
      zoom: "ズーム",
      invalid: "有効な画像ファイルをアップロードしてください。",
      tooLarge: "画像は 2 MB 以下にしてください。",
      uploadFailed: "顔写真のアップロードに失敗しました",
      uploaded: "顔写真をアップロードしました",
    },
    bulkInvite: {
      confirmTitle: "一括招待を送信しますか",
      confirmDescription: "{count}名の従業員へ招待メールを送信します。",
    },
    bulkEmail: {
      title: "従業員へ一括送信",
      description: "選択した従業員のメールアドレス宛にメッセージを送信します。",
      subject: "件名",
      message: "本文",
    },
    resetPassword: {
      title: "パスワード再設定",
      description: "新しいログインパスワードを入力してください。",
      newPassword: "新しいパスワード",
      confirmPassword: "新しいパスワード（確認）",
      passwordPlaceholder: "8文字以上",
      passwordMin: "パスワードは8文字以上で入力してください。",
      passwordMismatch: "2つのパスワードが一致しません。",
    },
    import: {
      title: "従業員をインポート",
      description: "従業員マスタを一括登録します。",
      employeeNoRequired: "社員を一意に識別する番号です。",
      familyNameRequired: "氏名（漢字）の姓です。",
      givenNameRequired: "氏名（漢字）の名です。",
      familyNameKanaRequired: "氏名（カタカナ）の姓です。",
      givenNameKanaRequired: "氏名（カタカナ）の名です。",
      tagNameRequired: "タグを識別する名称です。",
    },
    export: {
      title: "従業員をエクスポート",
      description: "出力する項目を選択してください。",
    },
    retire: {
      title: "退職処理",
      description: "退職日と退職理由を入力してください。",
    },
    history: {
      title: "更新履歴",
      actions: {
        CREATE: "追加",
        UPDATE: "更新",
        RETIRE: "退職処理",
        RESTORE: "復元",
      },
    },
    messages: {
      saved: "保存しました",
      deleted: "削除しました",
      accountIssued: "アカウント招待を送信しました",
      passwordResetSent: "パスワードを再設定しました",
      passwordResetRequested: "パスワードを再設定しました",
      retired: "退職処理が完了しました",
      restoreTitle: "従業員を復元しますか",
      restored: "従業員を復元しました",
      emailRequiredForAccount:
        "メールアドレス未設定のためアカウントを発行できません。",
      selectEmployeesRequired: "従業員を選択してください。",
      bulkInviteAccepted:
        "一括招待を送信しました（成功 {count} 件、失敗 {failed} 件）。",
      bulkInviteFailed: "一括招待を送信できませんでした。",
      bulkEmailAccepted: "一括送信を受け付けました。",
    },
    enums: {
      gender: {
        MALE: "男性",
        FEMALE: "女性",
        OTHER: "その他",
        UNDISCLOSED: "未設定",
      },
      hireType: { NEW_GRADUATE: "新卒", EXPERIENCED: "既卒" },
      employmentType: {
        EXECUTIVE: "役員",
        REGULAR: "正社員",
        SECONDMENT_IN: "受入出向社員",
        CONTRACT: "契約社員",
        SHOKUTAKU: "嘱託社員",
        PART_TIME: "パート/アルバイト",
        FREELANCE: "フリーランス/業務委託",
        TEMPORARY_DISPATCH_IN: "受入派遣社員",
        DISPATCH_STAFF: "派遣スタッフ",
        TRAINEE: "実習生",
      },
      workStatus: {
        NORMAL_DOMESTIC: "通常勤務（国内）",
        NORMAL_OVERSEAS: "通常勤務（海外）",
        LEAVE_PRIVATE_INJURY: "休業（私傷病）",
        LEAVE_CHILDCARE: "休業（育産休）",
        LEAVE_CAREGIVING: "休業（介護）",
        LEAVE_OTHER: "休業（その他）",
        WORK_RESTRICTED: "就業制限",
      },
      employmentStatus: {
        ACTIVE: "在籍",
        SECONDED: "出向",
        CONTRACT_ENDED: "契約満了",
        RETIRED: "退職",
      },
      position: {
        STAFF: "一般職",
        STAFF_J: "一般職（J）",
        STAFF_M: "一般職（M）",
        STAFF_H: "一般職（H）",
        MANAGER: "管理職",
        MANAGER_J: "管理職（J）",
        MANAGER_M: "管理職（M）",
        MANAGER_H: "管理職（H）",
        EXECUTIVE: "役員",
        OTHER: "その他",
      },
      jobType: {
        MANAGEMENT: "管理職",
        PROFESSIONAL_TECHNICAL: "専門・技術職",
        CLERICAL: "事務職",
        SALES: "販売・営業職",
        SERVICE: "サービス職",
        SECURITY: "保安職",
        AGRICULTURE_FORESTRY_FISHERY: "農林漁業職",
        PRODUCTION: "生産工程職",
        TRANSPORT_MACHINE: "輸送・機械運転職",
        CONSTRUCTION_MINING: "建設・採掘職",
        CARRYING_CLEANING_PACKAGING: "運搬・清掃・包装等",
        OTHER: "その他",
      },
      accountIssueStatus: {
        NOT_ISSUED: "未発行",
        ISSUED: "発行済み",
        ACTIVATED: "有効化済み",
        SUSPENDED: "一時停止",
      },
      userStatus: { ACTIVE: "有効", INACTIVE: "無効", DELETED: "削除済み" },
    },
  },
  organizationHealth: {
    tabs: {
      profile: "基本情報",
      offices: "事業所管理",
      departments: "部署管理",
    },
    profile: {
      title: "企業基本情報",
      description: "法人情報と主要連絡先を管理します。",
      logo: "企業ロゴ",
      logoHint: "読み取り専用。テナントのブランド設定を参照します。",
      employeeCount: "従業員数",
    },
    offices: {
      title: "事業所",
      description: "事業所の連絡先と労働保険情報を管理します。",
      add: "事業所を追加",
      edit: "事業所を編集",
      empty: "事業所はありません",
      dialogDescription: "事業所の基本情報を入力してください。",
      importTitle: "事業所をインポート",
      importDescription: "テンプレートの項目名で事業所を一括追加します。",
      exportTitle: "事業所をエクスポート",
      exportDescription: "出力項目を選択してください。",
    },
    departments: {
      title: "部署階層",
      description: "部署の親子関係と表示順を管理します。",
      add: "部署を追加",
      edit: "部署を編集",
      empty: "部署はありません",
      root: "最上位部署",
      memberCountSuffix: "（{count}名）",
      dialogDescription: "部署名、上位部署、表示順を設定します。",
      importTitle: "部署をインポート",
      importDescription:
        "上位部署は事前に登録するか、先の行に配置してください。",
      exportTitle: "部署をエクスポート",
      exportDescription: "現在の部署階層を出力します。",
    },
    fields: {
      companyName: "企業名",
      representativeName: "代表者",
      corporateNumber: "法人番号",
      location: "住所",
      areaCode: "郵便番号",
      postalCode: "郵便番号",
      prefecture: "都道府県",
      city: "市区町村",
      area: "町域",
      address: "番地・建物名",
      addressLine: "住所",
      contactName: "担当者",
      contactDepartment: "担当部署",
      contactPhone: "担当者電話番号",
      contactEmail: "担当者メール",
      websiteUrl: "公式サイト URL",
      industry: "業種",
      foundedOn: "設立日",
      name: "事業所名",
      laborInsuranceNumber: "労働保険番号",
      departmentName: "部署名",
      parentDepartment: "上位部署",
      sortOrder: "表示順",
    },
    import: {
      dropHint: "CSV/XLSX ファイルをドロップするか、選択してください。",
      choose: "ファイルを選択",
      preview: "プレビュー",
      previewCount: "最大 20 行を表示",
      progress: "インポート進捗",
      missing: "必須項目が不足しています",
      requiredFields: "必須項目",
      downloadTemplate: "テンプレートをダウンロード",
      officeNameRequired: "事業所を識別する名称です。必ず入力してください。",
      departmentNameRequired: "部署を識別する名称です。必ず入力してください。",
    },
    export: {
      columns: "出力項目",
      selectAll: "すべて選択",
      deselectAll: "すべて解除",
    },
    messages: {
      saved: "保存しました",
      deleted: "削除しました",
      deleteTitle: "削除の確認",
    },
  },
  documentSummary: {
    title: "伝票集計",
    subtitle: "処理完了伝票の財務集計",
    noWorkspace: "ワークスペースを選択してください。",
    noWorkspaceHint:
      "伝票集計を表示するにはアクティブなワークスペースが必要です。",
    readOnly: "伝票集計を表示する権限がありません。",
    readOnlyHint: "document_intake.read 権限が必要です。",
    empty: "条件に一致する処理完了伝票はありません。",
    split: {
      progress: "分割 {index}/{count}",
    },
    total: "全 {total} 件（ページ {page}、{pageSize} 件/ページ）",
    errors: {
      loadFailed: "伝票集計の読み込みに失敗しました。",
    },
    stats: {
      title: "年度集計",
      dateRange: "集計の取引日",
      fiscalYear: "会計年",
      fiscalYearOption: "{year}年度",
      apply: "集計を更新",
      syncList: "一覧の日付に合わせる",
      count: "件数",
      totalAmount: "税込合計金額",
      averageAmount: "平均単価",
      byAccount: "勘定科目別",
      byMonth: "月別金額",
      monthLabel: "{year}年{month}月",
      emptyChart: "集計データがありません",
      unknownAccount: "科目未設定",
    },
    filters: {
      keyword: "キーワード",
      keywordPlaceholder: "取引先・摘要",
      documentDate: "取引日",
      account: "勘定科目",
      taxRate: "税率",
      invoicePresence: "インボイス",
      invoicePresent: "あり",
      invoiceAbsent: "なし",
      allInvoicePresence: "すべて",
      amount: "金額",
      amountMin: "金額下限",
      amountMax: "金額上限",
      amountMinPlaceholder: "下限",
      amountMaxPlaceholder: "上限",
      allAccounts: "すべての科目",
      allTaxRates: "すべての税率",
      apply: "絞り込み",
      reset: "リセット",
    },
    taxRate: {
      "10": "10%",
      "8": "8%（軽減）",
      "10_NO_INVOICE": "10%（インボイスなし）",
      "8_NO_INVOICE": "8%（軽減・インボイスなし）",
      NON_TAXABLE: "非課税",
      OUT_OF_SCOPE: "不課税",
      EXEMPT: "不明",
      UNKNOWN: "不明",
      multiple: "複数あり",
    },
    columns: {
      documentDate: "取引日",
      documentNumber: "伝票番号",
      counterparty: "取引先",
      description: "摘要",
      account: "勘定科目",
      accountCode: "勘定科目コード",
      accountName: "勘定科目名",
      taxRate: "税率",
      amount: "税込金額",
      amountMinor: "税込金額（minor）",
      paymentMethod: "支払方法",
      invoiceRegistrationNumber: "登録番号",
      cardLastFour: "カード下4桁",
      currency: "通貨",
      filename: "Intake ファイル名",
      actions: "操作",
      documentIntakeId: "伝票ID",
      documentSegmentId: "セグメントID",
    },
    actions: {
      detail: "詳細",
    },
    pagination: {
      prev: "前へ",
      next: "次へ",
    },
    export: {
      button: "出力",
      title: "伝票集計を出力",
      description:
        "現在の絞り込み結果を CSV または Excel で出力します（上限 5000 件）。",
      columns: "出力列",
      selectAll: "すべて選択",
      deselectAll: "すべて解除",
      csv: "CSV",
      xlsx: "Excel",
      tooLarge: "出力件数が上限を超えています",
    },
  },
  documentIntake: {
    inbox: {
      title: "伝票受信",
      subtitle: "アクティブなワークスペースの受付書類",
      noWorkspace: "ワークスペースを選択してください。",
      readOnly: "伝票受信を表示する権限がありません。",
      emptyTitle: "受付書類はまだありません",
      emptyDescription:
        "領収書や請求書をアップロードすると、ここに表示されます。",
      total: "全 {total} 件（ページ {page}、{pageSize} 件/ページ）",
      bulkApprove: {
        action: "一括承認",
        running: "承認中...",
        select: "確認待ちの書類を選択",
        selectAll: "表示中の確認待ちをすべて選択",
        failed: "{count} 件の承認に失敗しました。",
      },
      foundation: {
        columns: {
          file: "ファイル",
          processing: "処理状態",
          accounting: "会計状態",
          documentType: "書類種別",
          counterparty: "取引先",
          date: "取引日",
          amount: "金額",
          taxRate: "税率",
          invoiceRegistrationNumber: "登録番号",
          account: "勘定科目",
          actions: "操作",
        },
        taxRate: {
          multiple: "複数あり",
        },
        split: {
          badge: "分割 {count}",
          expand: "分割明細を表示",
          collapse: "分割明細を閉じる",
        },
        file: {
          multipleDocuments: "複数書類",
        },
        processing: {
          UPLOADED: "受付済み",
          QUEUED: "処理待ち",
          PROCESSING: "処理中",
          REPROCESSING: "再解析中",
          NEEDS_REVIEW: "確認待ち",
          COMPLETED: "完了",
          FAILED: "処理エラー",
          CANCELLED: "取消済み",
          UNKNOWN: "状態不明",
        },
        processingStage: {
          PREPROCESSING: "画像処理中",
          OCR: "OCR解析中",
          FIELD_EXTRACTION: "項目抽出中",
          REVIEW: "確認待ち",
          COMPLETED: "処理完了",
          FAILED: "処理失敗",
          CANCELLED: "処理取消",
          LEGACY_PARSING: "旧解析処理",
          UNKNOWN: "状態不明",
        },
        review: {
          NOT_READY: "未準備",
          NEEDS_REVIEW: "未確認",
          PARTIALLY_REVIEWED: "一部確認済み",
          COMPLETED: "確認済み",
          REJECTED: "却下",
          NON_ACCOUNTING: "対象外",
          MIXED: "一部確認済み",
          UNKNOWN: "確認待ち（未集計）",
          progress: "{confirmed}/{total} 確認済み",
        },
        accounting: {
          NOT_STARTED: "未開始",
          PROCESSING: "会計処理中",
          TRANSACTION_REVIEW_REQUIRED: "取引確認待ち",
          DOWNSTREAM_PROCESSING: "仕訳処理中",
          COMPLETED: "仕訳確認済み",
          FAILED: "エラー",
          AMENDMENT_REQUIRED: "修正が必要",
          MIXED: "一部完了",
          UNKNOWN: "状態不明",
        },
        segments: {
          zero: "0件",
          count: "{count}件",
          updating: "セグメント更新中",
          updatingShort: "更新中",
        },
        amount: {
          multiple: "複数",
        },
        actions: {
          review: "確認",
          details: "詳細",
          retry: "再試行",
          reprocess: "再解析",
          cancelProcessing: "処理をキャンセル",
          cancelFailed: "処理のキャンセルに失敗しました。",
          retryFailed: "処理の再試行に失敗しました。",
        },
        rowAriaLabel: "{filename} を開く",
        tooltips: {
          reviewStaleMetadata: "集計を更新中です",
          reviewMixed: "確認済み {confirmed} · 却下 {rejected} · 合計 {total}",
          accountingMasked: "会計情報の閲覧権限がありません",
          accountingSegmentPartial: "{total}件中{completed}件完了",
          accountingSegmentReviewRequired: "{count}件の確認が必要",
          partialAmount: "一部の金額を取得できません",
          processingFailedGeneric: "処理に失敗しました",
        },
        foreignCurrency: {
          badge: "海外伝票 · 円金額の入力が必要",
        },
        failureCodes: {
          PROCESSING_FAILED: "処理に失敗しました",
          OCR_FAILED: "OCRに失敗しました",
          EXTRACTION_FAILED: "抽出に失敗しました",
        },
      },
    },
    upload: {
      title: "書類をアップロード",
      subtitle: "領収書・請求書をワークスペースへ受付",
      backToInbox: "伝票受信に戻る",
      dropTitle: "クリック、またはドラッグ＆ドロップ",
      dropHint: "PDF、JPEG、PNG、HEIC（最大 {maxMb} MB）",
      browse: "ファイルを選択",
      progress: "アップロード中 {progress}%",
      ownership: "利用区分",
      limits: "最大ファイルサイズ: {maxMb} MB",
      allowedTypes: "対応形式: PDF、JPEG、PNG、HEIC",
      submit: "アップロードして解析",
      uploading: "アップロード中...",
      viewInbox: "受信箱を表示",
      privacyNotice:
        "アップロードされた書類は会計処理のため安全に保管され、アクセスは権限に基づいて制限されます。",
      aiNotice:
        "AI によるフィールド抽出は提案であり、最終確認前に内容をご確認ください。",
      invalidType: "対応していないファイル形式です。",
      tooLarge: "ファイルサイズが上限（{maxMb} MB）を超えています。",
      sessionFailed: "アップロードセッションの作成に失敗しました。",
      failed: "アップロードに失敗しました。",
      noPermission: "書類をアップロードする権限がありません。",
      csvRoutedToBankImport:
        "CSV ファイルは銀行明細インポートからアップロードしてください。",
    },
    review: {
      title: "書類確認",
      backToInbox: "伝票受信に戻る",
      originalPreview: "原本プレビュー",
      originalRestricted: "原本ファイルを表示する権限がありません。",
      previewLoading: "プレビューを読み込み中...",
      parsedFields: "解析・提案フィールド",
      aiNotice: "AI 提案は確認が必要です。承認前に内容をご確認ください。",
      warnings: "警告",
      note: "確認メモ",
      weakGrounding: {
        needsConfirm: "要確認",
      },
      accountingDraft: {
        create: "会計ドラフトを作成",
        open: "会計ドラフトを開く",
        creating: "ドラフトを作成中...",
        featureDisabled: "書類会計デモは有効になっていません。",
        notApproved: "承認済みの書類のみ会計ドラフトを作成できます。",
      },
      reprocessQuery: {
        permissionDenied: "現在は再解析を実行できません。",
        segmentModeRequired: "再解析はセグメント確認画面から実行してください。",
      },
      foundationAccounting: {
        title: "Foundation 会計フロー",
        subtitle: "Segment 確認後の取引・仕訳分類・仕訳ドラフトの状態。",
        accountingStatus: {
          NOT_STARTED: "未開始",
          CLASSIFICATION_PENDING: "仕訳分類処理中",
          CLASSIFICATION_REVIEW_REQUIRED: "仕訳分類要確認",
          CLASSIFICATION_CONFIRMED: "仕訳分類確認済み",
          CLASSIFICATION_TERMINAL: "仕訳分類終了",
          JOURNAL_REVIEW_REQUIRED: "仕訳ドラフト要確認",
          JOURNAL_CONFIRMED: "仕訳ドラフト確認済み",
          JOURNAL_TERMINAL: "仕訳ドラフト終了",
        },
        bridge: {
          empty: "ブリッジ未要求",
          status: {
            PENDING: "ブリッジ待機中",
            PROCESSING: "ブリッジ処理中",
            SUCCEEDED: "ブリッジ成功",
            FAILED: "ブリッジ失敗",
            INELIGIBLE: "ブリッジ対象外",
            CANCELLED: "ブリッジ取消",
            AMENDMENT_REQUIRED: "修正が必要",
          },
        },
        transaction: {
          title: "取引",
          total: "合計 {amount} JPY",
          confirm: "取引を確認",
          pending:
            "取引ドラフトを作成中です。しばらくしてから再読み込みしてください。",
          empty: "取引事実はまだ生成されていません。",
          splitList: "分割された取引",
        },
        classification: {
          title: "仕訳分類",
          confirm: "仕訳分類を確認",
          request: "分類を再リクエスト",
          taxTreatment: "税務処理",
        },
        journal: {
          title: "仕訳ドラフト",
          date: "仕訳日",
          debitTotal: "借方合計",
          creditTotal: "貸方合計",
          balance: "貸借",
          balanced: "一致",
          unbalanced: "不一致",
          reviewedAt: "確認日時",
          confirmedHint: "仕訳確認済み",
          reviewRequiredHint: "仕訳確認が必要です",
          confirm: "仕訳を確認",
          openDocumentDetail: "書類詳細を開く",
        },
        refreshing: "更新中…",
        retry: "再試行",
        failure: {
          retryStatus: "状態を再確認",
          BRIDGE_FAILED: {
            title: "会計連携に失敗しました",
          },
          BRIDGE_INELIGIBLE: {
            title: "会計連携の対象外です",
            message: "この書類は会計連携の対象外です。",
          },
          BRIDGE_CANCELLED: {
            title: "会計連携は取り消されました",
            message: "会計連携は取り消されました。",
          },
          BRIDGE_AMENDMENT_REQUIRED: {
            title: "修正が必要です",
            message:
              "書類または会計データの修正が必要です。書類確認結果を見直してください。",
          },
          TRANSACTION_FAILED: {
            title: "取引を続行できません",
            message: "取引を続行できません。書類確認結果を確認してください。",
          },
          CLASSIFICATION_FAILED: {
            title: "仕訳分類を続行できません",
            message: "仕訳分類を続行できません。会計状態を確認してください。",
          },
          JOURNAL_FAILED: {
            title: "仕訳ドラフトを続行できません",
            message:
              "仕訳ドラフトを続行できません。会計状態を確認してください。",
          },
          bridge: {
            generic:
              "会計連携を完了できませんでした。状態を再確認するか、書類確認を見直してください。",
            codes: {
              BRIDGE_PAYLOAD_CONFLICT:
                "会計連携データが競合しています。確認済みの書類内容を見直してください。",
              PROCESSING_FAILED:
                "会計連携処理に失敗しました。しばらくしてから状態を再確認してください。",
            },
          },
        },
        error: {
          loadFailed: "会計データを読み込めませんでした。再試行してください。",
          confirmTransactionFailed: "取引を確認できませんでした。",
          confirmClassificationFailed: "仕訳分類を確認できませんでした。",
          confirmJournalFailed: "仕訳ドラフトを確認できませんでした。",
          permissionDenied: "この会計操作の権限がありません。",
          versionConflict:
            "会計データが更新されました。再読み込みしてから再試行してください。",
          amendmentRequired: "会計処理を続けるには修正が必要です。",
          workerDisabled: "この環境では会計処理が利用できません。",
          notFound: "会計データが見つかりませんでした。",
          periodLocked: "会計期間がロックされています。",
        },
        workflow: {
          v2: {
            navLabel: "会計ワークフロー",
            awaitingSegmentConfirm: "書類を確認すると会計処理を開始します",
            unknownStatus: "状態を確認できません",
            stages: {
              BRIDGE: "会計連携",
              TRANSACTION: "取引確認",
              CLASSIFICATION: "分類確認",
              JOURNAL: "仕訳確認",
            },
            status: {
              BRIDGE: {
                NOT_STARTED: "未開始",
                PROCESSING: "処理中",
                REVIEW_REQUIRED: "確認待ち",
                CONFIRMED: "完了",
                FAILED: "失敗",
              },
              TRANSACTION: {
                NOT_STARTED: "未開始",
                PROCESSING: "処理中",
                REVIEW_REQUIRED: "確認待ち",
                CONFIRMED: "完了",
                FAILED: "失敗",
              },
              CLASSIFICATION: {
                NOT_STARTED: "未開始",
                PROCESSING: "処理中",
                REVIEW_REQUIRED: "確認待ち",
                CONFIRMED: "完了",
                FAILED: "失敗",
              },
              JOURNAL: {
                NOT_STARTED: "未開始",
                PROCESSING: "処理中",
                REVIEW_REQUIRED: "確認待ち",
                CONFIRMED: "仕訳確認済み",
                FAILED: "失敗",
              },
            },
            description: {
              BRIDGE: {
                NOT_STARTED: "書類確認後に開始します。",
                PROCESSING: "会計連携を処理しています。",
                REVIEW_REQUIRED: "会計連携の確認が必要です。",
                CONFIRMED: "会計連携が完了しました。",
                FAILED: "会計連携が完了しませんでした。",
              },
              TRANSACTION: {
                NOT_STARTED: "会計連携の完了を待っています。",
                PROCESSING: "取引を作成しています。",
                REVIEW_REQUIRED: "取引を確認してください。",
                CONFIRMED: "取引を確認済みです。",
                FAILED: "取引を続行できません。",
              },
              CLASSIFICATION: {
                NOT_STARTED: "取引確認の完了を待っています。",
                PROCESSING: "仕訳分類を生成しています。",
                REVIEW_REQUIRED: "仕訳分類を確認してください。",
                CONFIRMED: "仕訳分類を確認済みです。",
                FAILED: "仕訳分類を続行できません。",
              },
              JOURNAL: {
                NOT_STARTED: "仕訳分類確認の完了を待っています。",
                PROCESSING: "仕訳ドラフトを生成しています。",
                REVIEW_REQUIRED: "仕訳ドラフトを確認してください。",
                CONFIRMED: "仕訳確認済み",
                FAILED: "仕訳ドラフトを続行できません。",
              },
            },
          },
          status: {
            generic: {
              NOT_STARTED: "未開始",
              PROCESSING: "処理中",
              REVIEW_REQUIRED: "確認待ち",
              COMPLETED: "完了",
              FAILED: "失敗",
              DISABLED: "利用不可",
            },
            JOURNAL: {
              COMPLETED: "仕訳確認済み",
            },
            POSTING: {
              DISABLED: "この画面では転記不可",
              NOT_STARTED: "未開始",
            },
          },
        },
      },
      workspace: {
        foundationBadge: "Foundation 確認",
        accountingRail: {
          expand: "会計フローを展開",
          collapse: "会計フローを折りたたむ",
        },
      },
      preview: {
        ocr: "OCR画像",
        original: "元ファイル",
        mineruDebug: "MINERU",
        geminiRequestDebug: "Gemini リクエスト",
        geminiResponseDebug: "Gemini レスポンス",
        debugEmpty: "デバッグデータがありません。",
        debugReconstructedHint:
          "保存済み OCR/候補結果から再構成しています。再処理後は完全なリクエスト/レスポンスが保存されます。",
        originalFullUploadHint:
          "元ファイルはアップロードされた原本全体です。OCR画像は現在のセグメント切り出しのため、表示範囲が異なる場合があります。",
        zoomIn: "拡大",
        zoomOut: "縮小",
        rotateLeft: "左に回転",
        rotateRight: "右に回転",
        fitWidth: "幅に合わせる",
        reset: "ズームをリセット",
        previousPage: "前のページ",
        nextPage: "次のページ",
        loadFailed: "プレビューを読み込めませんでした。",
        permissionDenied: "元ファイルを表示する権限がありません。",
        ocrLoadFailed: "OCR画像を読み込めませんでした",
        ocrReload: "OCR画像を再読み込み",
        ocrUrlExpiredHint: "OCR画像の有効期限が切れた可能性があります",
        noFieldLocation: "位置情報を利用できません",
        focusActive: "選択した項目を表示しています",
        invalidCoordinates: "座標情報が無効です",
      },
      summary: {
        legacy: "旧形式の書類",
        empty: "有効なセグメントがありません",
        progress: "{confirmed}/{total} 確認済み",
        needsReview: "未確認 {count} 件",
        excluded: "対象外 {count} 件",
        rejected: "却下 {count} 件",
        duplicate: "重複 {count} 件",
        nonAccounting: "会計対象外 {count} 件",
        processing: "処理中 {count} 件",
        selectedOutcome: "選択中: {outcome}",
      },
      legacyBanner: {
        badge: "旧形式",
        title: "旧形式の書類です",
        description: "この書類は従来の確認画面で表示されています。",
      },
      tabs: {
        document: "書類",
        fields: "入力内容",
        validation: "検証",
        accounting: "会計",
      },
      validation: {
        title: "バリデーション",
        empty: "バリデーション項目がありません。",
        failures: "失敗",
        warnings: "警告",
        passed: "合格 ({count})",
        unknown: "状態不明",
        fallback: "検証問題 ({ruleCode})",
        overridden: "例外承認済み",
        locateField: "フィールドへ移動",
        locateDocument: "書類上の位置",
        noLocation: "この項目の位置情報は利用できません。",
        showPassed: "合格を表示",
        hidePassed: "合格を非表示",
        summary: {
          fail: "FAIL {count}",
          overridden: "例外 {count}",
          warning: "WARNING {count}",
          pass: "PASS {count}",
          unknown: "UNKNOWN {count}",
        },
        messages: {
          required_total_missing: "合計金額がありません。",
          required_date_missing: "日付がありません。",
          supplier_missing: "取引先がありません。",
          subtotal_plus_tax_equals_total: "小計と税額の合計が一致しません。",
          date_in_future: "日付が未来です。",
          date_too_old: "日付が10年以上前です。",
          service_end_before_start: "サービス終了日が開始日より前です。",
          registration_number_format_invalid: "登録番号の形式が不正です。",
          qualified_invoice_without_registration_number:
            "適格請求書に登録番号がありません。",
          possible_full_card_number: "カード番号全文の可能性があります。",
          sensitive_data_redacted: "機微情報はマスクされました。",
        },
      },
      confirmGuard: {
        unsavedChanges: "未保存の変更があります",
        saveBeforeConfirm: "確認する前に変更を保存してください。",
        unresolvedFailures:
          "未解決の検証エラーがあります。修正するか、権限がある場合は例外承認してください。",
        unknownValidation:
          "一部の検証結果を解釈できません。確認前に検証を確認してください。",
        processing: "処理が完了していません。",
        alreadyConfirmed: "このセグメントは既に確認済みです。",
        overrideSyncPending: "例外承認の保存を完了してから確認してください。",
      },
      missingDate: {
        title: "日付が入力されていません",
        message:
          "日付なしで確認すると、会計処理や仕訳日付の確認が必要になる場合があります。このまま日付なしで確認しますか？",
        cancel: "キャンセル",
        confirmWithoutDate: "日付なしで確認",
      },
      override: {
        title: "例外として承認",
        message: "この検証エラーを例外として扱います。理由を入力してください。",
        comment: "理由",
        submit: "例外を保存",
        action: "例外として承認",
        forbidden: "検証例外の権限がありません。",
      },
      error: {
        versionConflict:
          "他のユーザーが内容を更新しました。最新の内容を読み込んでください。",
        candidateSuperseded:
          "抽出結果が更新されました。最新の内容を読み込みます。",
        alreadyConfirmed: "このセグメントは既に確認済みです。",
        invalidDate: "日付が必要です。または日付なし確認が必要です。",
        locationUnavailable: "このフィールドの OCR 座標がありません。",
      },
      actions: {
        more: "その他",
      },
    },
    reviewMode: {
      segmentLoadFailed:
        "書類情報を読み込めませんでした。しばらくしてから再試行してください。",
      retry: "再試行",
      unavailable: "この書類は現在確認できません。",
      invalidSelection: "指定された書類は現在利用できません。",
      processing: {
        waitingForSegments: "処理完了後に確認できます。",
      },
    },
    segmentReview: {
      segmentsTitle: "セグメント一覧",
      previewTitle: "画像とオーバーレイ",
      processing: "認識結果を処理中…",
      candidateStale:
        "認識結果が更新されました。再読み込み後に確定してください。",
      reload: "再読み込み",
      operations: {
        editSplit: "分割を編集",
        manualSplit: "手動分割",
        recrop: "再裁切",
        merge: "セグメントをマージ",
        reopen: "レビューを再開",
        editBoundary: "境界を編集",
        dialogDescription:
          "全ページ画像上でセグメント境界を調整します。送信後に OCR を再割当し、フィールドを再抽出します。",
        selectSegments: "マージするセグメントを選択",
        reasonCode: "理由コード",
        reasonComment: "理由コメント",
        submit: "境界変更を送信",
        overlapWarning:
          "矩形の重なりが大きすぎます。調整してから送信してください。",
        phaseCreatingRevision: "改訂を作成中…",
        phaseGeneratingCrop: "裁切画像を生成中…",
        phaseReallocatingOcr: "OCR を再割当中…",
        phaseExtractingFields: "フィールドを再抽出中…",
        phaseFailed: "セグメント操作に失敗しました。再試行してください。",
      },
      list: {
        pageSegment: "ページ {page} · セグメント {index}",
        failCount: "FAIL {count}",
        warningCount: "WARN {count}",
        manualEdit: "手動境界調整",
      },
      outcome: {
        NEEDS_REVIEW: "要確認",
        CONFIRMED: "確定済み",
        REJECTED: "却下",
        DUPLICATE: "重複",
        NON_ACCOUNTING: "非会計",
        MANUALLY_EXCLUDED: "除外",
        PROCESSING: "処理中",
      },
      field: {
        documentNumber: "伝票番号",
        memo: "摘要",
        subtotal: "小計（JPY）",
        tax: "税額（JPY）",
        taxRate: "税率",
        taxRateUnset: "未設定",
        taxRate10: "10%",
        taxRate8: "8%（軽減）",
        taxRateExempt: "不明",
        paymentMethod: "支払方法",
        currency: "通貨",
        registrationNumber: "登録番号",
        taxSummary: "税額サマリー",
        suggestedAccount: "会計候補",
        accountHint: "勘定科目",
        cardLastFour: "カード下4桁",
        lineItemsEmpty: "明細は検出されませんでした。",
        lineItemsTotal: "合計 {count} 行",
        confidence: "信頼度 {value}%",
        source: "ソース: {value}",
        moreCandidates: "他 {count} 件",
        locate: "位置表示",
        lowConfidence: "低信頼フィールド：{fields}",
      },
      taxBreakdown: {
        title: "税率内訳",
        amount: "金額",
        taxAmount: "税額",
        addRow: "行を追加",
        removeRow: "行を削除",
        empty: "税率内訳がありません。必要に応じて追加してください。",
        exceedsTotal: "税率内訳の合計（金額＋税額）は伝票合計を超えられません。",
      },
      voucherSplit: {
        open: "伝票分割",
        edit: "分割を編集",
        detailsTitle: "分割明細",
        dialogTitle: "伝票分割",
        dialogDescription: "税込金額・税率・勘定科目を行ごとに指定します。合計は伝票合計と一致させてください。",
        amount: "税込金額",
        addRow: "行を追加",
        removeRow: "行を削除",
        save: "分割を保存",
        clear: "分割を取り消す",
        totalHint: "伝票合計 {total} / 分割合計 {sum}",
        sumMismatch: "分割した税込金額の合計が伝票合計と一致しません。",
        incomplete: "各行に金額、税率、勘定科目を入力してください。",
        amendmentRequired: "会計処理が完了しているため、分割を変更できません。",
        readonlyEmpty: "税率内訳はありません。",
      },
      paymentMethod: {
        CASH: "現金",
        CREDIT_CARD: "クレジットカード",
        DEBIT_CARD: "デビットカード",
        BANK_TRANSFER: "振込",
        QR_PAYMENT: "QR決済",
        ELECTRONIC_MONEY: "電子マネー",
        POINT: "ポイント",
        UNKNOWN: "不明",
        OTHER: "その他",
      },
      sections: {
        basic: "基本情報",
        amountTax: "金額・税",
        paymentAccounting: "支払・勘定科目",
        lineItems: "明細（読み取り専用）",
      },
      foreignCurrency: {
        notice: "海外伝票です。円の金額を入力してください。カードまたは銀行の円建決済額を優先してください。",
        faceAmount: "票面: {amount}",
      },
      overlay: {
        noImage: "表示できる画像がありません。",
      },
      actions: {
        save: "保存",
        saveTemporary: "一時保存",
        saving: "保存中…",
        approve: "承認する",
        approving: "承認中…",
        correct: "訂正する",
        correcting: "訂正中…",
        confirm: "セグメント確定",
        confirming: "確定中…",
        reject: "却下",
        exclude: "除外",
        reprocess: "再処理",
      },
      reprocess: {
        title: "再処理",
        description:
          "範囲を選択してください。再 OCR は外部費用が発生する場合があります。",
        descriptionFullOnly:
          "書類を最初から再処理します。既存の抽出結果は新しい処理結果に置き換わります。",
        reExtract: "再抽出のみ",
        reOcr: "再 OCR",
        full: "完全再処理",
      },
      reject: {
        title: "セグメント却下",
        description: "このセグメントは却下され、会計対象外になります。",
        commentPlaceholder: "任意コメント",
      },
      exclude: {
        title: "セグメント除外",
        description: "手動で会計結果から除外します。",
        commentPlaceholder: "任意コメント",
      },
      errors: {
        multipleSegments: "複数セグメントは個別に確認してください。",
        amendmentRequired: "ブリッジ済みまたは計上済みのため修正が必要です。",
        reviewAlreadyConfirmed:
          "確認済みです。再処理前にレビューを再開してください。",
        segmentEditForbidden: "セグメント境界の編集権限がありません。",
        confirmedReopenRequired: "確認済みセグメントは再開後に編集できます。",
        segmentCrossPageMerge: "ページをまたぐマージはできません。",
        bboxOverlap: "セグメント境界の重なりが大きすぎます。",
        operationNoChange: "境界に変更がないため送信できません。",
        operationRunning: "別のセグメント操作が処理中です。",
        reopenForbidden: "レビュー再開の権限がありません。",
        generic: "操作に失敗しました。再度お試しください。",
      },
    },
    unassigned: {
      title: "未割当キュー",
      subtitle: "所有区分が未割当の書類を割り当てます",
      noPermission: "書類の割当権限がありません。",
      emptyTitle: "未割当の書類はありません",
      emptyDescription: "すべての書類に所有区分が割り当て済みです。",
    },
    retention: {
      title: "保管ステータス",
      description: "書類の保管・削除ポリシーの現在状態です。",
      status: "受付ステータス",
      fileStatus: "原本ファイル",
      uploadedAt: "アップロード日時",
      scanStatus: "セキュリティスキャン",
      lockedNotice:
        "この書類は保管ロックまたはリーガルホールド中のため、削除できません。",
    },
    filters: {
      status: "処理状態",
      documentDate: "取引日",
      keyword: "キーワード",
      keywordPlaceholder: "取引先・摘要",
      account: "勘定科目",
      taxRate: "税率",
      invoicePresence: "インボイス",
      invoicePresent: "あり",
      invoiceAbsent: "なし",
      allInvoicePresence: "すべて",
      amount: "金額",
      amountMinPlaceholder: "下限",
      amountMaxPlaceholder: "上限",
      allAccounts: "すべての科目",
      allTaxRates: "すべての税率",
      all: "すべて",
      apply: "検索",
      reset: "リセット",
    },
    fields: {
      documentType: "書類種別",
      documentDate: "取引日",
      counterparty: "取引先",
      amount: "金額",
    },
    table: {
      file: "ファイル",
      status: "ステータス",
      source: "受付経路",
      uploader: "アップロード者",
      ownership: "所有区分",
      type: "種別",
      date: "取引日",
      amount: "金額",
      review: "確認",
      actions: "操作",
    },
    documentType: {
      RECEIPT: "領収書",
      INVOICE: "請求書",
      REQUEST_FOR_PAYMENT: "支払依頼",
      OTHER: "その他",
      UNKNOWN: "不明",
    },
    status: {
      UPLOADED: "アップロード済み",
      SECURITY_SCANNING: "スキャン中",
      SECURITY_REJECTED: "スキャン拒否",
      STORED: "保管済み",
      OCR_QUEUED: "OCR 待ち",
      OCR_PROCESSING: "OCR 処理中",
      OCR_COMPLETED: "OCR 完了",
      AI_EXTRACTION_QUEUED: "候補生成待ち",
      AI_EXTRACTING: "候補生成中",
      PROCESSING_FAILED: "処理失敗",
      PROCESSING_CANCELLED: "取消済み",
      QUEUED_FOR_PARSING: "解析待ち",
      PARSING: "解析中",
      PARSED: "解析完了",
      NEEDS_REVIEW: "確認が必要",
      APPROVED: "承認済み",
      REJECTED: "却下",
      DUPLICATE: "重複",
      PARSING_FAILED: "解析失敗",
      ARCHIVED: "アーカイブ",
      UNKNOWN: "不明",
    },
    reviewStatus: {
      PENDING: "確認待ち",
      IN_REVIEW: "確認中",
      APPROVED: "承認済み",
      REJECTED: "却下",
      DUPLICATE: "重複",
      REPARSE_REQUESTED: "再解析依頼",
    },
    ownershipStatus: {
      UNASSIGNED: "未割当",
      AUTO_ASSIGNED: "自動割当",
      ASSIGNED: "割当済み",
    },
    retentionStatus: {
      ACTIVE: "有効",
      RETENTION_LOCKED: "保管ロック",
      DELETION_REQUESTED: "削除申請中",
      LEGAL_HOLD: "リーガルホールド",
      PURGED: "削除済み",
    },
    ownership: {
      personal: "個人",
      soleProprietor: "個人事業主",
      corporation: "法人",
      client: "顧問先",
      unassigned: "未割当",
    },
    usage: {
      PERSONAL_USE: "個人利用",
      BUSINESS_USE: "事業利用",
      MIXED_USE: "家事按分",
      UNKNOWN: "不明",
    },
    suggestion: {
      title: "分類・勘定科目候補",
      usage: "利用区分",
      accountCandidate: "勘定科目候補",
      accountCode: "勘定科目コード",
      businessUseRatio: "事業利用割合（%）",
    },
    duplicate: {
      probable: "重複の可能性",
      viewCandidate: "重複候補の書類を表示",
      previewTitle: "重複候補の書類",
      previewDescription: "重複の可能性がある既存書類の内容を確認できます。",
    },
    duplicates: {
      button: "重複の伝票（{count}件）",
      title: "重複の伝票",
      subtitle: "同一ファイル、または取引先・取引日・税込金額が一致する書類です。",
      candidate: "候補",
      duplicate: "重複",
      missingCandidate: "候補の書類は削除済みです",
      emptyTitle: "重複の伝票はありません",
      emptyDescription: "同一ファイル、または取引先・取引日・税込金額が一致する書類がここに表示されます。",
      edit: "編集",
      counterparty: "取引先",
      documentDate: "取引日",
      amount: "税込金額",
      loadFailed: "重複の伝票を読み込めませんでした",
      kind: {
        exact: "同一ファイル",
        probable: "重複の可能性",
      },
    },
    source: {
      WEB_UPLOAD: "Web アップロード",
      LINE_OFFICIAL_ACCOUNT: "LINE",
    },
    actions: {
      review: "確認",
      approve: "承認",
      correctAndApprove: "修正して承認",
      reparse: "再解析",
      reject: "却下",
    },
    delete: {
      action: "削除",
      deleting: "削除中...",
      confirmTitle: "この書類を削除しますか？",
      confirmDescription:
        "「{name}」と原本ファイルを削除します。この操作は元に戻せません。",
      confirmAction: "削除",
      failed: "削除に失敗しました。",
      linkedToAccounting: "この書類は既に仕訳計上済みのため、削除できません。",
      notAllowed: "現在の状態ではこの書類を削除できません。",
      retentionLocked: "この書類は保存ロック中のため、削除できません。",
      legalHold: "この書類はリーガルホールド中のため、削除できません。",
    },
    loading: "読み込み中...",
    reviewMeta: {
      source: "取込チャネル",
      receivedAt: "受信日時",
      uploader: "アップロード者",
      documentStatus: "処理状態",
    },
    readonlyPreview: {
      title: "伝票プレビュー",
      description: "照合中の伝票を確認します。",
      loadFailed: "伝票を読み込めませんでした。",
    },
  },
  documentAccountingDemoPage: {
    title: "書類会計デモ",
    subtitle:
      "承認済み書類 → 会計ドラフト → 人手による仕訳計上確認 → 仕訳とレポート",
    banner:
      "デモ — 承認済み書類は自動仕訳されません。レビューでドラフト作成後、ドラフト画面で明示的に計上を確認してください。",
    actions: {
      openInbox: "受信箱を開く",
      openUpload: "書類をアップロード",
      continueInInbox: "受信箱で続行",
    },
    scenarios: {
      title: "推奨デモシナリオ",
      hint: "seed スクリプト実行後、受信箱で対応する書類を確認できます。",
      travel: {
        title: "旅費領収書",
        description: "標準的な承認済み領収書。ドラフト作成と計上が可能です。",
      },
      office: {
        title: "事務用品",
        description: "事務用品系の科目マッピングデモ。",
      },
      mixed: {
        title: "按分 (70/30)",
        description: "事業/私用按分のドラフト行デモ。",
      },
      closedYear: {
        title: "締め年度（計上不可）",
        description: "取引日が締め期間内。検証/計上がブロックされる想定です。",
      },
    },
    seed: {
      title: "ローカルシードデータ",
      description: "MySQL/MinIO と backend build が利用可能な環境で実行：",
    },
  },
  documentAccountingDemo: {
    title: "書類会計ドラフト",
    subtitle: "承認済み書類の会計ドラフト編集と仕訳計上確認",
    banner:
      "デモ — 承認済み書類は自動仕訳されません。このページで明示的に確認してください。",
    sections: {
      source: "元書類",
      editor: "ドラフト仕訳",
      status: "ステータス",
      actions: "操作",
    },
    fields: {
      transactionDate: "取引日",
      description: "摘要",
      counterparty: "取引先",
      totalAmount: "合計金額",
      businessAllocation: "事業使用割合",
      account: "勘定科目",
      debit: "借方",
      credit: "貸方",
      amount: "金額",
    },
    status: {
      DRAFT: "下書き",
      READY_TO_POST: "計上可能",
      POSTING: "計上処理中",
      POSTED: "計上済み",
      VOIDED: "取消済み",
      POSTING_FAILED: "計上失敗",
    },
    actions: {
      save: "ドラフトを保存",
      validate: "貸借平衡を検証",
      approve: "承認する",
      confirmPosting: "転記する",
      void: "ドラフトを取消",
      openJournal: "仕訳を表示",
      openLedger: "総勘定元帳を表示",
      openReport: "レポートを表示",
      backToReview: "レビューに戻る",
    },
    confirmApproval: {
      title: "仕訳下書きの承認",
      description:
        "この仕訳下書きを承認します。承認しても、まだ転記は行われません。",
      confirm: "承認する",
      cancel: "キャンセル",
    },
    confirmPosting: {
      title: "仕訳計上の確認",
      description:
        "計上後の仕訳はその場で修正できません。このドラフトを正式に計上しますか？",
      confirm: "転記する",
      cancel: "キャンセル",
    },
    messages: {
      saved: "ドラフトを保存しました",
      validated: "ドラフトの検証が完了しました",
      validationOk: "貸借平衡の検証に成功しました",
      validationFailed: "貸借平衡の検証に失敗しました",
      approved: "仕訳下書きを承認しました",
      voided: "ドラフトを取消しました",
      postingConfirmed: "仕訳計上リクエストを送信しました",
      postingSucceeded: "仕訳計上が完了しました",
      postingFailed: "仕訳計上に失敗しました",
      loadFailed: "ドラフトの読み込みに失敗しました",
      periodClosed: "会計期間が締められているため、計上できません。",
    },
  },
  lineDocumentIntakeDemo: {
    title: "LINE 書類取込デモ",
    subtitle:
      "LINE メッセージ投入のシミュレーション（実 LINE トラフィックなし）",
    banner:
      "デモ / 模擬 LINE イベント — 実 LINE トラフィックはありません。将来の実 LINE adapter は同一 normalized event と Document Intake サービスを再利用します。",
    controls: {
      identity: "デモ LINE ユーザー",
      fixture: "添付サンプル",
      workspaceHint: "任意の対象 Workspace",
      autoWorkspace: "バインドから自動解決",
      send: "模擬イベント送信",
    },
    identities: {
      single: "単一 Workspace ユーザー",
      multiple: "複数 Workspace ユーザー",
      unbound: "未バインドユーザー",
    },
    fixtures: {
      receiptPng: "円建て領収書 (PNG)",
      receiptJpg: "円建て領収書 (JPEG)",
      invoicePdf: "円建て請求書 (PDF)",
      invalidTxt: "無効ファイル (TXT)",
    },
    messages: {
      title: "Inbound メッセージ",
      empty:
        "模擬メッセージはまだありません。ユーザーと添付を選んで送信してください。",
      workspaceSelectionRequired:
        "書類を提出する前に Workspace を選択してください。",
    },
    notifications: {
      title: "最近の通知（ログ）",
    },
    actions: {
      openInbox: "Document Inbox を開く",
      openReview: "Review を開く",
      selectWorkspace: "Workspace を確定",
      retry: "再試行",
    },
    status: {
      RECEIVED: "受信済み",
      RESOLVING_OWNER: "所有者解決中",
      FETCHING_ATTACHMENT: "添付取得中",
      SUBMITTING_DOCUMENT: "書類提出中",
      ACCEPTED: "受理済み",
      NEEDS_WORKSPACE_SELECTION: "Workspace 選択待ち",
      DUPLICATE: "重複",
      FAILED: "失敗",
    },
  },
  errors: {
    unauthorized:
      "セッションの有効期限が切れました。再度ログインしてください。",
    requestFailed:
      "リクエストに失敗しました。しばらくしてから再度お試しください。",
    routeLoadFailed: "ページの読み込みに失敗しました",
    routeLoadFailedDescription:
      "ページ資産が更新されたか、ネットワークが一時的に切断された可能性があります。更新して続行してください。",
    badRequest: "リクエストパラメータが正しくありません。",
    forbidden: "この操作を実行する権限がありません。",
    notFound: "指定されたリソースが見つかりません。",
    unavailable:
      "サービスを一時的に利用できません。しばらくしてから再度お試しください。",
    quotaLimitExceeded:
      "現在のプランの利用枠に達しました。プランをアップグレードするか、管理者にお問い合わせください。",
    quotaUsage: "（使用済み {used} / {limit}）",
    quotaReset: "、{resetAt} にリセットされます",
    quotaAction:
      "。プラン・請求画面でアップグレードするか、管理者にお問い合わせください。",
    subscriptionReadOnly:
      "トライアルまたはサブスクリプションの期限が切れています。既存データの閲覧のみ可能です。文書処理を続けるには更新してください。",
  },
} as const;
